export default {
  "brandSeo": {
    "pageTitle": "{title} avec Miral AI",
    "toolDescription": "Sur Miral AI, {description}",
    "sectionTitle": "{title} avec Miral AI",
    "faqTitle": "{title} sur Miral AI",
    "toolFreeTrialCta": "Essayer cet outil gratuitement sur Miral AI",
    "toolProcessCta": "{action} gratuitement",
    "imageFaqs": [
      { "q": "Puis-je essayer gratuitement la génération d’images sur Miral ?", "a": "Oui. Inscrivez-vous à Miral AI pour recevoir des crédits gratuits et tester la génération. Chaque résultat utilise ensuite les crédits requis par le modèle choisi." },
      { "q": "Pourquoi créer des images avec Miral AI ?", "a": "Miral AI réunit des modèles d’image majeurs au même endroit pour comparer leurs fonctions et créer sans passer d’une plateforme à l’autre." }
    ],
    "toolFaqs": [
      { "q": "Puis-je essayer gratuitement cet outil Miral AI ?", "a": "Oui. Connectez-vous à Miral AI pour commencer un essai gratuit. L’accès dépend des limites du compte et ne signifie pas une utilisation gratuite illimitée." },
      { "q": "Pourquoi utiliser les outils créatifs de Miral AI ?", "a": "Miral AI regroupe génération d’images et outils d’édition pratiques afin de créer, traiter et télécharger les résultats dans un même flux." }
    ]
  },
  "common": {
    "loading": "Chargement...",
    "error": "Une erreur est survenue",
    "success": "Succès",
    "confirm": "OK",
    "prev": "Précédent",
    "next": "Suivant",
    "optional": "Facultatif",
    "remove": "Supprimer",
    "generate": "Générer",
    "generating": "Génération...",
    "required": "Requis",
    "generateFailedContactSupport": "La génération a échoué. Veuillez réessayer ou contacter le support !",
    "localMediaTransferFailed": "Des fluctuations réseau ont interrompu le transfert ou l’échange avec le service. La génération est interrompue. Veuillez relancer la génération ou contacter le support.",
    "errorDetails": "Détails de l'erreur",
    "tryAgainOrContactSupportTail": " Veuillez réessayer ou contacter le support !",
    "errorCategoryImageSizeInvalid": "La taille de l'image ne répond pas aux exigences. Veuillez utiliser une image valide",
    "errorCategoryOutputEmptyOrSensitive": "La génération a été bloquée par les règles de sécurité ou n'a produit aucun résultat. Veuillez ajuster votre invite/image de référence",
    "errorCategoryUpstreamBusy": "Le service est occupé (surcharge côté amont)",
    "errorCategoryAiNetworkError": "Connexion réseau anormale, veuillez vérifier votre réseau puis réessayer",
    "errorCategoryAiTimeout": "La requête AI a expiré. Le réseau peut être instable, veuillez réessayer dans un instant",
    "close": "Fermer",
    "leaveConfirmTitle": "Rappel",
    "leaveConfirmMessage": "Votre création IA est en cours de génération. Changer de page n'affectera pas la progression. Vous pouvez consulter les créations en cours ou terminées dans [Mon compte - Mes créations].\nConfirmez-vous que vous voulez quitter cette page ?",
    "leaveConfirmConfirm": "Quitter la page",
    "leaveConfirmCancel": "Rester ici"
  },
  "api": {
    "errors": {
      "requestFailed": "La requête a échoué",
      "badRequest": "Requête incorrecte",
      "unauthorized": "Non autorisé, veuillez vous reconnecter",
      "forbidden": "Interdit",
      "notFound": "Ressource introuvable",
      "serverError": "Erreur interne du serveur",
      "timeout": "Délai de requête expiré, veuillez réessayer",
      "networkError": "Erreur réseau, veuillez vérifier votre connexion",
      "sessionExpired": "Session expirée, veuillez vous reconnecter",
      "operationFailed": "L'opération a échoué !"
    }
  },
  "nav": {
    "home": "Accueil",
    "models": "Modèles IA",
    "pricing": "Tarifs",
    "faq": "FAQ",
    "login": "Connexion",
    "signup": "Mettre à niveau",
    "register": "S'enregistrer",
    "email": "Email",
    "logout": "Déconnexion",
    "help": "Aide",
    "profile": "Profil",
    "myWorks": "Mes œuvres",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "processing": "Traitement en cours...",
    "haveAccount": "Vous avez déjà un compte ?",
    "noAccount": "Vous n'avez pas de compte ?",
    "orContinueWith": "Ou continuer avec",
    "loginFailed": "Échec de la connexion, veuillez réessayer",
    "registerFailed": "Échec de l'inscription, veuillez réessayer",
    "fillRequired": "Veuillez remplir tous les champs obligatoires",
    "passwordMismatch": "Les mots de passe ne correspondent pas",
    "passwordTooShort": "Le mot de passe doit contenir au moins 6 caractères",
    "googleNotLoaded": "Service de connexion Google non chargé, veuillez actualiser la page",
    "googleInitFailed": "Échec de l'initialisation de la connexion Google",
    "googleUserInfoFailed": "Impossible d'obtenir les informations utilisateur",
    "googleCancelled": "Connexion Google annulée",
    "codeLoginHint": "Entrez votre email, nous vous enverrons un code de vérification",
    "verificationCode": "Code de vérification",
    "sendCode": "Envoyer le code",
    "resendCode": "Renvoyer",
    "verifyAndLogin": "Vérifier et se connecter",
    "enterEmail": "Veuillez entrer votre adresse email",
    "invalidEmail": "Veuillez entrer une adresse email valide",
    "sendCodeFailed": "Échec de l'envoi du code de vérification, veuillez réessayer",
    "checkSpamFolder": "Vous ne trouvez pas l'email ? Vérifiez votre dossier spam/courrier indésirable",
    "enterValidCode": "Veuillez entrer un code de vérification à 6 chiffres",
    "verifyCodeFailed": "Code invalide ou expiré",
    "googleLoginFailed": "Échec de la connexion Google, veuillez réessayer",
    "registerHint": "En vous inscrivant, vous acceptez notre",
    "and": "et",
    "freeCreditsLabel": "Crédits gratuits :",
    "freeCreditsDesc": "Obtenez des crédits gratuits simplement en vous connectant — aucun paiement requis !",
    "sidebar": {
      "navigation": "Navigation",
      "home": "Accueil",
      "inspiration": "Inspiration",
      "history": "Historique",
      "allModels": "Tous les modèles IA",
      "videoAI": "Vidéo IA",
      "videoGenerator": "Générateur vidéo",
      "newModels": "Nouveaux modèles",
      "otherModels": "Autres modèles",
      "videoEnhance": "Amélioration vidéo",
      "musicAI": "Musique IA",
      "musicGenerator": "Musique IA",
      "imageAI": "Image IA",
      "imageGenerator": "Générateur d'image",
      "hotModels": "Modèles populaires",
      "hotTools": "Outils populaires",
      "upgrade": "Mettre à niveau"
    }
  },
  "footer": {
    "brand": "Miral",
    "siteTitle": "Miral - Plateforme de création d'images, vidéos et musique IA",
    "desc": "Une plateforme IA tout-en-un pour la création d'images, vidéos et musiques.",
    "fluxModels": "Modèles FLUX",
    "aiImages": "Images IA",
    "aiVideos": "Vidéos IA",
    "aiMusic": "Musique IA",
    "product": "Produit",
    "videoModels": "Modèles vidéo IA",
    "imageModels": "Modèles d'image IA",
    "musicModels": "Modèles musique IA",
    "apps": "Applications",
    "company": "Entreprise",
    "about": "À propos",
    "contact": "Nous contacter",
    "blog": "Blog",
    "tools": "Outils",
    "resources": "Ressources",
    "allModels": "Tous les modèles IA",
    "pricing": "Tarifs",
    "trustSafety": "Confiance et sécurité",
    "terms": "Conditions d'utilisation",
    "privacy": "Politique de confidentialité",
    "faq": "FAQ",
    "musicGenerator": "Générateur de musique IA",
    "copyright": "© 2025 Miral. Tous droits réservés.",
    "langZh": "简体中文",
    "langEn": "English"
  },
  "about": {
    "tag": "About Miral",
    "title": "About Us",
    "subtitle": "Create images, videos, and music with leading AI models in one place.",
    "paragraphs": [
      "Miral is an AI creation platform for creators, designers, and businesses. Generate images and videos, compose AI music, and use practical tools such as watermark removal and document cleanup.",
      "We continuously integrate leading models and reliable channels so you can go from idea to finished content in the browser.",
      "Learn more about our data practices on Trust & Safety, or contact support when you need help."
    ]
  },
  "contact": {
    "tag": "Support",
    "title": "Contact Us",
    "subtitle": "We will get back to your questions and feedback as soon as we can.",
    "emailLabel": "Support email",
    "hint": "Email us about billing, credits, or generation issues. We usually reply on business days.",
    "cta": "Send Email"
  },
  "models": {
    "image": {
      "nano-banana": {
        "name": "Nano Banana Pro",
        "desc": "Réalisme cinématographique avec des détails naturels de peau, de texture et de lumière"
      },
      "nano-banana-31": {
        "name": "Nano Banana 3.1",
        "desc": "Génération d'images multi-résolution, modes v2.5 et v3.1"
      },
      "seedream-4": {
        "name": "Seedream 4",
        "desc": "Style artistique"
      },
      "seedream-5": {
        "name": "Seedream 5",
        "desc": "Style artistique"
      },
      "midjourney": {
        "name": "Midjourney",
        "desc": "Style artistique"
      },
      "gpt-image-1": {
        "name": "GPT-Image-1",
        "desc": "Usage polyvalent"
      },
      "gpt-image-1-5": {
        "name": "GPT-Image-1-5",
        "desc": "Usage polyvalent"
      },
      "flux-pro-1-1-ultra": {
        "name": "Flux Pro 1.1 Ultra",
        "desc": "Texte vers image haute qualité"
      },
      "flux-schnell": {
        "name": "Flux Schnell",
        "desc": "Texte vers image rapide"
      },
      "flux-2": {
        "name": "FLUX.2",
        "desc": "Texte vers image nouvelle génération"
      },
      "flux-kontext": {
        "name": "Flux Kontext",
        "desc": "Texte vers image & retouche haute qualité"
      },
      "qwen-image-2-0-pro": {
        "name": "Qwen Image 2.0 Pro",
        "desc": "Génération texte-image haute résolution et détails fins"
      },
      "z-image-turbo": {
        "name": "Z Image Turbo",
        "desc": "Génération texte-image haute résolution"
      },
      "sd-3-5": {
        "name": "Stable Diffusion 3.5",
        "desc": "Génération texte-image avec Stable Diffusion 3.5"
      }
    },
    "video": {
      "pollodance": {
        "name": "Pollo Dance",
        "desc": "Contrôle du mouvement, références et styles cinéma"
      },
      "seegen": {
        "name": "SeeGen",
        "desc": "Texte ou image vers vidéo, multi-résolution"
      },
      "seedance": {
        "name": "Seedance IA",
        "desc": "Synchronisation audiovisuelle native"
      },
      "wan-2-5": {
        "name": "Wan 2.5",
        "desc": "Style animation"
      },
      "wan-2-6": {
        "name": "Wan 2.6",
        "desc": "Qualité améliorée"
      },
      "veo-3-1": {
        "name": "Veo 3.1",
        "desc": "Référence multi-image"
      },
      "veo-3-1-fast": {
        "name": "Veo 3.1 Rapide",
        "desc": "Rapide, prend en charge la trame finale"
      },
      "kling-2-6": {
        "name": "Kling 2.6",
        "desc": "Synchro labiale"
      },
      "kling-3": {
        "name": "Kling 3",
        "desc": "Synchro labiale"
      },
      "sora-2": {
        "name": "Sora 2",
        "desc": "4 s / 8 s / 12 s"
      },
      "kling-2-5": {
        "name": "Kling 2.5",
        "desc": "Standard"
      },
      "wan-2-2": {
        "name": "Wan 2.2",
        "desc": "Classique"
      },
      "vidu-q3-pro": {
        "name": "Vidu Q3 Pro",
        "desc": "Texte/image vers vidéo, multi-résolution"
      },
      "veo-3-0": {
        "name": "Veo 3.0",
        "desc": "Texte/Imagé vers vidéo"
      },
      "hailuo-2-3": {
        "name": "Hailuo 2.3",
        "desc": "Vidéo créative"
      },
      "runway": {
        "name": "Runway",
        "desc": "Atelier"
      },
      "wan-animate": {
        "name": "Wan Animate",
        "desc": "Image et vidéo de référence pour animer un personnage. Qualité standard/pro, filigrane optionnel."
      }
    }
  },
  "tools": {
    "demoTitle": "Démo",
    "page": {
      "tag": "Boîte à outils IA",
      "title": "Boîte à outils IA professionnelle",
      "subtitle": "Suppression de filigrane, restauration de photo, mise à l'échelle HD, amélioration vidéo et autres outils professionnels pour tous vos besoins de post-traitement.",
      "allTools": "Tous les outils"
    },
    "detail": {
      "useNow": "Utiliser maintenant",
      "clickUpload": "Cliquez ou glissez-déposez pour télécharger",
      "support": "Supporte",
      "reupload": "Recharger",
      "scale": "Échelle",
      "process": "Traiter",
      "processing": "Traitement en cours...",
      "before": "Avant",
      "after": "Après",
      "download": "Télécharger le résultat",
      "processNew": "Traiter un nouveau fichier",
      "howToUse": "Comment utiliser",
      "moreTools": "Plus d'outils",
      "notFound": "Outil non trouvé",
      "backToList": "Retour aux outils",
      "loginRequired": "Connexion requise",
      "loginRequiredDesc": "Veuillez vous connecter pour utiliser cet outil",
      "loginNow": "Se connecter maintenant",
      "demo": "Démo",
      "uploadOriginalFailed": "Échec du téléchargement de l'image originale, veuillez réessayer"
    },
    "steps": {
      "upload": {
        "title": "Télécharger le fichier",
        "desc": "Sélectionnez ou glissez-déposez le fichier image ou vidéo que vous souhaitez traiter."
      },
      "adjust": {
        "title": "Ajuster les paramètres",
        "desc": "Configurez les paramètres de traitement tels que le facteur d'échelle et le format de sortie."
      },
      "process": {
        "title": "Traitement en un clic",
        "desc": "L'IA traite automatiquement, généralement terminé en quelques secondes à minutes."
      },
      "download": {
        "title": "Télécharger le résultat",
        "desc": "Aperçu du résultat et téléchargement de la sortie haute qualité."
      }
    },
    "fileTypes": {
      "image": "Image",
      "video": "Vidéo"
    },
    "watermarkRemover": {
      "name": "Suppression de filigrane",
      "desc": "Supprimez les filigranes d'image en un clic avec l'IA",
      "fullDesc": "Suppression de filigrane par IA tout en préservant la qualité de l'image. Prend en charge le traitement par lots, la détection automatique de filigrane et la suppression précise sans endommager l'image originale."
    },
    "backgroundRemover": {
      "name": "Suppression d'arrière-plan",
      "desc": "Supprimez l'arriere-plan des images en un clic avec l'IA",
      "fullDesc": "Suppression de l'arrière-plan par IA en un clic. Détecte précisément le contour du sujet, préserve les détails fins comme les cheveux, exporte en image à fond transparent."
    },

    "photoRestore": {
      "name": "Restauration de photo",
      "desc": "Restaurez les vieilles, floues ou endommagées photos avec la technologie IA",
      "fullDesc": "Restaurez les vieilles, floues ou endommagées photos avec la technologie IA. Prend en charge le filtrage du bruit, le nettoyage et le remplissage des parties manquantes pour ramener les précieux souvenirs à la vie."
    },
    "imageEnhancer": {
      "name": "Améliorateur d'image",
      "desc": "Améliorez la netteté des images en un clic avec l'IA",
      "fullDesc": "Mettez à l'échelle les images en résolution 4K avec des détails améliorés. Utilise des algorithmes IA avancés pour améliorer les détails, rendant les images floues nettes et claires."
    },
    "videoEnhancer": {
      "name": "Améliorateur de vidéo",
      "desc": "Mettez à l'échelle les vidéos en résolution 4K avec une clarté améliorée",
      "fullDesc": "Mettez à l'échelle les vidéos en résolution 4K avec une clarté améliorée. Prend en charge plusieurs formats vidéo avec interpolation de trames alimentée par IA pour une qualité HD exceptionnelle."
    },
    "watermark-remover": {
      "name": "Suppression de filigrane",
      "desc": "Suppression de filigrane par IA tout en préservant la qualité de l'image",
      "fullDesc": "Suppression de filigrane par IA tout en préservant la qualité de l'image. Prend en charge le traitement par lots, la détection automatique de filigrane et la suppression précise sans endommager l'image originale.",
      "fileTooLarge": "L'image est trop grande. Veuillez utiliser un fichier de moins de 15 Mo (JPG, PNG ou WebP).",
      "notImageFile": "Veuillez télécharger un fichier image.",
      "noImageInResponse": "Aucune image de résultat n'a été renvoyée. Veuillez réessayer plus tard.",
      "downloadName": "watermark-removed.png",
      "aiRepair": "Suppression du filigrane",
      "uploadLabel": "Télécharger une image",
      "uploadHint": "Prend en charge les images JPG, PNG ou WebP jusqu'à 15 Mo.",
      "featuresKicker": "Rapide et précis",
      "featuresTitle": "Supprimer différents filigranes des photos en ligne",
      "featuresIntro": "Téléchargez une image JPG, PNG ou WebP et laissez l'IA détecter les zones de filigrane et reconstruire l'arrière-plan sans brossage manuel.",
      "features": [
        {
          "title": "Effacer les filigranes d’image complète",
          "desc": "Supprimez les textes translucides répétés ou les filigranes de motifs qui couvrent toute l’image pour un résultat plus propre.",
          "cta": "Essayez AI Watermark Remover gratuitement"
        },
        {
          "title": "Supprimer les horodatages et les marques de date",
          "desc": "Nettoyez les dates, les horodatages et les marques de l'appareil photo des coins des photos tout en reconstruisant l'arrière-plan derrière eux.",
          "cta": "Effacer les filigranes d’images en ligne"
        },
        {
          "title": "Effacer les logos de marque",
          "desc": "Supprimez les logos de marque, les badges de coin et les marques promotionnelles des images que vous êtes autorisé à modifier.",
          "cta": "Supprimer les filigranes de photos maintenant"
        },
        {
          "title": "Nettoyer le texte et les brouillons",
          "desc": "Supprimez les superpositions de texte des aperçus, des brouillons de conception et des photos pour créer un contenu visuel plus propre.",
          "cta": "Essayez le dissolvant de filigrane maintenant"
        }
      ],
      "useCasesKicker": "Cas d'utilisation",
      "useCasesTitle": "Que peut nettoyer le dissolvant de filigrane d'image AI ?",
      "audienceLabels": [
        "Vendeurs de commerce électronique",
        "Équipes marketing",
        "Concepteurs et créateurs",
        "Magasins de mode et de vêtements"
      ],
      "audienceCases": [
        {
          "title": "Préparez les visuels des produits 3 fois plus rapidement",
          "desc": "Avant de créer des images de liste de produits soignées, nettoyez d'abord les photos de produits autorisées, les images de fournisseurs ou les brouillons d'actifs. Supprimez les marques gênantes afin que les acheteurs puissent se concentrer sur le produit."
        },
        {
          "title": "Réduisez le nettoyage manuel de 60 % et créez des éléments de campagne plus rapidement",
          "desc": "Avant de transformer des visuels détenus ou sous licence en publicités, bannières et graphiques de marque, supprimez les filigranes indésirables. Les actifs propres peuvent être intégrés plus rapidement dans les promotions de campagnes, les lancements de produits et les affiches de produits."
        },
        {
          "title": "Transformez plus rapidement des images épurées en nouveaux concepts créatifs",
          "desc": "Commencez avec des images sources plus propres pour explorer de nouvelles orientations de conception sans reconstruire à partir de zéro. Utilisez des brouillons nettoyés comme références pour les croquis d’IA, les illustrations conceptuelles ou les visuels de style affiche."
        },
        {
          "title": "Actualiser les images du catalogue de produits sans nouvelle prise de vue",
          "desc": "Avant de préparer des mises à jour de catalogue, des lancements saisonniers ou des visuels d'essais virtuels IA, nettoyez les photos de vêtements autorisées afin que les acheteurs puissent se concentrer sur la coupe, le tissu et les détails du produit."
        }
      ],
      "useCases": [
        {
          "title": "Suppression des filigranes pour les photos de produits",
          "desc": "Nettoyez le texte, les logos et les marques promotionnelles des photos de produits avant de diffuser vos propres ressources."
        },
        {
          "title": "Suppression des filigranes pour les photos sociales",
          "desc": "Supprimez les marques de plate-forme ou les horodatages de vos propres photos pour une version de publication plus propre."
        },
        {
          "title": "Nettoyer plusieurs filigranes",
          "desc": "Lorsqu'une image contient plusieurs filigranes, l'IA peut détecter et nettoyer plusieurs zones couvertes."
        }
      ],
      "howToKicker": "Trois étapes simples",
      "howToTitle": "Comment supprimer gratuitement les filigranes des images en ligne",
      "howToIntro": "Aucune installation de logiciel n'est nécessaire. Téléchargez une image, exécutez le outil de suppression de filigrane AI et téléchargez le résultat nettoyé.",
      "howToCta": "Supprimer les filigranes en ligne maintenant",
      "steps": {
        "upload": {
          "title": "Télécharger une image filigranée",
          "desc": "Choisissez une image JPG, PNG ou WebP de moins de 15 Mo. Assurez-vous que vous avez le droit de le modifier et de l’utiliser."
        },
        "remove": {
          "title": "Supprimez le filigrane avec l'IA",
          "desc": "Démarrez le traitement et l'IA détectera les logos, le texte, les horodatages ou les filigranes d'image complète et reconstruira l'arrière-plan."
        },
        "download": {
          "title": "Aperçu et téléchargement",
          "desc": "Comparez les résultats avant et après, puis téléchargez l'image nettoyée ou téléchargez-en une autre."
        }
      },
      "faqTitle": "FAQ sur la suppression des filigranes AI",
      "faqs": [
        {
          "q": "Qu'est-ce qu'un outil de suppression de filigrane IA ?",
          "a": "Un outil de suppression de filigrane IA détecte les zones de filigrane et reconstruit les arrière-plans couverts en utilisant les couleurs, les textures et le contenu de l'image à proximité."
        },
        {
          "q": "Comment supprimer gratuitement les filigranes des photos en ligne ?",
          "a": "Inscrivez-vous, téléchargez une image sur le outil de suppression de filigrane Miral AI et lancez le traitement pour prévisualiser le résultat nettoyé."
        },
        {
          "q": "Quels formats d'images sont pris en charge ?",
          "a": "L'outil prend actuellement en charge les images JPG, PNG et WebP de moins de 15 Mo. Cette page ne supprime pas les filigranes des vidéos."
        },
        {
          "q": "Peut-il supprimer les filigranes, les logos et les horodatages d’images complètes ?",
          "a": "Oui. L'IA peut traiter des filigranes d'image complète répétés, des logos de marque, des tampons de date, du texte et des brouillons. Les résultats dépendent de l'opacité, de la zone couverte et de la complexité de l'arrière-plan."
        },
        {
          "q": "Quel outil puis-je utiliser pour supprimer plusieurs logos ou horodatages d’une même photo ?",
          "a": "Le outil de suppression de filigrane Miral AI peut traiter plusieurs zones de filigrane, y compris les logos et les horodatages. Vérifiez l'aperçu lorsque de grandes marques couvrent des personnes ou des textures complexes."
        },
        {
          "q": "La suppression d’un filigrane sur une image est-elle légale ?",
          "a": "Ne traitez que les images que vous possédez, que vous êtes autorisé à modifier ou que vous pouvez légalement utiliser. La suppression des filigranes de droits d'auteur sans autorisation peut porter atteinte aux droits du propriétaire."
        },
        {
          "q": "Comment corriger les zones floues après avoir supprimé un filigrane ?",
          "a": "Commencez avec l’image source de la plus haute qualité disponible et vérifiez l’aperçu avant de télécharger. L'IA tente de préserver la composition, la résolution et les détails d'origine, mais le contenu masqué par de grands filigranes doit être reconstruit, de sorte que les résultats locaux peuvent différer de l'original."
        }
      ]
    },
    "full-watermark-remover": {
      "name": "Suppression de filigrane IA",
      "desc": "Supprimez les filigranes des images avec l'IA",
      "fullDesc": "Utilisez l'IA pour détecter et supprimer les filigranes des images tout en préservant le contenu, les détails et la qualité visuelle.",
      "audienceLabels": ["Vendeurs e-commerce", "Équipes marketing", "Designers et créateurs", "Boutiques de mode"],
      "audienceCases": [
        { "title": "Préparez vos visuels produits 3 fois plus vite", "desc": "Avant de créer des images de fiches produit soignées, nettoyez les photos produit, images fournisseurs ou brouillons que vous êtes autorisé à utiliser. Supprimez les marques gênantes pour recentrer l'attention sur le produit." },
        { "title": "Réduisez le nettoyage manuel de 60 % et créez plus vite vos campagnes", "desc": "Avant de transformer vos visuels détenus ou sous licence en publicités, bannières et créations de marque, supprimez les filigranes indésirables. Les ressources propres passent plus vite aux campagnes, lancements et affiches produit." },
        { "title": "Transformez plus vite des images propres en nouveaux concepts", "desc": "Explorez de nouvelles pistes créatives à partir d'images sources nettoyées, sans tout reconstruire. Utilisez les brouillons sans filigrane comme références pour des croquis IA, du concept art ou des visuels d'affiche." },
        { "title": "Actualisez vos catalogues sans nouvelle séance photo", "desc": "Avant de préparer un catalogue, une collection saisonnière ou des visuels d'essayage virtuel IA, nettoyez les photos de vêtements autorisées afin de mettre en valeur la coupe, le tissu et les détails du produit." }
      ],
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "downloadName": "filigrane-plein-ecran-supprime.png"
    },
    "ai-text-remover": {
      "name": "Suppression de texte IA",
      "desc": "Supprimez le texte indésirable des images avec l'IA",
      "fullDesc": "Supprimez le texte indésirable des images avec l'IA tout en préservant l'arrière-plan, les textures et les détails naturels.",
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "downloadName": "texte-supprime.png"
    },
    "ai-logo-remover": {
      "name": "Suppression de logo IA",
      "desc": "Supprimez les logos indésirables des images avec l'IA",
      "fullDesc": "Supprimez les logos indésirables des images avec l'IA tout en préservant l'arrière-plan, les textures et les détails naturels.",
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "downloadName": "logo-supprime.png"
    },
    "ai-passersby-remover": {
      "name": "Suppression de passants IA",
      "desc": "Supprimez les passants des images avec l'IA",
      "fullDesc": "Utilisez l'IA pour détecter et supprimer les passants des images tout en préservant le sujet, la texture de l'arrière-plan et les détails naturels.",
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "downloadName": "passants-supprimes.png"
    },
    "background-remover": {
      "name": "Suppression d'arrière-plan",
      "desc": "Suppression de l'arrière-plan par IA en un clic, conserve le sujet",
      "heroTitle": "Suppresseur d'arrière-plan IA gratuit pour PNG transparents",
      "fullDesc": "Importez une image JPG, PNG ou WebP : l'IA détecte automatiquement portraits, produits et contours. Préservez les cheveux et les détails fins, puis téléchargez un PNG transparent sans Photoshop.",
      "uploadLabel": "Importer une image à détourer",
      "uploadHint": "Cliquez ou glissez une image ici",
      "uploadSpec": "JPG, PNG ou WebP jusqu'à 15 Mo. Le résultat est téléchargé en PNG transparent.",
      "processButton": "Supprimer l'arrière-plan",
      "previewAlt": "Aperçu avant suppression de l'arrière-plan par IA",
      "demoBeforeAlt": "Portrait avant suppression de l'arrière-plan",
      "demoAfterAlt": "Portrait après suppression de l'arrière-plan par IA",
      "processingAlt": "L'IA supprime l'arrière-plan de l'image",
      "processingLabel": "Détourage en cours",
      "resultLabel": "Fond transparent prêt",
      "resultBeforeAlt": "Image originale avant suppression du fond",
      "resultAfterAlt": "PNG transparent après suppression du fond par IA",
      "productBeforeAlt": "Photo produit avant suppression du fond",
      "productAfterAlt": "Produit détouré sur fond transparent",
      "featuresKicker": "Détection précise du sujet",
      "featuresTitle": "Suppresseur d'arrière-plan IA pour portraits et photos de produits",
      "featuresIntro": "Des contours complexes d'un portrait aux visuels e-commerce, l'IA sépare automatiquement le sujet sans pinceau, tracé ni masque manuel.",
      "features": [
        { "title": "Détourer un portrait en conservant les cheveux", "desc": "Détectez personnes, vêtements et mèches fines pour obtenir des portraits, photos de profil, affiches et visuels sociaux plus propres.", "cta": "Détourer un portrait gratuitement" },
        { "title": "Détourer une photo produit en un clic", "desc": "Retirez table, mur et décor de studio pour créer des éléments transparents destinés aux fiches produits, fonds blancs et publicités.", "cta": "Supprimer le fond d'un produit" },
        { "title": "Télécharger un PNG transparent", "desc": "Conservez la transparence pour placer le sujet sur un nouveau fond, une bannière, une présentation ou une création graphique.", "cta": "Rendre le fond transparent" }
      ],
      "featureAlts": { "portraitBefore": "Portrait avant détourage", "portraitAfter": "Portrait détouré avec cheveux préservés", "productBefore": "Produit avant suppression du fond", "productAfter": "Produit détouré sur fond transparent", "ecommerceBefore": "Image e-commerce avant détourage", "ecommerceAfter": "PNG transparent pour produit e-commerce" },
      "useCasesKicker": "Cas d'usage populaires",
      "useCasesTitle": "Quelles images détourer avec l'IA en un clic ?",
      "useCasesIntro": "Idéal lorsqu'il faut isoler rapidement un sujet ou créer un élément transparent pour un projet créatif ou commercial.",
      "useCases": [
        { "title": "Photos produits e-commerce", "desc": "Créez des éléments produits transparents pour catalogues, boutiques et campagnes." },
        { "title": "Portraits et photos de profil", "desc": "Retirez le décor tout en préservant cheveux, vêtements et contours." },
        { "title": "Visuels pour réseaux sociaux", "desc": "Placez personnes ou produits dans couvertures, publications et miniatures." },
        { "title": "Portraits professionnels", "desc": "Isolez la personne puis ajoutez la couleur de fond nécessaire." },
        { "title": "Logos et éléments graphiques", "desc": "Supprimez un fond indésirable avant réutilisation sur le Web ou une affiche." },
        { "title": "Publicité et design graphique", "desc": "Préparez rapidement des PNG transparents faciles à composer." }
      ],
      "howToKicker": "Trois étapes simples",
      "howToTitle": "Comment supprimer gratuitement le fond d'une image en ligne",
      "howToIntro": "Importez une image, lancez le détourage automatique par IA, puis téléchargez le PNG transparent.",
      "steps": [
        { "title": "Importer un JPG, PNG ou WebP", "desc": "Choisissez un portrait, produit ou visuel net de moins de 15 Mo." },
        { "title": "Supprimer le fond avec l'IA", "desc": "L'IA sépare le sujet en conservant les contours importants." },
        { "title": "Prévisualiser et télécharger le PNG", "desc": "Comparez le résultat et enregistrez l'image transparente." }
      ],
      "faqTitle": "FAQ sur la suppression d'arrière-plan par IA",
      "faqs": [
        { "q": "Comment supprimer gratuitement un arrière-plan en ligne ?", "a": "Importez un JPG, PNG ou WebP puis lancez la suppression. L'IA détecte le sujet et génère un PNG transparent." },
        { "q": "L'IA peut-elle préserver les cheveux et les contours fins ?", "a": "L'outil tente de conserver cheveux, vêtements et petits détails. Un bon contraste entre sujet et fond améliore généralement le résultat." },
        { "q": "Puis-je retirer le fond d'une photo produit ?", "a": "Oui. Les produits clairement visibles conviennent aux visuels transparents pour l'e-commerce et la publicité." },
        { "q": "Quel format obtient-on après traitement ?", "a": "Le résultat est téléchargé en PNG avec transparence." },
        { "q": "Quels formats et tailles sont acceptés ?", "a": "JPG, PNG et WebP sont acceptés jusqu'à 15 Mo." },
        { "q": "Dois-je installer Photoshop ?", "a": "Non. L'IA supprime automatiquement le fond directement dans le navigateur." }
      ],
      "fileTooLarge": "Image trop volumineuse. Utilisez un fichier de moins de 15 Mo (JPG, PNG ou WebP).",
      "notImageFile": "Veuillez télécharger un fichier image.",
      "noImageInResponse": "Aucune image de résultat retournée. Veuillez réessayer plus tard.",
      "downloadName": "sans-arriere-plan.png"
    },
    "image-eraser": {
      "name": "Gomme d'image IA",
      "desc": "Effacez n'importe quel objet, personne ou filigrane de vos images avec l'IA",
      "fullDesc": "Gomme d'image propulsée par l'IA. Brossez sur tout objet, personne, filigrane ou texte indésirable dans votre photo et l'IA le supprimera de manière transparente en remplissant la zone avec un contenu naturel. Idéal pour nettoyer vos photos et éliminer les éléments gênants.",
      "fileTooLarge": "Image trop volumineuse. Utilisez un fichier de moins de 15 Mo (JPG, PNG ou WebP).",
      "notImageFile": "Veuillez télécharger un fichier image.",
      "noImageInResponse": "Aucune image de résultat retournée. Veuillez réessayer plus tard.",
      "downloadName": "image-erased.png"
    },
    "object-remover": {
      "name": "Suppression d'objet",
      "desc": "Supprimez les objets indésirables de vos photos avec l'IA",
      "fullDesc": "Outil de suppression d'objet propulsé par l'IA. Brossez sur tout objet indésirable dans votre photo et l'IA le supprimera de manière transparente en remplissant la zone avec un contenu naturel. Idéal pour nettoyer vos photos et éliminer les éléments gênants.",
      "fileTooLarge": "Image trop volumineuse. Utilisez un fichier de moins de 15 Mo (JPG, PNG ou WebP).",
      "notImageFile": "Veuillez télécharger un fichier image.",
      "noImageInResponse": "Aucune image de résultat retournée. Veuillez réessayer plus tard.",
      "downloadName": "object-removed.png",
      "uploadLabel": "Télécharger une image",
      "uploadHint": "Cliquez ou faites glisser pour télécharger une image",
      "uploadSpec": "Prend en charge les images JPG, PNG ou WebP.",
      "maskHint": "Passez votre pinceau sur chaque partie de l'objet que vous souhaitez que l'IA supprime.",
      "processButton": "Supprimer l'objet",
      "demoBeforeAlt": "Photo avant la suppression des objets indésirables",
      "demoAfterAlt": "Photo après suppression d'un objet indésirable",
      "processingAlt": "L'IA traite la photo marquée",
      "resultBeforeAlt": "Photo originale avant retrait de l'objet",
      "resultAfterAlt": "Nettoyer la photo après la suppression de l'objet",
      "featureImageLabels": {
        "object": "exemple de suppression d'objets indésirables",
        "person": "exemple de suppression de personne",
        "distraction": "exemple de suppression de distraction en arrière-plan"
      },
      "featuresKicker": "Nettoyage précis des photos",
      "featuresTitle": "Supprimer les objets indésirables des photos en ligne",
      "featuresIntro": "Marquez la zone exacte que vous souhaitez nettoyer et utilisez la suppression des objets IA pour les distractions photo quotidiennes sans reconstruire manuellement l'arrière-plan.",
      "features": [
        {
          "title": "Éliminez les objets indésirables",
          "desc": "Utilisez une brosse réglable pour marquer l'encombrement, les panneaux, les accessoires ou d'autres objets. L'IA supprime la zone sélectionnée et la remplit avec les détails de l'image environnante.",
          "cta": "Supprimer des objets gratuitement"
        },
        {
          "title": "Supprimer des personnes des arrière-plans de photos",
          "desc": "Éliminez les photobombers, les touristes ou les passants des photos de voyage et des portraits lorsqu'ils détournent l'attention du sujet principal.",
          "cta": "Nettoyer les arrière-plans photo gratuits"
        },
        {
          "title": "Effacer les petites distractions en arrière-plan",
          "desc": "Supprimez les fils, les poubelles, l'encombrement de la rue, les marques ou les distractions visuelles isolées pour créer une composition plus propre.",
          "cta": "Effacer les distractions photo gratuitement"
        }
      ],
      "useCasesKicker": "Cas d'utilisation populaires",
      "useCasesTitle": "Que pouvez-vous supprimer avec AI Object Remover ?",
      "useCasesIntro": "Conçu pour des retouches ciblées où vous pouvez clairement brosser la zone indésirable et conserver le reste de la photo inchangé.",
      "useCases": [
        {
          "title": "Nettoyage de photos de voyage",
          "desc": "Supprimez les passants, les panneaux, les poubelles ou l'encombrement de la rue des photos de vacances."
        },
        {
          "title": "Nettoyage des photos de produits",
          "desc": "Effacez les accessoires, les étiquettes, les câbles et les éléments gênants autour d'un produit."
        },
        {
          "title": "Nettoyage de l'arrière-plan du portrait",
          "desc": "Supprimez les personnes en arrière-plan et les petits objets qui détournent l’attention du sujet."
        },
        {
          "title": "Immobilier Photos",
          "desc": "Nettoyez l'encombrement temporaire et les objets isolés des images de pièces ou de propriétés."
        },
        {
          "title": "Images de médias sociaux",
          "desc": "Polissez les photos avant de les publier en supprimant les distractions visibles du cadre."
        },
        {
          "title": "Retouche photo créative",
          "desc": "Effacez les zones sélectionnées avant de réutiliser une image dans une mise en page ou un projet visuel."
        }
      ],
      "howToKicker": "Trois étapes simples",
      "howToTitle": "Comment supprimer un objet d'une photo en ligne",
      "howToIntro": "Téléchargez une photo, passez le pinceau sur l'objet indésirable et téléchargez le résultat nettoyé par l'IA.",
      "steps": [
        {
          "title": "Téléchargez votre photo",
          "desc": "Choisissez l'image qui contient la personne, l'élément ou la distraction que vous souhaitez effacer."
        },
        {
          "title": "Brossez l'objet",
          "desc": "Ajustez la brosse et couvrez toute la zone indésirable. Utilisez Annuler ou la gomme pour affiner le masque."
        },
        {
          "title": "Supprimer et télécharger",
          "desc": "Démarrez le traitement AI, comparez les images avant et après, puis téléchargez la photo nettoyée."
        }
      ],
      "faqTitle": "FAQ sur la suppression d'objets AI",
      "faqs": [
        {
          "q": "Comment supprimer les objets indésirables des photos en ligne ?",
          "a": "Téléchargez une photo, balayez tout l'objet indésirable et lancez le traitement. L'IA reconstruit la zone sélectionnée en utilisant les couleurs, les textures et les détails de la scène à proximité."
        },
        {
          "q": "Quel outil puis-je utiliser pour supprimer une personne d’un arrière-plan photo ?",
          "a": "Utilisez le pinceau pour couvrir la personne et inclure des détails tels que des ombres ou des objets transportés. Les résultats sont généralement meilleurs lorsque l’arrière-plan environnant est visible."
        },
        {
          "q": "L’IA peut-elle supprimer les panneaux, les câbles, les poubelles et l’encombrement des rues ?",
          "a": "Oui. Marquez clairement la zone indésirable et évitez de couvrir les sujets proches que vous souhaitez conserver. Les petites distractions isolées sont généralement plus faciles à reconstruire."
        },
        {
          "q": "Comment puis-je obtenir un résultat de suppression d'objet plus naturel ?",
          "a": "Utilisez une image source claire et de haute qualité et appliquez légèrement au-delà des bords de l'objet. Traitez les zones difficiles séparément lorsque plusieurs objets se chevauchent."
        },
        {
          "q": "Le outil de suppression d'objets modifie-t-il toute la photo ?",
          "a": "La demande de suppression est basée sur le masque brossé. L'outil se concentre sur la zone sélectionnée, même si l'IA doit reconstruire les pixels autour de ses bords."
        },
        {
          "q": "Quels formats d'images puis-je télécharger ?",
          "a": "Le contrôle de téléchargement accepte les formats d'image courants, notamment JPG, PNG et WebP."
        }
      ]
    },
    "ai-person-remover": {
      "name": "Suppression de personnes par IA",
      "desc": "Supprimez les personnes de vos photos avec l'IA",
      "fullDesc": "Outil de suppression de personne propulsé par l'IA. Brossez sur n'importe quelle personne dans votre photo et l'IA la supprimera de manière transparente en remplissant la zone avec un contenu naturel. Idéal pour supprimer les passants, touristes ou inconnus de vos clichés.",
      "fileTooLarge": "Image trop volumineuse. Utilisez un fichier de moins de 15 Mo (JPG, PNG ou WebP).",
      "notImageFile": "Veuillez télécharger un fichier image.",
      "noImageInResponse": "Aucune image de résultat retournée. Veuillez réessayer plus tard.",
      "downloadName": "person-removed.png"
    },
    "background-blur": {
      "name": "Flou d'arrière-plan",
      "desc": "Flouter l'arrière-plan avec l'IA en un clic pour mettre le sujet en valeur",
      "fullDesc": "L'IA détecte automatiquement le sujet au premier plan (personne/objet), garde le sujet net et applique un flou gaussique à l'arrière-plan pour un effet type Portrait Mode. Idéal pour portraits et gros plans produit.",
      "fileTooLarge": "Image trop volumineuse. Utilisez un fichier de moins de 15 Mo (JPG, PNG ou WebP).",
      "notImageFile": "Veuillez télécharger un fichier image.",
      "noImageInResponse": "Aucune image de résultat retournée. Veuillez réessayer plus tard.",
      "downloadName": "flou-arriere-plan.png"
    },
    "white-background": {
      "name": "Fond Blanc",
      "desc": "Remplacement de l'arrière-plan par blanc avec l'IA",
      "fullDesc": "Remplacement de l'arrière-plan par blanc avec l'IA en un clic. Détecte précisément le contour du sujet, préserve les détails fins, exporte en image à fond blanc. Idéal pour photos produit et photos d'identité.",
      "fileTooLarge": "Image trop volumineuse. Utilisez un fichier de moins de 15 Mo (JPG, PNG ou WebP).",
      "notImageFile": "Veuillez télécharger un fichier image.",
      "noImageInResponse": "Aucune image de résultat retournée. Veuillez réessayer plus tard.",
      "downloadName": "fond-blanc.png"
    },
    "blue-background": {
      "name": "Fond Bleu",
      "desc": "Remplacement de l'arrière-plan par bleu avec l'IA",
      "fullDesc": "Remplacement de l'arrière-plan par bleu avec l'IA en un clic. Détecte précisément le contour du sujet, préserve les détails fins, exporte en image à fond bleu. Idéal pour photos d'identité et photos de passeport.",
      "fileTooLarge": "Image trop volumineuse. Utilisez un fichier de moins de 15 Mo (JPG, PNG ou WebP).",
      "notImageFile": "Veuillez télécharger un fichier image.",
      "noImageInResponse": "Aucune image de résultat retournée. Veuillez réessayer plus tard.",
      "downloadName": "fond-bleu.png"
    },
    "face-swap": {
      "name": "Échange de visages sur photo",
      "desc": "Échangez les visages sur les photos avec l'IA en un clic",
      "fullDesc": "Échange de visage alimenté par l'IA. Téléchargez une photo cible et une photo de visage source pour fusionner le visage dans l'image cible de manière transparente. Prend en charge les scènes multi-personnes avec des résultats réalistes.",
      "fileTooLarge": "Image trop volumineuse. Utilisez un fichier de moins de 15 Mo (JPG, PNG ou WebP).",
      "notImageFile": "Veuillez télécharger un fichier image.",
      "targetImage": "Photo cible",
      "sourceImage": "Visage source",
      "effectImageLabel": "Résultat",
      "downloadName": "echange-visage-resultat.png",
      "step1Title": "Télécharger des photos",
      "step1Desc": "Téléchargez la photo cible et la photo de visage source",
      "step2Title": "Échange de visage IA",
      "step2Desc": "Cliquez sur traiter, l'IA échange le visage automatiquement",
      "step3Title": "Télécharger",
      "step3Desc": "Prévisualisez et téléchargez le résultat",
      "processButton": "Changer de visage",
      "targetPreviewAlt": "Aperçu de la photo cible pour l'échange de visage AI",
      "sourcePreviewAlt": "Aperçu du visage source pour l'échange de visage AI",
      "processingAlt": "Aperçu du traitement d'échange de visage par l'IA",
      "resultBeforeAlt": "Cibler la photo avant l'échange de visage",
      "resultAfterAlt": "Photo après échange de visage avec l'IA",
      "featuresKicker": "Remplacement naturel du visage",
      "featuresTitle": "Échangez des visages entre les photos avec l'IA",
      "featuresIntro": "Utilisez une photo cible pour la pose et la composition, puis fournissez un visage source clair pour un échange de visage photo ciblé.",
      "features": [
        {
          "title": "Créez un échange de visage d'apparence naturelle",
          "desc": "L'IA mélange l'identité de la source dans la photo cible tout en suivant sa pose, son cadrage, son éclairage et son style visuel global.",
          "cta": "Créer un échange de visage photo gratuitement"
        },
        {
          "title": "Conservez la composition photo cible",
          "desc": "Utilisez un portrait, un selfie, une image de personnage ou une scène créative comme cible tout en conservant son arrière-plan et sa composition.",
          "cta": "Essayez Photo Face Swap gratuitement"
        },
        {
          "title": "Utilisez un visage source clair",
          "desc": "Téléchargez une image source frontale et bien éclairée avec des détails du visage visibles pour aider le modèle à créer un remplacement plus cohérent.",
          "cta": "Téléchargez et échangez gratuitement"
        }
      ],
      "useCasesKicker": "Idées de photos créatives",
      "useCasesTitle": "Utilisations populaires de l'échange de visages de photos en ligne",
      "useCasesIntro": "Créez des retouches photo ludiques et créatives en utilisant une image cible et une image de visage source.",
      "useCases": [
        {
          "title": "Échanges de visages avec selfie et photo de profil",
          "desc": "Remplacez un visage dans un selfie ou un portrait tout en préservant la pose, l'arrière-plan et le cadrage cibles. Explorez les concepts de photo de profil et les idées de portraits personnels avec un visage source clair.",
          "cta": "Créer un échange de visage de portrait gratuitement",
          "imageAlt": "Exemple d'échange de visage AI pour les selfies et les photos de profil"
        },
        {
          "title": "Mèmes et images de réaction sociale",
          "desc": "Transformez des photos familières en mèmes personnalisés, en images de réaction ludiques et en contenu social partageable. Une expression cible claire permet de garder l’image finale facile à reconnaître.",
          "cta": "Créez un échange de visage de mème gratuitement",
          "imageAlt": "Cas d'utilisation de mèmes créatifs et d'images de réaction sociale"
        },
        {
          "title": "Cosplay, personnages et histoires créatives",
          "desc": "Essayez un visage dans un costume, un portrait fantastique, un personnage illustré ou une scène thématique. Utilisez l'échange de visages pour explorer les concepts des personnages et créer des histoires visuelles à partir d'images que vous pouvez modifier.",
          "cta": "Essayez un échange de visage de personnage gratuitement",
          "imageAlt": "Cas d'utilisation du cosplay et de l'échange de visages de personnages"
        }
      ],
      "howToKicker": "Trois étapes simples",
      "howToTitle": "Comment échanger des visages dans des photos en ligne avec l'IA",
      "howToIntro": "Choisissez une photo cible, ajoutez un visage source clair et laissez l'IA générer le résultat de l'échange de visage.",
      "faqTitle": "FAQ sur l'échange de visages avec photos",
      "faqs": [
        {
          "q": "Comment échanger un visage entre deux photos en ligne ?",
          "a": "Téléchargez la photo dont vous souhaitez conserver la pose et la composition comme cible, puis téléchargez l'identité que vous souhaitez utiliser comme visage source et lancez le traitement."
        },
        {
          "q": "Quelle est la différence entre la photo cible et le visage source ?",
          "a": "La photo cible fournit la pose, l’arrière-plan et la composition. Le visage source fournit l'identité faciale utilisée pour le remplacement."
        },
        {
          "q": "Comment choisir une bonne image source pour l’échange de visage ?",
          "a": "Utilisez une image claire et bien éclairée avec un visage dégagé. Un angle source et une expression similaires à la cible peuvent produire un résultat plus cohérent."
        },
        {
          "q": "Puis-je utiliser l'échange de visage AI pour des selfies, des mèmes ou des photos de cosplay ?",
          "a": "Oui. Il s'agit d'utilisations créatives courantes lorsque vous possédez ou êtes autorisé à modifier les images téléchargées."
        },
        {
          "q": "Pourquoi un échange de visage semble-t-il parfois moins réaliste ?",
          "a": "De grandes différences dans l’angle du visage, l’éclairage, l’expression, la résolution ou une occlusion importante peuvent rendre la fusion plus difficile. Essayez des photos sources plus claires et plus compatibles."
        },
        {
          "q": "Quels formats d'image et tailles de fichiers sont pris en charge ?",
          "a": "Les images JPG, PNG et WebP sont prises en charge, avec une taille de fichier maximale de 15 Mo par image."
        },
        {
          "q": "Puis-je échanger un visage dans une vidéo sur cette page ?",
          "a": "Non. Cette page traite les images fixes et renvoie un résultat d’image."
        }
      ]
    },
    "photo-restore": {
      "name": "Restauration de photos",
      "desc": "Restaurez les vieilles, floues ou endommagées photos avec la technologie IA",
      "fullDesc": "Restaurez les vieilles, floues ou endommagées photos avec la technologie IA. Prend en charge le filtrage du bruit, le nettoyage et le remplissage des parties manquantes pour ramener les précieux souvenirs à la vie.",
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "downloadName": "photo-restauree.png"
    },
    "blurry-photo-repair": {
      "name": "Réparer les images floues",
      "desc": "Réparez les images floues et récupérez des détails plus nets avec l'IA",
      "fullDesc": "Réparez les images floues avec l'IA. Améliorez la netteté, récupérez les détails des visages et des textures, et rendez les photos plus claires.",
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "downloadName": "image-floue-reparee.png"
    },
    "cartoon-digital-human": {
      "name": "Générateur de personnages cartoon IA",
      "desc": "Transformer un portrait en style cartoon",
      "fullDesc": "Générez un humain numérique cartoon style anime à partir d'un portrait. Conservez les traits reconnaissables tout en créant un avatar soigné aux lignes nettes et aux couleurs vives.",
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "downloadName": "humain-numerique-cartoon.png"
    },
    "manga-digital-human": {
      "name": "Générateur de personnages manga IA",
      "desc": "Transformer un portrait en style manga",
      "fullDesc": "Générez un humain numérique style manga à partir d'un portrait. Conservez les traits reconnaissables tout en créant un rendu BD propre avec des lignes expressives et un ombrage soigné.",
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "downloadName": "humain-numerique-manga.png"
    },
    "oil-painting-digital-human": {
      "name": "Générateur de portraits à l'huile IA",
      "desc": "Transformer un portrait en style peinture à l'huile",
      "fullDesc": "Générez un humain numérique style peinture à l'huile à partir d'un portrait. Conservez les traits reconnaissables tout en créant un portrait pictural aux couleurs riches et à la texture de pinceau.",
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "downloadName": "humain-numerique-peinture-huile.png"
    },
    "id-photo-generator": {
      "name": "Générateur de photo d'identité",
      "desc": "Générer une photo d'identité standard à partir d'un portrait",
      "fullDesc": "Générez une photo d'identité propre et professionnelle à partir d'un portrait. L'IA ajuste le sujet pour un rendu net de photo documentaire.",
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "downloadName": "photo-identite.png"
    },
    "ai-change-clothes": {
      "name": "Changeur de vêtements IA",
      "desc": "Importez tenue et personne, changement en un clic",
      "fullDesc": "Importez d'abord l'image de tenue, puis l'image de la personne. L'IA transfère la tenue sélectionnée sur le portrait tout en préservant la personne, la pose et les détails naturels de l'image.",
      "demoTitle": "Démo",
      "notImageFile": "Veuillez télécharger un fichier image valide.",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo.",
      "firstImageLabel": "Image de tenue",
      "uploadFirstImage": "Importer l'image de tenue",
      "changeFirstImage": "Changer l'image de tenue",
      "secondImageLabel": "Image de la personne",
      "uploadSecondImage": "Importer l'image de la personne",
      "changeSecondImage": "Changer l'image de la personne",
      "uploadingSecondImage": "Importation de l'image de la personne...",
      "downloadName": "tenue-changee-ia.png"
    },
    "image-enhancer": {
      "name": "Améliorateur d'image",
      "desc": "Mettez à l'échelle les images en résolution 4K avec des détails améliorés",
      "fullDesc": "Mettez à l'échelle les images en résolution 4K avec des détails améliorés. Utilise des algorithmes IA avancés pour améliorer les détails, rendant les images floues nettes et claires.",
      "fileTooLarge": "Image trop volumineuse. Utilisez un fichier de moins de 15 Mo (JPG, PNG ou WebP).",
      "notImageFile": "Veuillez télécharger un fichier image.",
      "downloadName": "image-amelioree.png",
      "targetResolution": "Résolution cible",
      "outputFormat": "Format de sortie",
      "resolutions": {
        "2k": "2K",
        "4k": "4K",
        "8k": "8K"
      },
      "formats": {
        "JPEG": "JPEG",
        "PNG": "PNG",
        "WEBP": "WEBP"
      },
      "processFailed": "Échec du traitement. Essayez une autre image ou un autre format de sortie."
    },
    "video-enhancer": {
      "name": "Améliorateur de vidéo",
      "desc": "Mettez à l'échelle les vidéos en résolution 4K avec une clarté améliorée",
      "fullDesc": "Mettez à l'échelle les vidéos en résolution 4K avec une clarté améliorée. Prend en charge plusieurs formats vidéo avec interpolation de trames alimentée par IA pour une qualité HD exceptionnelle.",
      "notVideoFile": "Veuillez télécharger un fichier vidéo (p. ex. MP4, MOV, AVI).",
      "fileTooLarge": "Vidéo trop volumineuse. Veuillez utiliser un fichier de moins de 100 Mo."
    },
    "cartoon-video-style-converter": {
      "name": "Convertisseur style cartoon",
      "desc": "Convertir les vidéos en style cartoon",
      "fullDesc": "Téléchargez une vidéo et l'IA la convertira en style cartoon tout en préservant les mouvements principaux, le cadrage et le rythme.",
      "notVideoFile": "Veuillez télécharger un fichier vidéo valide.",
      "fileTooLarge": "Vidéo trop volumineuse. Veuillez choisir une vidéo de moins de 100 Mo.",
      "downloadName": "cartoon-style-video.mp4"
    },
    "anime-video-style-converter": {
      "name": "Convertisseur style anime",
      "desc": "Convertir les vidéos en style anime",
      "fullDesc": "Téléchargez une vidéo et l'IA la convertira en style anime tout en préservant les mouvements du sujet et le rythme du plan.",
      "notVideoFile": "Veuillez télécharger un fichier vidéo valide.",
      "fileTooLarge": "Vidéo trop volumineuse. Veuillez choisir une vidéo de moins de 100 Mo.",
      "downloadName": "anime-style-video.mp4"
    },
    "oil-painting-video-style-converter": {
      "name": "Convertisseur style peinture à l'huile",
      "desc": "Convertir les vidéos en style peinture à l'huile",
      "fullDesc": "Téléchargez une vidéo et l'IA la convertira en style peinture à l'huile avec des couleurs riches et une texture picturale.",
      "notVideoFile": "Veuillez télécharger un fichier vidéo valide.",
      "fileTooLarge": "Vidéo trop volumineuse. Veuillez choisir une vidéo de moins de 100 Mo.",
      "downloadName": "oil-painting-style-video.mp4"
    },
    "cyberpunk-video-style-converter": {
      "name": "Convertisseur style cyberpunk",
      "desc": "Convertir les vidéos en style cyberpunk",
      "fullDesc": "Téléchargez une vidéo et l'IA la convertira en style cyberpunk futuriste à fort contraste avec des effets néon.",
      "notVideoFile": "Veuillez télécharger un fichier vidéo valide.",
      "fileTooLarge": "Vidéo trop volumineuse. Veuillez choisir une vidéo de moins de 100 Mo.",
      "downloadName": "cyberpunk-style-video.mp4"
    },
    "doc-crop-enhance": {
      "name": "Recadrage et correction d'image",
      "desc": "Recadrez et corrigez la deformation des documents avec l'IA",
      "fullDesc": "Recadrage, correction et amélioration d'images de documents. Suppression des bords, correction de distorsion, et amélioration avec plusieurs modes incluant éclaircir, netteté, noir et blanc, niveaux de gris et suppression des ombres.",
      "enhanceMode": "Mode d'amélioration",
      "enhanceModes": {
        "disabled": "Amélioration désactivée",
        "brighten": "Éclaircir",
        "sharpen": "Améliorer et netteté",
        "blackWhite": "Noir et blanc",
        "grayscale": "Niveaux de gris",
        "deshadow": "Suppression des ombres",
        "bitmap": "Bitmap"
      },
      "cropImage": "Recadrer",
      "dewarpImage": "Correction",
      "notImageFile": "Veuillez télécharger un fichier image valide",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo",
      "noImageInResponse": "Échec du traitement, veuillez réessayer",
      "downloadName": "doc-crop-enhanced.png",
      "featuresKicker": "AMÉLIORATION DE LA NUMÉRISATION DE DOCUMENTS",
      "featuresTitle": "Transformez les photos de documents en numérisations nettes et correctement alignées",
      "featuresIntro": "Gérez les bords, l'inclinaison, la perspective, les pages incurvées, les ombres et la clarté du texte des documents pour répondre aux besoins courants de capture mobile et d'amélioration de la numérisation.",
      "features": [
        {
          "title": "Détecter et recadrer automatiquement les bords du document",
          "desc": "Trouvez la limite entre le papier et son arrière-plan, puis supprimez les bureaux, les ombres des bords et les zones non liées pour une page plus propre.",
          "cta": "Recadrer un document gratuitement"
        },
        {
          "title": "Redressez les documents asymétriques et corrigez la perspective",
          "desc": "Corrigez la distorsion trapézoïdale, les pages inclinées et les proportions causées par les photos inclinées des contrats, des formulaires et des épreuves de test.",
          "cta": "Corriger une photo de document"
        },
        {
          "title": "Déformer les pages courbes et les documents numérisés",
          "desc": "Corrigez la distorsion près des reliures de livres, du papier gondolé et des pages pliées pour faciliter la lecture des photos de manuels et de livres.",
          "cta": "Déformer un document incurvé"
        },
        {
          "title": "Supprimer les ombres des numérisations de documents",
          "desc": "Réduisez les ombres causées par les téléphones, les doigts, le dos des livres et un éclairage inégal pour des reçus, des feuilles de calcul et des pages numérisées plus propres.",
          "cta": "Supprimer les ombres du document"
        },
        {
          "title": "Éclaircir les documents et affiner le texte",
          "desc": "Améliorez la luminosité et les bords du texte imprimé dans les documents à faible contraste pour faciliter la lecture, l'impression et l'organisation.",
          "cta": "Affiner le texte numérisé"
        },
        {
          "title": "Créez des numérisations en noir et blanc, en niveaux de gris ou bitmap",
          "desc": "Convertissez les photos de documents couleur en images noir et blanc, en niveaux de gris ou bitmap améliorées pour l'impression et l'archivage.",
          "cta": "Améliorer une image de document"
        }
      ],
      "useCasesKicker": "CAS D'UTILISATION COURANT",
      "useCasesTitle": "Quelles images de documents peuvent être recadrées et améliorées ?",
      "useCasesIntro": "Conçu pour les images de documents individuels capturées par téléphone ou scanner avec un cadrage irrégulier, des ombres, une distorsion ou un texte peu clair.",
      "useCases": [
        {
          "title": "Photo du téléphone à numériser",
          "desc": "Supprimez les arrière-plans du bureau et corrigez les angles de caméra pour que les photos du téléphone ressemblent davantage à des numérisations."
        },
        {
          "title": "Contrats et formulaires",
          "desc": "Contrats de recadrage, applications et formulaires pour restaurer des bords nets et des proportions de page."
        },
        {
          "title": "Reçus et factures",
          "desc": "Réduisez les ombres et accentuez le texte imprimé pâle pour une visualisation et un archivage plus clairs."
        },
        {
          "title": "Pages de livre incurvées",
          "desc": "Courbure correcte à proximité des reliures des manuels, livres et cahiers d'exercices."
        },
        {
          "title": "Papiers de test et feuilles de travail",
          "desc": "Redressez les papiers de test, supprimez les ombres et affinez le texte imprimé pour la réutilisation ou l'impression."
        },
        {
          "title": "Archives en noir et blanc",
          "desc": "Convertissez les photos de documents en styles de numérisation cohérents en noir et blanc ou en niveaux de gris."
        }
      ],
      "faqTitle": "FAQ sur le recadrage et la correction des documents AI",
      "faqs": [
        {
          "q": "Qu’est-ce que le recadrage et la correction de documents par l’IA ?",
          "a": "Il détecte la zone du document, supprime l'arrière-plan environnant et peut corriger l'inclinaison, la perspective ou la distorsion des pages incurvées en fonction de vos paramètres."
        },
        {
          "q": "Comment recadrer automatiquement les images d'un document numérisé en ligne ?",
          "a": "Activez le recadrage des bords, puis téléchargez l'image du document numérisé. L'outil tente de détecter la limite du papier et de supprimer la zone en dehors du document."
        },
        {
          "q": "Puis-je redresser un document numérisé en ligne ?",
          "a": "Oui. Utilisez le redressement pour un balayage incliné et la correction de perspective pour une photo de téléphone inclinée. Utilisez la correction de déformation uniquement lorsque la page elle-même est courbée."
        },
        {
          "q": "Quelle est la différence entre les modes d’ombre et de netteté ?",
          "a": "Deshadow améliore l’éclairage inégal des pages, tandis que la netteté renforce les bords du texte et des lignes. Choisissez le mode qui correspond au problème source."
        },
        {
          "q": "Quel outil puis-je utiliser pour améliorer les épreuves, les contrats et les reçus numérisés ?",
          "a": "Utilisez cet outil de recadrage et d'amélioration de documents avec suppression des ombres pour un éclairage inégal, netteté pour le texte pâle et noir et blanc ou niveaux de gris lors de la préparation des documents pour l'impression."
        },
        {
          "q": "Peut-il transformer une photo de téléphone en document numérisé ?",
          "a": "Le recadrage, la correction et l'amélioration peuvent produire une image semblable à une numérisation, mais l'outil ne génère pas de PDF ni n'extrait de texte OCR."
        },
        {
          "q": "Quels formats d'image et tailles de fichiers sont pris en charge ?",
          "a": "Les images JPG, PNG et WebP sont prises en charge, avec une taille de fichier maximale de 15 Mo."
        },
        {
          "q": "Le traitement modifie-t-il le contenu du document original ?",
          "a": "L'outil ajuste le cadrage, la géométrie, la luminosité et la clarté. Il ne modifie pas le texte et n'extrait pas le contenu du document."
        }
      ],
      "education": {
        "kicker": "DOCUMENTS ÉDUCATIFS",
        "title": "Transformez les épreuves, les devoirs et les photos de manuels scolaires en numérisations claires",
        "intro": "Détectez automatiquement les bords des documents éducatifs et corrigez l’inclinaison, la perspective, les pages incurvées et les ombres pour une impression, un archivage et une utilisation en classe plus propres.",
        "items": [
          {
            "title": "Photos de papier d'essai de culture",
            "desc": "Détectez les bords du papier test et supprimez l’arrière-plan du bureau pour créer une page propre et correctement encadrée."
          },
          {
            "title": "Corriger les images des devoirs",
            "desc": "Corrigez l'inclinaison et la perspective des photos de devoirs afin qu'elles soient plus faciles à consulter, à soumettre et à imprimer."
          },
          {
            "title": "Déformer les pages du manuel",
            "desc": "Corrigez les pages incurvées près des reliures de livres et réduisez les ombres qui rendent le contenu imprimé plus difficile à lire."
          },
          {
            "title": "Aiguiser les feuilles de travail en classe",
            "desc": "Éclaircissez et améliorez la netteté des feuilles de calcul ou des documents d'étude avec des effets de numérisation nets en noir et blanc ou en niveaux de gris."
          }
        ],
        "relatedTitle": "Besoin de supprimer les réponses manuscrites d’une épreuve ?",
        "relatedDesc": "Cet outil gère le recadrage, la correction géométrique et l'amélioration de l'image. Utilisez la gomme d'écriture manuscrite pour supprimer les réponses des élèves, les calculs ou les annotations de l'enseignant.",
        "relatedCta": "Gomme d'écriture ouverte"
      }
    },
    "handwritten-erase": {
      "name": "Effaceur d'écriture manuscrite",
      "desc": "Effacez l'écriture manuscrite des documents avec l'IA",
      "fullDesc": "Détecte et efface automatiquement l'écriture manuscrite des documents tout en préservant le contenu imprimé. Parfait pour les examens, notes, contrats et plus. Prend en charge le recadrage, la correction et la rotation.",
      "docDirection": "Rotation",
      "docDirections": {
        "none": "Pas de rotation",
        "rotate90": "90° sens horaire",
        "rotate180": "180° sens horaire",
        "rotate270": "270° sens horaire",
        "auto": "Détection automatique"
      },
      "crop": "Recadrer",
      "dewarp": "Correction",
      "notImageFile": "Veuillez télécharger un fichier image valide",
      "fileTooLarge": "Image trop volumineuse, veuillez sélectionner une image de moins de 15 Mo",
      "noImageInResponse": "Échec du traitement, veuillez réessayer",
      "downloadName": "handwritten-erased.png",
      "featuresKicker": "Suppression de l'écriture manuscrite d'un document",
      "featuresTitle": "Supprimer l'écriture manuscrite et restaurer des documents propres",
      "featuresIntro": "Nettoyez les réponses manuscrites, les révisions de contrat, les notes de révision et les marques de documents numérisés tout en préservant le texte imprimé et la mise en page originale.",
      "features": [
        {
          "title": "Supprimer les réponses des étudiants des copies de test",
          "desc": "Détectez automatiquement les réponses manuscrites, les calculs et les annotations sur les épreuves terminées.",
          "cta": "Réponses sur papier de test propre gratuites"
        },
        {
          "title": "Effacer l’écriture manuscrite des contrats",
          "desc": "Nettoyez les ajouts manuscrits, les cercles, les montants modifiés, les flèches et les notes de révision tout en préservant les clauses, les tableaux et la mise en page imprimés.",
          "cta": "Écriture manuscrite propre du contrat en ligne"
        },
        {
          "title": "Préparer et réimprimer des tests pour l'enseignement",
          "desc": "Nettoyez les réponses des élèves et les annotations des enseignants pour les leçons, la préparation aux tests et l'archivage des documents.",
          "cta": "Essayez le nettoyant pour papier de test pour enseignants"
        },
        {
          "title": "Nettoyer les marques manuscrites des documents numérisés",
          "desc": "Supprimez les coches, les flèches, les cercles, les notes en marge et les marques de révision des formulaires numérisés, des rapports d'inspection et des documents de bureau.",
          "cta": "Nettoyer les marques de documents numérisés"
        }
      ],
      "useCasesKicker": "Pour les étudiants et les enseignants",
      "useCasesTitle": "Cas d'utilisation dans l'enseignement pour la suppression de l'écriture manuscrite de l'IA",
      "useCases": [
        {
          "title": "Suppression de la réponse au test",
          "desc": "Effacez les réponses et les calculs des élèves des copies de test."
        },
        {
          "title": "Examen des erreurs",
          "desc": "Restaurez les papiers terminés pour une autre série de pratique."
        },
        {
          "title": "Nettoyage du classeur",
          "desc": "Supprimez le contenu manuscrit des devoirs et des feuilles de travail."
        },
        {
          "title": "Enseignement et préparation aux tests",
          "desc": "Créez des papiers vierges pour les cours, la réimpression et l'archivage."
        },
        {
          "title": "Correction du papier numérisé",
          "desc": "Faites pivoter, recadrez et déformez les images de documents asymétriques ou incurvées."
        },
        {
          "title": "Nettoyage des contrats et des notes",
          "desc": "Supprimez l’écriture manuscrite et les annotations des documents généraux."
        }
      ],
      "howToKicker": "Trois étapes simples",
      "howToTitle": "Comment supprimer les réponses manuscrites des épreuves de test en ligne",
      "howToIntro": "Téléchargez un papier ou un document test, définissez les options de rotation, de recadrage et de déformation, puis téléchargez le résultat nettoyé.",
      "steps": {
        "upload": {
          "title": "Télécharger une épreuve ou un document de test",
          "desc": "Téléchargez une copie de test JPG, PNG ou WebP, une feuille de devoirs ou un document numérisé de moins de 15 Mo."
        },
        "process": {
          "title": "Configurer et supprimer l'écriture manuscrite",
          "desc": "Choisissez la direction du document et activez le recadrage ou la correction de déformation selon vos besoins, puis démarrez le traitement."
        },
        "download": {
          "title": "Révision et téléchargement",
          "desc": "Comparez les images avant et après, téléchargez le document propre ou traitez une autre image."
        }
      },
      "faqTitle": "FAQ sur la suppression des réponses au papier de test AI",
      "faqs": [
        {
          "q": "Quel outil puis-je utiliser pour supprimer les réponses manuscrites des épreuves ?",
          "a": "Le outil de suppression d'écriture manuscrite Miral AI détecte les réponses manuscrites, les calculs et les annotations tout en préservant les questions imprimées et la mise en page originale lorsque cela est possible."
        },
        {
          "q": "L’IA peut-elle supprimer l’écriture manuscrite tout en préservant le texte imprimé ?",
          "a": "Il peut restaurer un papier propre tout en préservant le texte imprimé lorsque l'écriture manuscrite ne chevauche pas fortement le contenu imprimé."
        },
        {
          "q": "Les enseignants peuvent-ils nettoyer et réimprimer les copies de test ?",
          "a": "Oui. Il convient à la préparation des cours, aux explications en classe, à la création de tests et à l'archivage de documents."
        },
        {
          "q": "Les étudiants peuvent-ils réinitialiser les devoirs auxquels ils ont répondu pour les réviser ?",
          "a": "Oui. Les papiers de test et les feuilles de travail nettoyés peuvent être réutilisés pour vérifier les erreurs et poursuivre la pratique."
        },
        {
          "q": "Comment effacer des notes manuscrites, des marques de stylo et des annotations à l'encre rouge ?",
          "a": "Téléchargez l'image du document et exécutez le outil de suppression d'écriture manuscrite. Il peut traiter différentes couleurs d'écriture manuscrite et différents outils d'écriture, bien que les résultats dépendent de la clarté et du chevauchement avec le texte imprimé."
        },
        {
          "q": "Comment puis-je corriger une numérisation asymétrique ou incurvée avant de supprimer l'écriture manuscrite ?",
          "a": "Redémarrez ou faites d'abord pivoter un balayage incliné. Utilisez le recadrage pour l'excès d'arrière-plan et la correction de déformation uniquement pour les pages véritablement incurvées avant de traiter l'écriture manuscrite."
        },
        {
          "q": "Quels formats d'images sont pris en charge ?",
          "a": "Les images JPG, PNG et WebP de moins de 15 Mo sont prises en charge. Les fichiers PDF ne sont pas pris en charge sur cette page."
        }
      ]
    },
    "category": {
      "image": "Traitement d'image",
      "video": "Traitement vidéo",
      "document": "Traitement de document"
    },
    "categoryModal": {
      "title": "Sélectionner une catégorie d'outils"
    },
    "convert": {
      "success": "Conversion terminée !",
      "zipHint": "Le résultat est empaqueté dans un fichier ZIP contenant plusieurs images",
      "fileTooLarge": "Fichier trop volumineux, veuillez sélectionner un fichier de moins de 50 Mo",
      "demoTitle": "Aperçu de conversion",
      "sourceLabel": "Format source",
      "targetLabel": "Format de sortie"
    },
    "pdf-to-word": {
      "name": "PDF vers Word",
      "desc": "Convertir des fichiers PDF en documents Word modifiables",
      "fullDesc": "Convertir intelligemment des fichiers PDF en documents Word modifiables, en préservant avec précision la mise en page, les tableaux, les images, etc."
    },
    "image-to-word": {
      "name": "Image vers Word",
      "desc": "Convertir le texte des images en documents Word",
      "fullDesc": "Reconnaître intelligemment le texte, les tableaux et autres contenus dans les images et les convertir en documents Word, en préservant le format de mise en page original."
    },
    "pdf-to-excel": {
      "name": "PDF vers Excel",
      "desc": "Convertir des tableaux PDF en fichiers Excel modifiables",
      "fullDesc": "Reconnaître intelligemment le contenu des tableaux dans les fichiers PDF et les convertir en fichiers Excel modifiables."
    },
    "pdf-to-ppt": {
      "name": "PDF vers PPT",
      "desc": "Convertir des fichiers PDF en présentations PPT modifiables",
      "fullDesc": "Convertir intelligemment des fichiers PDF en présentations PPT modifiables, en préservant la mise en page, les images et le texte originaux."
    },
    "pdf-to-image": {
      "name": "PDF vers Image",
      "desc": "Convertir chaque page PDF en images haute qualité",
      "fullDesc": "Convertir chaque page d'un fichier PDF en images haute qualité. Prend en charge la conversion par lots de PDF multipages."
    },
    "word-to-pdf": {
      "name": "Word vers PDF",
      "desc": "Convertir des documents Word en fichiers PDF",
      "fullDesc": "Convertir rapidement des documents Word en fichiers PDF, en préservant la mise en page, les polices et les images originales."
    },
    "excel-to-pdf": {
      "name": "Excel vers PDF",
      "desc": "Convertir des feuilles de calcul Excel en fichiers PDF",
      "fullDesc": "Convertir des feuilles de calcul Excel en fichiers PDF, en préservant la structure des tableaux et la mise en page des données."
    },
    "image-to-pdf": {
      "name": "Image vers PDF",
      "desc": "Fusionner plusieurs images en un seul fichier PDF",
      "fullDesc": "Fusionner plusieurs images en un seul fichier PDF. Prend en charge les formats d'image courants tels que JPG, PNG et BMP."
    },
    "word-to-image": {
      "name": "Word vers Image",
      "desc": "Convertir chaque page de document Word en image",
      "fullDesc": "Convertir chaque page d'un document Word en images haute qualité. Prend en charge la conversion par lots de documents multipages."
    }
  },
  "plans": {
    "basic": {
      "name": "Basique",
      "features": [
        "Tous les crédits livrés en une seule fois",
        "Générer jusqu'à 2 600 images IA",
        "Générer 520 vidéos IA",
        "Générer jusqu'à 480 pistes musicales IA",
        "Aucun filigrane",
        "Licence commerciale"
      ]
    },
    "pro": {
      "name": "Pro",
      "features": [
        "Tous les crédits livrés en une seule fois",
        "Générer jusqu'à 10 600 images IA",
        "Générer jusqu'à 2 120 vidéos IA",
        "Générer jusqu'à 1 920 pistes musicales IA",
        "Tous les modèles premium",
        "File prioritaire",
        "Assistance prioritaire",
        "Mode privé et conformité DPA"
      ]
    },
    "ultimate": {
      "name": "Ultimate",
      "features": [
        "Tous les crédits livrés en une seule fois",
        "Générer jusqu'à 36 600 images IA",
        "Générer jusqu'à 7 320 vidéos IA",
        "Générer jusqu'à 6 720 pistes musicales IA",
        "Tous les modèles premium",
        "Assistance dédiée",
        "Mode privé et conformité DPA"
      ]
    }
  },
  "faq": {
    "categories": {
      "all": "Tous",
      "general": "Général",
      "pricing": "Tarifs",
      "models": "Modèles",
      "features": "Fonctionnalités"
    },
    "items": [
      {
        "q": "Qu'est-ce que Miral ?",
        "a": "Miral est une plateforme de création IA tout-en-un intégrant 29+ modèles IA de premier plan, prenant en charge la génération d'images, la création de vidéos, la production musicale et des outils d'édition professionnels. Pas besoin de basculer entre les plates-formes - un seul compte vous donne accès à tous les principaux modèles, y compris FLUX, Midjourney, Sora, Veo, Kling et plus encore."
      },
      {
        "q": "Quels modèles IA sont pris en charge ?",
        "a": "Nous prenons en charge 29+ modèles IA de premier plan, y compris les modèles d'image (FLUX 2 Max, Midjourney, Seedream, GPT-Image-1, Nano Banana, etc.), les modèles vidéo (Veo 3.1, Sora 2, Kling 2.6, Seedance, Wan 2.5, etc.) et les modèles de génération de musique IA. Tous les modèles sont régulièrement mis à jour."
      },
      {
        "q": "Comment fonctionne le système de crédits ?",
        "a": "Nous utilisons un système de crédits unifié. La génération d'image commence à 2 crédits, la génération de vidéo à 10 crédits et la musique à 10 crédits par piste. Les modèles premium peuvent consommer plus de crédits. Les abonnés bénéficient de taux de crédit inférieurs et peuvent également acheter des packs de crédits séparément."
      },
      {
        "q": "Puis-je générer des images, des vidéos et de la musique ?",
        "a": "Oui ! Miral prend en charge la conversion texte-image, l'édition d'image, le transfert de style, la conversion texte-vidéo, image-vidéo, la création de musique IA et plus encore - répondant à tous les besoins créatifs, des projets personnels aux travaux commerciaux."
      },
      {
        "q": "À quelle vitesse se fait la génération ?",
        "a": "La plupart des générations d'images se terminent en 30 secondes, la génération de vidéo prend environ 1 à 6 minutes. Nous optimisons continuellement notre infrastructure pour garantir une génération rapide et stable."
      },
      {
        "q": "Puis-je utiliser Miral à des fins commerciales ?",
        "a": "Oui. Tous les plans payants incluent des licences commerciales, vous permettant d'utiliser le contenu généré à des fins commerciales, pour des matériaux marketing, des médias sociaux, etc."
      },
      {
        "q": "L'accès API est-il disponible ?",
        "a": "Oui, le plan Ultimate inclut l'accès API. Grâce à notre API complète, vous pouvez intégrer directement la génération d'images, de vidéos et de musique IA dans vos applications."
      },
      {
        "q": "Puis-je générer de la musique avec l'IA ?",
        "a": "Absolument ! Notre générateur de musique IA prend en charge divers styles musicaux. Il suffit de décrire ce que vous voulez générer pour créer de la musique originale, parfaite pour les bandes sonores de vidéos, la musique de fond pour les podcasts, etc."
      },
      {
        "q": "Comment gérez-vous la confidentialité et la sécurité des données ?",
        "a": "Nous respectons strictement les normes de conformité RGPD. Toutes les données sont cryptées et ne sont pas utilisées pour l'entraînement IA. Les utilisateurs peuvent supprimer leur compte et toutes leurs données à tout moment."
      },
      {
        "q": "Les autres peuvent-ils voir mon travail ?",
        "a": "Par défaut, votre travail n'est visible que par vous. Les utilisateurs Pro et Ultimate peuvent activer le mode privé pour garantir une confidentialité totale."
      },
      {
        "q": "Comment puis-je supprimer mon compte et mes données ?",
        "a": "Vous pouvez demander la suppression de votre compte dans vos paramètres de compte à tout moment. Nous supprimerons toutes vos données et contenus générés dans les 30 jours."
      },
      {
        "q": "Puis-je obtenir de l'aide si je rencontre des problèmes ?",
        "a": "Bien sûr ! Vous pouvez contacter notre équipe d'assistance à miral_support@miralvis.com. Les utilisateurs Pro bénéficient d'une assistance prioritaire, et les utilisateurs Ultimate bénéficient d'une assistance dédiée."
      }
    ]
  },
  "testimonials": {
    "items": [
      {
        "name": "Alex Chen",
        "role": "Directeur marketing numérique",
        "tag": "Économise 90 % du temps",
        "content": "Miral est devenu notre centre de contenu visuel. Générez des images de produits avec Midjourney, créez des vidéos promotionnelles avec Veo, puis éditez tout dans Miral - le tout sans changer de plateforme."
      },
      {
        "name": "Sarah Rodriguez",
        "role": "Propriétaire de commerce électronique",
        "tag": "40 % de conversion en plus",
        "content": "Avoir accès à 29+ modèles en un seul endroit est incroyable. J'utilise Seedream pour les photos de produits, Seedance pour les publicités vidéo et les outils de mise à l'échelle pour les catalogues. La conversion a augmenté de 40 % !"
      },
      {
        "name": "David Kim",
        "role": "Créateur de contenu",
        "tag": "500K+ abonnés",
        "content": "Je crée des images avec FLUX et Nano Banana, puis les transforme en vidéos virales avec Kling et Sora. Le système de crédits est équitable - payer selon l'utilisation. Mes abonnés adorent le contenu diversifié !"
      },
      {
        "name": "Emma Thompson",
        "role": "Graphiste",
        "tag": "Niveau professionnel",
        "content": "En tant que graphiste, j'étais sceptique quant aux plates-formes IA. Mais la riche bibliothèque de modèles et les outils d'édition précis de Miral sont vraiment impressionnants - du croquis de concept au produit final, tout est facile."
      },
      {
        "name": "James Wilson",
        "role": "Producteur vidéo",
        "tag": "Flux de travail 10x plus rapide",
        "content": "Les modèles vidéo ici sont incroyables - Veo est cinématographique, Seedance est rapide, et l'animation de personnages de Wan est naturelle. Tous les modèles partagent un seul système de crédits - économise du temps et de l'argent."
      },
      {
        "name": "Lisa Park",
        "role": "Propriétaire d'agence créative",
        "tag": "Choix numéro un de l'équipe",
        "content": "Toute notre équipe est passée à Miral. L'intégration API est fluide, et la variété des modèles signifie que nous trouvons toujours le bon outil. C'est la meilleure plateforme IA disponible."
      }
    ]
  },
  "langModal": {
    "title": "Sélectionner la langue"
  },
  "home": {
    "generate": "Générer",
    "chatDisabledGenerateHint": "Veuillez saisir un prompt",
    "compactChatPlaceholder": "Saisissez votre prompt pour générer de superbes images et vidéos IA ainsi que de la musique originale",
    "hero": {
      "title": "Miral – Créateur IA tout-en-un d’images, de vidéos et de musique",
      "subtitle": "Propulsé par des modèles IA polyvalents, Miral réunit l’édition d’images, la génération vidéo et la création musicale par IA. Retouchez des photos, créez des portraits vidéo cinématographiques et composez une musique de fond personnalisée pour vos projets personnels et commerciaux.",
      "createVideo": "Créer une vidéo",
      "createImage": "Créer une image"
    },
    "stats": {
      "models": "Meilleurs modèles IA",
      "works": "Œuvres générées",
      "tools": "Outils professionnels",
      "platforms": "Plates-formes partenaires"
    },
    "generatorNew": {
      "promptPlaceholder": "Décrivez la vidéo que vous souhaitez générer...",
      "promptPlaceholderImage": "Décrivez l'image que vous souhaitez générer...",
      "generating": "Génération en cours...",
      "noHistory": "Les résultats apparaîtront ici",
      "generationFailed": "Génération échouée",
      "historyTitle": "Historique",
      "myAssets": "Mes actifs"
    },
    "quickTools": {
      "title": "Outils IA rapides"
    },
    "exploreMore": {
      "title": "Explorer plus de fonctions IA"
    },
    "platform": {
      "tag": "Plateforme",
      "title": "Boîte à outils IA qui rend la création simple",
      "subtitle": "Génération d'images, création de vidéos, production musicale et outils professionnels tout-en-un alimentés par des modèles IA leaders de l'industrie.",
      "tabs": {
        "image": "Images IA",
        "video": "Vidéos IA",
        "music": "Musique IA",
        "tools": "Boîte à outils IA"
      },
      "image": {
        "title": "Générez et éditez des images stupéfiantes avec les meilleurs modèles IA mondiaux",
        "desc": "Conversion texte-image, édition précise, transfert de style et mise à l'échelle HD. Alimenté par FLUX, Midjourney, Seedream, GPT-Image-1 et Nano Banana.",
        "explore": "Explorer les modèles d'image →"
      },
      "video": {
        "title": "Créez des vidéos cinématographiques avec l'IA",
        "desc": "Du texte-à-vidéo à l'animation d'image, alimenté par les modèles Veo, Sora, Kling, Seedance et Wan. Générez des vidéos avec synchronisation audio et travail de caméra professionnel.",
        "explore": "Explorer les modèles vidéo →"
      },
      "music": {
        "title": "Création musicale originale alimentée par l'IA",
        "desc": "Générez de la musique originale à partir de descriptions, prenant en charge divers styles et durées. Parfait pour les bandes sonores de vidéos, la musique de fond pour les podcasts, etc.",
        "explore": "Explorer la musique IA →"
      },
      "tools": {
        "title": "Boîte à outils IA professionnelle",
        "desc": "Suppression de filigrane, restauration de photo, mise à l'échelle HD, amélioration vidéo et plus d'outils professionnels pour tous vos besoins de post-traitement.",
        "explore": "Voir tous les outils →"
      }
    },
    "models": {
      "tag": "Modèles",
      "title": "Intégration en un seul lieu des meilleurs modèles IA mondiaux",
      "subtitle": "Une plateforme intégrant tous les modèles IA principaux. Plus besoin de basculer entre plusieurs comptes et abonnements.",
      "imageModels": "Modèles d'image",
      "videoModels": "Modèles vidéo",
      "musicModels": "Musique IA",
      "musicDesc": "Générer de la musique originale à partir de descriptions",
      "filterAll": "Tous",
      "credits": "Crédits",
      "viewAll": "Tout voir →"
    },
    "features": {
      "tag": "Fonctionnalités principales",
      "title": "Créez des images, vidéos et musiques stupéfiantes",
      "subtitle": "Du texte-à-image, texte-à-vidéo à la création musicale IA, plus l'édition précise et la mise à l'échelle HD - création tout-en-un.",
      "items": {
        "textToImage": {
          "tag": "Texte à image",
          "title": "Texte à image",
          "desc": "Saisissez une description, assistez à la magie. Que ce soit des portraits hyper-réalistes ou des paysages fantastiques, utilisez Midjourney, Seedream, Nano Banana et d'autres modèles pour générer des chefs-d'œuvre visuels avec des invites simples.",
          "cta": "Génération d'image",
          "imageAlt": "Générez des chefs-d'œuvre visuels avec des prompts simples grâce à Midjourney, Seedream, Nano Banana et d'autres modèles"
        },
        "imageEdit": {
          "tag": "Édition d'image et transfert de style",
          "title": "Édition d'image et transfert de style",
          "desc": "Utilisez l'IA pour remodeler précisément les images. Que ce soit pour changer de style, modifier des objets, remplacer des arrière-plans ou éditer du texte, tout cela avec une grande cohérence.",
          "cta": "Édition d'image",
          "beforeAlt": "Avant l'édition d'image et le transfert de style",
          "afterAlt": "Après l'édition d'image et le transfert de style"
        },
        "textToVideo": {
          "tag": "Texte à vidéo",
          "title": "Texte à vidéo",
          "desc": "Il suffit de saisir des invites pour générer des vidéos cinématographiques avec synchronisation audio, travail de caméra professionnel et mouvement réaliste. Choisissez parmi les modèles Veo, Sora, Kling, Seedance et Wan.",
          "cta": "Génération de vidéo"
        },
        "imageToVideo": {
          "tag": "Image à vidéo",
          "title": "Image à vidéo",
          "desc": "Transformez des images fixes en vidéos cinématographiques. Que ce soit des photos de produits, des illustrations ou des images générées par IA, donnez-leur vie avec un mouvement naturel et une voix off.",
          "cta": "Animation d'image"
        },
        "upscale": {
          "tag": "Mise à l'échelle HD",
          "title": "Mise à l'échelle HD",
          "desc": "Utilisez l'IA pour améliorer la qualité des images et des vidéos. Prend en charge la mise à l'échelle HD sans perte et améliore la résolution vidéo jusqu'au niveau professionnel 4K.",
          "cta": "Mettre à l'échelle maintenant",
          "imageAlt": "Améliorez la qualité des images et des vidéos avec l'IA"
        },
        "templates": {
          "tag": "40+ modèles d'image",
          "title": "40+ modèles d'image",
          "desc": "Modèles massifs pour susciter l'inspiration : modèles 3D, style Ghibli, jouets de designer, générateur de mème, couvertures de magazines et plus encore - téléchargez une photo, résultats instantanés.",
          "cta": "Parcourir les modèles",
          "imageAlt": "Exemple de modèle d'image"
        }
      }
    },
    "gallery": {
      "tag": "Galerie",
      "title": "Explorez les possibilités infinies",
      "subtitle": "Découvrez ce que les créateurs construisent avec Miral - des images hyper-réalistes aux vidéos cinématographiques, l'inspiration au bout des doigts.",
      "images": {
        "alt1": "Exemple d'image générée par Midjourney",
        "alt2": "Exemple d'image générée par Seedream",
        "alt3": "Exemple d'image générée par GPT-Image-1",
        "alt4": "Exemple d'image générée par Flux",
        "alt5": "Exemple d'image générée par Flux Pro",
        "alt6": "Exemple d'image générée par Midjourney",
        "alt7": "Exemple d'image générée par Seedream",
        "alt8": "Exemple d'image générée par GPT-Image-1"
      }
    },
    "whyChoose": {
      "tag": "Pourquoi choisir Miral",
      "title": "Création tout-en-un, tout ce dont vous avez besoin",
      "subtitle": "Plateforme unique rassemblant les meilleurs modèles de création d'image, de vidéo et de musique IA mondiaux.",
      "items": {
        "allModels": {
          "title": "Tous les modèles intégrés, un seul suffit",
          "desc": "Accès en un seul lieu à 29+ modèles IA de premier plan d'OpenAI, Google, Alibaba, ByteDance et plus. Plus besoin de basculer entre les outils ou gérer plusieurs abonnements."
        },
        "fast": {
          "title": "Extrêmement rapide",
          "desc": "La plupart des générations d'image se terminent en 30 secondes, la génération de vidéo prend environ 1 à 6 minutes. Infrastructure optimisée pour éviter les longues attentes."
        },
        "credits": {
          "title": "Système de crédits simple",
          "desc": "Payer selon l'utilisation, tarification transparente. Commencez avec des crédits gratuits - pas besoin de carte de crédit pour commencer à créer."
        },
        "api": {
          "title": "API développeur",
          "desc": "Intégrez directement la génération d'image, de vidéo et de musique IA dans vos applications via notre API complète. Construisez votre produit sur les meilleurs modèles IA."
        }
      }
    },
    "testimonials": {
      "tag": "Histoires d'utilisateurs",
      "title": "Des créateurs du monde entier nous font confiance",
      "subtitle": "Rejoignez des milliers de professionnels et de créateurs utilisant Miral pour générer des images, créer des vidéos et alimenter leurs flux de travail créatifs."
    },
    "faq": {
      "tag": "Support",
      "title": "Questions fréquentes",
      "subtitle": "Guide complet de la plateforme, des modèles pris en charge, des plans tarifaires et des fonctionnalités."
    },
    "cta": {
      "title": "Commencez votre voyage de création IA maintenant",
      "subtitle": "Rejoignez des milliers de créateurs, designers et entreprises utilisant Miral pour réaliser leur créativité avec les meilleurs modèles IA mondiaux.",
      "createImage": "Créer une image →",
      "createVideo": "Créer une vidéo →",
      "note": "Les nouveaux utilisateurs reçoivent des crédits gratuits lors de l'inscription. Aucune carte de crédit requise."
    },
    "apps": {
      "title": "Applications",
      "quickTitle": "Applications IA rapides",
      "more": "Plus",
      "keywords": {
        "viralVideo": "Vidéo virale",
        "tiktokAds": "Pubs TikTok",
        "productShowcase": "Présentation produit",
        "aiAvatar": "Avatar IA",
        "homeModernKitchen": "Cuisine moderne"
      },
      "social": "Réseaux Sociaux",
      "posters": "Affiches",
      "interior": "Maison",
      "entertainment": "Divertissement",
      "lifestyle": "Style de Vie",
      "comic": "Bande Dessinée",
      "items": {
        "viralVideo": "Vidéos Virales",
        "celebrityVideo": "Vidéo Célébrité",
        "productShowcase": "Vitrine Produit",
        "tiktokAds": "Publicité TikTok",
        "aiMeme": "Mème IA",
        "aiAvatar": "Avatar IA",
        "logoAnimation": "Animation Logo",
        "socialShorts": "Shorts Sociaux",
        "brandStory": "Histoire de Marque",
        "tutorialClip": "Tutoriel",
        "musicVideo": "Clip Musical IA",
        "animeScene": "Scène Anime",
        "movieTrailer": "Bande-Annonce",
        "gameCinematic": "Cinématique Jeu",
        "visualPoetry": "Poésie Visuelle",
        "natureDoc": "Documentaire Nature",
        "cyberpunkCity": "Cité Cyberpunk",
        "underwaterWorld": "Monde Sous-Marin",
        "timelapseArt": "Art Timelapse",
        "dailyVlog": "Vlogs Quotidiens",
        "cookingShow": "Émission Cuisine",
        "fitnessCoach": "Coach Fitness",
        "travelDiary": "Journal de Voyage",
        "fashionShow": "Défilé de Mode",
        "petParadise": "Paradis Animalier",
        "weddingMoment": "Moment de Mariage",
        "yogaFlow": "Flux Yoga",
        "homeDecor": "Décoration Maison",
        "sunsetRun": "Course Coucher de Soleil",
        "instagramReels": "Instagram Reels",
        "youtubeIntro": "Intro YouTube",
        "linkedinPromo": "Promo LinkedIn",
        "aiThumbnail": "Vignette IA",
        "podcastClip": "Clip Podcast",
        "horrorShort": "Court Horreur",
        "danceVideo": "Vidéo Danse",
        "aiComic": "BD IA",
        "magicShow": "Spectacle de Magie",
        "fantasyWorld": "Monde Fantaisie",
        "diyCraft": "Bricolage DIY",
        "morningRoutine": "Routine Matinale",
        "babyGrowth": "Croissance Bébé",
        "streetFood": "Street Food",
        "bookTrailer": "Bande-Annonce Livre",
        "socialLuxuryBag": "Drop Sac de Luxe",
        "socialFashionVote": "Vote Mode",
        "socialSneakerDrop": "Sneakers Urbaines Premium",
        "socialTropicalCocktail": "Cocktail du Week-end",
        "socialCityBillboard": "Pub Panneau Urbain",
        "socialStreetwearDrop": "Drop Streetwear",
        "socialBoxingGloves": "Pub Gants de Boxe",
        "homeEclecticLiving": "Salon Éclectique",
        "homeFarmhouseKitchen": "Cuisine Fermière",
        "homeModernKitchen": "Cuisine Moderne Minimaliste",
        "homeVictorianStairs": "Escalier Victorien",
        "homeScandiLiving": "Salon Scandinave",
        "homeMediterraneanPatio": "Patio Méditerranéen",
        "homeBohoSunroom": "Véranda Bohème",
        "homeEclecticBedroom": "Chambre Éclectique",
        "comicPortrait": "BD Super-Héros",
        "animeCharacter": "Anime Mécha",
        "mangaScene": "Manga Nuit Pluvieuse",
        "comicOilPainting": "BD Quotidien",
        "comicCover": "BD Héros Énergétique",
        "animePortrait": "BD Saut sur les Toits",
        "comicCouple": "BD Jeune Héros",
        "mangaWarrior": "BD Sorcier"
      }
    }
  },
  "musicTags": {
    "pop": "Pop",
    "electronic": "Électronic",
    "classical": "Classique",
    "jazz": "Jazz"
  },
  "music": {
    "breadcrumb": {
      "home": "Accueil",
      "aiMusic": "Musique IA"
    },
    "model": {
      "label": "Modèle",
      "aiMusicName": "Musique IA",
      "desc": "Générer de la musique originale à partir de descriptions, prenant en charge divers styles et durées.",
      "tagMusic": "Génération musicale",
      "tagLyrics": "Création de paroles"
    },
    "mode": {
      "describe": "Décrire",
      "lyrics": "Écrire des paroles"
    },
    "form": {
      "musicDesc": "Description de la musique",
      "musicDescPlaceholder": "Décrivez le style musical, l'émotion et la scène que vous souhaitez...\n\nExemple : Une musique électronique entraînante avec des mélodies de synthé futuristes, adaptée aux vidéos promotionnelles de produits technologiques",
      "optimize": "Optimiser",
      "songTitle": "Titre de la chanson",
      "songTitlePlaceholder": "Entrez le titre de la chanson...",
      "lyricsDescLabel": "Description des paroles",
      "lyricsDescPlaceholder": "Rédigez la description de vos paroles ici...\n\nExemple :\n[Intro]\n...\n[Verse]\n...\n[Chorus]\n...",
      "styleTags": "Étiquettes de style",
      "styleTagsPlaceholder": "Cliquez sur les étiquettes ci-dessous pour ajouter (sélection multiple)"
    },
    "tags": {
      "sections": [
        {
          "label": "Couplet",
          "value": "[Verse]\n"
        },
        {
          "label": "Refrain",
          "value": "[Chorus]\n"
        },
        {
          "label": "Pont",
          "value": "[Bridge]\n"
        },
        {
          "label": "Intro",
          "value": "[Intro]\n"
        },
        {
          "label": "Outro",
          "value": "[Outro]\n"
        }
      ],
      "styles": [
        {
          "label": "Pop",
          "value": "Pop"
        },
        {
          "label": "Rock",
          "value": "Rock"
        },
        {
          "label": "Jazz",
          "value": "Jazz"
        },
        {
          "label": "Classical",
          "value": "Classical"
        },
        {
          "label": "Electronic",
          "value": "Electronic"
        },
        {
          "label": "R&B",
          "value": "R&B"
        },
        {
          "label": "Hip-Hop",
          "value": "Hip-Hop"
        },
        {
          "label": "Country",
          "value": "Country"
        },
        {
          "label": "Folk",
          "value": "Folk"
        },
        {
          "label": "Ambient",
          "value": "Ambient"
        },
        {
          "label": "Cinematic",
          "value": "Cinematic"
        },
        {
          "label": "Lo-fi",
          "value": "Lo-fi"
        },
        {
          "label": "Metal",
          "value": "Metal"
        },
        {
          "label": "Reggae",
          "value": "Reggae"
        },
        {
          "label": "Blues",
          "value": "Blues"
        },
        {
          "label": "Soul",
          "value": "Soul"
        },
        {
          "label": "Funk",
          "value": "Funk"
        },
        {
          "label": "Indie",
          "value": "Indie"
        }
      ]
    },
    "options": {
      "duration": "Durée",
      "instrumental": "Instrumental",
      "instrumentalDescOn": "Générer seulement l'accompagnement, sans voix",
      "instrumentalDescOff": "Inclure la performance vocale"
    },
    "errors": {
      "titleRequired": "Le titre de la chanson est obligatoire",
      "lyricsDescRequired": "La description des paroles est obligatoire"
    },
    "footer": {
      "creditsRequired": "Crédits requis :",
      "creditsLeft": "Restants :",
      "generate": "Générer la musique"
    },
    "preview": {
      "generating": "Génération de la musique...",
      "generatedTitle": "Musique générée",
      "emptyTitle": "Générateur de musique IA",
      "emptySubtitle": "Créez de la musique originale avec l'IA. Décrivez le style ou saisissez des paroles, et générez votre morceau en quelques secondes.",
      "emptyTags": [
        "Pop",
        "Jazz",
        "Cinematic",
        "Lo-fi",
        "Rock"
      ],
      "track": "Piste",
      "play": "Lecture",
      "pause": "Pause",
      "mute": "Couper le son",
      "unmute": "Réactiver le son",
      "download": "Télécharger",
      "showLyrics": "Afficher les paroles",
      "hideLyrics": "Masquer les paroles",
      "generateFailed": "Échec de la génération",
      "requestFailed": "Échec de la requête, veuillez réessayer",
      "downloadMp3": "Télécharger MP3",
      "downloadWav": "Télécharger WAV",
      "regenerate": "Régénérer",
      "noHistory": "Pas encore d'historique"
    },
    "intro": {
      "title": "Générateur de musique IA",
      "desc": "Grâce à la technologie IA avancée, saisissez simplement une description ou des paroles pour générer de la musique originale de haute qualité. Prend en charge plusieurs styles musicaux, adapté aux bandes sonores de vidéos, aux publicités, aux podcasts, etc.",
      "tagMusic": "Génération musicale",
      "tagLyrics": "Création de paroles",
      "tagStyles": "Multiples styles",
      "tagCommercial": "Licence commerciale"
    },
    "features": {
      "badge": "Fonctionnalités principales",
      "title": "Que peut faire le générateur de musique IA pour vous ?",
      "items": {
        "styles": {
          "icon": "🎵",
          "title": "Multiples styles",
          "desc": "Prend en charge la Pop, le Rock, l'Électronic, le Jazz, le Classique, le Hip-Hop et des dizaines de styles musicaux pour répondre à divers besoins créatifs."
        },
        "lyrics": {
          "icon": "📝",
          "title": "Création de paroles",
          "desc": "Saisissez des paroles pour générer des chansons complètes avec des repères de section (Couplet, Refrain, etc.), l'IA arrange et produit automatiquement la musique."
        },
        "vocals": {
          "icon": "🎤",
          "title": "Synthèse vocale",
          "desc": "Prend en charge les voix masculine et féminine avec divers timbres, l'IA chante vos paroles de manière naturelle et fluide."
        },
        "instrumental": {
          "icon": "🎹",
          "title": "Mode instrumental",
          "desc": "Génère un accompagnement instrumental de haute qualité, adapté aux bandes sonores de vidéos, à la musique de fond pour les podcasts, etc."
        },
        "fast": {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "Des modèles IA avancés assurent une production musicale rapide, la plupart des musiques pouvant être générées en 30 secondes."
        },
        "commercial": {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toute la musique générée peut être utilisée à des fins commerciales, notamment pour les vidéos, les publicités, les podcasts, etc."
        }
      }
    },
    "faq": {
      "title": "Questions fréquentes",
      "items": {
        "howItWorks": {
          "q": "Comment fonctionne le générateur de musique IA ?",
          "a": "Notre générateur de musique IA utilise des modèles d'apprentissage profond avancés pour créer de la musique originale basée sur vos descriptions textuelles ou paroles. Il suffit de saisir le style musical, l'émotion et la description de la scène, et l'IA composera automatiquement une pièce musicale complète."
        },
        "commercial": {
          "q": "La musique générée peut-elle être utilisée à des fins commerciales ?",
          "a": "Oui, toute la musique générée en utilisant notre plateforme peut être utilisée à des fins commerciales, y compris pour les vidéos YouTube, les publicités, les podcasts, les jeux, etc."
        },
        "styles": {
          "q": "Quels styles musicaux sont pris en charge ?",
          "a": "Nous prenons en charge la Pop, le Rock, l'Électronic, le Jazz, le Classique, le Hip-Hop, le R&B, le Country, le Metal, le Folk et des dizaines d'autres styles musicaux. Vous pouvez également combiner plusieurs styles pour créer de la musique unique."
        },
        "credits": {
          "q": "Combien de crédits coûte chaque génération ?",
          "a": "Selon le modèle sélectionné, chaque génération coûte 8-10 crédits. Vous pouvez obtenir de meilleurs taux de crédit grâce aux plans d'abonnement."
        },
        "download": {
          "q": "Puis-je télécharger la musique générée ?",
          "a": "Oui, la musique générée prend en charge les formats MP3 et WAV pour le téléchargement. Vous pouvez choisir le format approprié selon vos besoins."
        }
      }
    },
    "demoTracks": {
      "summerBreeze": {
        "title": "Brise estivale",
        "style": "Pop / Entraînant",
        "duration": "2:00"
      },
      "spaceJourney": {
        "title": "Voyage spatial",
        "style": "Électronic / Futuriste",
        "duration": "1:30"
      },
      "rainWalk": {
        "title": "Marche sous la pluie",
        "style": "Jazz / Décontracté",
        "duration": "2:30"
      },
      "mountainDawn": {
        "title": "Aube montagneuse",
        "style": "Classique / Paisible",
        "duration": "3:00"
      }
    }
  },
  "pricing": {
    "title": "Inspiration illimitée, choisissez le plan qui vous convient le mieux",
    "subtitle": "Débloquez tous les modèles IA, générez des images, vidéos et musiques par lots.",
    "promo": "Offre limitée — Économisez 30 % sur les plans annuels",
    "monthly": "Mensuel",
    "yearly": "Annuel",
    "yearlyNote": "Plan annuel — crédits livrés en une seule fois, paiement unique plus économique",
    "popular": "Plus populaire",
    "currentPlan": "Plan actuel",
    "currentPlanBtn": "Plan actuel",
    "upgrade": "Mise à niveau",
    "unavailable": "Indisponible",
    "upgradeSuccess": "Mise à niveau réussie !",
    "upgradeFailed": "Échec de la mise à niveau",
    "upgradeModal": {
      "title": "Confirmer la mise à niveau",
      "item1": "Nous facturerons la différence sur votre carte.",
      "item2": "Après un paiement réussi, le solde supplémentaire sera automatiquement ajouté.",
      "item3": "Le nouveau plan prendra effet après un paiement réussi.",
      "tip": "Conseil : Veuillez vous assurer que votre méthode de paiement est valide. Après un paiement réussi, le solde augmentera en quelques secondes.",
      "cancel": "Annuler",
      "confirm": "Confirmer la mise à niveau"
    },
    "subscribe": "S'abonner maintenant",
    "processing": "Traitement en cours...",
    "creditsPer": "crédits /",
    "extraCredits": "crédits supplémentaires",
    "creditsRate": "100 crédits = $",
    "perMonth": "mois",
    "perYear": "année",
    "yearlyBilling": "Facturé annuellement",
    "saveVsMonthly": "Économisez par rapport au mensuel :",
    "planDesc": {
      "basic": "Parfait pour bien commencer",
      "pro": "Meilleur pour les créateurs et professionnels",
      "ultimate": "Pour les équipes et les utilisateurs avancés"
    },
    "creditsPack": {
      "title": "Acheter un pack de crédits",
      "subtitle": "Achat unique, pas d'abonnement",
      "buy": "Acheter des crédits",
      "oneTime": "Achat unique",
      "permanent": "Les crédits n'expirent jamais",
      "tip": "Astuce : Les abonnements ont une meilleure valeur",
      "tipItems": [
        "Taux de crédit inférieurs (économisez 40-60 %)",
        "15 % de réduction sur tous les packs de crédits"
      ]
    },
    "security": {
      "noTraining": "Non utilisé pour l'entraînement IA",
      "encrypted": "Stockage crypté",
      "gdpr": "Conformité RGPD",
      "delete": "Suppression de compte en libre-service"
    },
    "dataSafety": "En savoir plus sur notre engagement en matière de sécurité des données →",
    "allPlansInclude": "Tous les plans incluent",
    "includes": {
      "models": "Modèles IA premium",
      "fast": "Génération rapide",
      "privacy": "100 % de confidentialité",
      "commercial": "Utilisation commerciale"
    },
    "creditsInfo": {
      "title": "Guide des crédits",
      "subtitle": "Voir la consommation de crédits pour tous les modèles",
      "model": "Modèle",
      "type": "Type",
      "cost": "Coût en crédits",
      "speed": "Vitesse",
      "image": "Image",
      "video": "Vidéo"
    },
    "questions": "Des questions ?",
    "contact": "Besoin d'aide ?",
    "contactUs": "Nous contacter",
    "faq": {
      "items": [
        {
          "q": "Qu'est-ce que je peux créer avec des crédits ?",
          "a": "Les crédits peuvent être utilisés pour générer des images, vidéos et musiques IA. La génération d'image commence à 2 crédits, la génération de vidéo à 10 crédits et la musique à 10 crédits par piste. Les modèles premium peuvent consommer plus de crédits."
        },
        {
          "q": "Puis-je annuler à tout moment ?",
          "a": "Oui, vous pouvez annuler votre abonnement à tout moment. Vous pouvez continuer à utiliser le service jusqu'à la fin de votre période de facturation en cours."
        },
        {
          "q": "Et si je manque de crédits ?",
          "a": "Vous pouvez acheter des packs de crédits ponctuels à tout moment (aucun abonnement nécessaire). Les abonnés bénéficient de 15 % de réduction sur les packs de crédits. Vous pouvez également mettre à niveau votre plan pour bénéficier de meilleurs taux sur les quotas mensuels."
        },
        {
          "q": "Y a-t-il une politique de remboursement ?",
          "a": "Oui. Pour les premiers achats de packs ponctuels ou les premiers abonnements, vous pouvez demander un remboursement dans les 7 jours calendrier si l'utilisation des crédits est inférieure à 3 %."
        }
      ]
    }
  },
  "modelDetail": {
    "breadcrumb": {
      "home": "Accueil",
      "models": "Modèles"
    },
    "model": "Modèle",
    "modelVersion": "Version du modèle",
    "standard": "Standard",
    "pro": "Pro",
    "standardDesc": "Qualité standard, génération rapide",
    "proDesc": "Haute qualité, prend en charge la haute résolution",
    "credits": "crédits",
    "imagePrompt": "Invite d'image",
    "imagePromptPlaceholder": "Décrivez l'image que vous souhaitez générer...",
    "videoPrompt": "Invite de vidéo",
    "videoPromptPlaceholder": "Décrivez la vidéo que vous souhaitez générer...",
    "referenceImage": "Image de référence",
    "aspectRatio": "Format d'image",
    "thinkingLevel": "Niveau de réflexion",
    "thinkingMinimal": "Faible latence",
    "thinkingHigh": "Haute fidélité",
    "characters": "caractères",
    "imageSize": "Taille de l'image",
    "auto": "Auto",
    "resolution": "Résolution",
    "duration": "Durée",
    "seconds": "secondes",
    "creditsRequired": "Crédits requis :",
    "remaining": "Restants :",
    "getMoreCredits": "Obtenir plus de crédits",
    "generate": "Générer",
    "generating": "Génération en cours...",
    "demoPrompt": "Invite de démonstration",
    "modelLabel": "Modèle :",
    "version": "Version :",
    "size": "Taille :",
    "download": "Télécharger",
    "regenerate": "Régénérer",
    "noHistory": "Aucun historique de génération",
    "features": {
      "badge": "Fonctionnalités principales",
      "title": "Que peut faire ce modèle ?",
      "items": {
        "realistic": {
          "icon": "📷",
          "title": "Style réaliste",
          "desc": "Générer des images photoréalistes avec un éclairage naturel et des détails."
        },
        "artistic": {
          "icon": "🎨",
          "title": "Style artistique",
          "desc": "Créer des images artistiques avec divers styles de peinture."
        },
        "portrait": {
          "icon": "👤",
          "title": "Portrait",
          "desc": "Photographie de portrait professionnelle avec des tons de peau naturels."
        },
        "landscape": {
          "icon": "🏔️",
          "title": "Paysage",
          "desc": "Photographie de paysages et de nature époustouflante."
        },
        "product": {
          "icon": "📦",
          "title": "Produit",
          "desc": "Photographie de produit de haute qualité pour le commerce électronique."
        },
        "fast": {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "La plupart des images sont générées en 10-30 secondes."
        },
        "highRes": {
          "icon": "🖼️",
          "title": "Haute résolution",
          "desc": "Prend en charge la sortie jusqu'à 4K."
        },
        "cinematic": {
          "icon": "🎬",
          "title": "Cinématique",
          "desc": "Créer des vidéos cinématographiques avec un travail de caméra professionnel."
        },
        "audioSync": {
          "icon": "🔊",
          "title": "Synchronisation audio",
          "desc": "Synchronisation audiovisuelle native pour les vidéos."
        },
        "lipSync": {
          "icon": "👄",
          "title": "Synchronisation labiale",
          "desc": "Synchronisation labiale précise pour les vidéos de personnages."
        },
        "animation": {
          "icon": "🎭",
          "title": "Animation",
          "desc": "Animation de personnages et mouvement fluides."
        },
        "longVideo": {
          "icon": "⏱️",
          "title": "Vidéo longue",
          "desc": "Prend en charge des durées vidéo plus longues."
        },
        "privacy": {
          "icon": "🔒",
          "title": "Privacy & security",
          "desc": "All data is encrypted in transit and not used for AI training. Your creations belong to you."
        }
      }
    },
    "faq": {
      "title": "Questions fréquentes",
      "items": [
        {
          "q": "Pour quoi ce modèle est-il le meilleur ?",
          "a": "Ce modèle excelle dans la génération d'images de haute qualité avec des détails réalistes et un éclairage naturel. Il est parfait pour la photographie de portrait, les images de produits et les créations artistiques."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "La version standard coûte 5 crédits par génération, tandis que la version Pro coûte 20 crédits pour des options de qualité et de résolution plus élevées."
        },
        {
          "q": "Quelles résolutions sont prises en charge ?",
          "a": "La version standard prend en charge jusqu'à 2K. La version Pro prend en charge jusqu'à 4K pour un maximum de détails."
        },
        {
          "q": "Combien de temps dure la génération ?",
          "a": "La plupart des images sont générées en 10-30 secondes selon la complexité et les paramètres de résolution."
        }
      ],
      "imageType": "images",
      "videoType": "videos",
      "imageFormats": "PNG, JPEG, and WebP output formats are supported; choose what fits your workflow.",
      "videoFormats": "Videos are delivered as MP4 with 480p and 720p options and multiple aspect ratios."
    },
    "qwenImage20Pro": {
      "negativePromptLabel": "Invite négative (facultatif)",
      "negativePromptPlaceholder": "Décrivez ce que vous ne voulez pas voir (par ex. faible netteté, mains déformées, etc.)",
      "customWidth": "Largeur",
      "customHeight": "Hauteur",
      "sizeHint": "Plage : 512×512 à 2048×2048",
      "sizeErrorRequired": "Veuillez saisir la largeur et la hauteur",
      "sizeErrorInteger": "La largeur et la hauteur doivent être des entiers",
      "sizeErrorRange": "La résolution doit être comprise entre 512×512 et 2048×2048",
      "promptEnhanceTitle": "Amélioration du prompt",
      "promptEnhanceDesc": "Renforcez les détails du prompt pour obtenir un rendu plus riche",
      "watermarkTitle": "Filigrane",
      "watermarkDesc": "Ajoute un filigrane aux images générées",
      "demoPromptText": "Parmi les montagnes enneigées, un petit garçon en combinaison de ski et lunettes glisse joyeusement ; la neige s'envole sur sa traînée, derrière lui s'étendent des crêtes couvertes de neige.",
      "faqSizeSupportQ": "Quelles résolutions sont prises en charge ?",
      "faqSizeSupportA": "Saisissez la largeur et la hauteur dans la plage 512~2048 (par ex. 2048*2048).",
      "faqMaxCountQ": "Combien d'images peut-on générer au maximum en une seule requête ?",
      "faqMaxCountA": "Jusqu'à 4 images (n=1..4).",
      "faqLinkUsageQ": "Comment utiliser les liens des images après la génération ?",
      "faqLinkUsageA": "Le système télécharge d'abord l'URL temporaire renvoyée par DashScope, l'envoie ensuite sur notre serveur, puis renvoie une URL accessible durablement."
    },
    "zImageTurbo": {
      "promptExtendTitle": "Amélioration du prompt",
      "promptExtendDesc": "Renforcez les détails du prompt pour obtenir un rendu plus riche",
      "customWidth": "Largeur",
      "customHeight": "Hauteur",
      "sizeHint": "Plage : 512×512 à 2048×2048",
      "sizeErrorRequired": "Veuillez saisir la largeur et la hauteur",
      "sizeErrorInteger": "La largeur et la hauteur doivent être des entiers",
      "sizeErrorRange": "La résolution doit être comprise entre 512×512 et 2048×2048",
      "seedLabel": "Graine",
      "seedErrorRequired": "Veuillez saisir une graine",
      "seedErrorInteger": "La graine doit être un entier",
      "seedErrorRange": "La graine doit être comprise entre 0 et 2147483647",
      "tagQuality": "Haute qualité",
      "tagOfficial": "Officiel direct",
      "tagHighRes": "Haute résolution",
      "tagSeed": "Contrôle du seed",
      "tagPromptExtend": "Amélioration du prompt",
      "feature1Title": "Sortie de haute qualité",
      "feature1Desc": "Générez des images haute résolution et téléversez-les pour obtenir des URL accessibles durablement.",
      "feature2Title": "Résolution personnalisée",
      "feature2Desc": "Saisissez largeur/hauteur dans la plage 512–2048.",
      "feature3Title": "Génération contrôlable",
      "feature3Desc": "Prend en charge seed et l'amélioration du prompt pour la reproductibilité et l'ajustement.",
      "demoPromptText": "Sur un sable doré fin, une suite nette d'empreintes s'enfonce dans l'image ; les bords gardent la texture humide des grains, la plage scintille au soleil et mène le regard vers un phare au loin.",
      "faqSizeSupportQ": "Quelles résolutions sont prises en charge ?",
      "faqSizeSupportA": "Saisissez la largeur et la hauteur dans la plage 512~2048 (par ex. 1024*1536).",
      "faqSeedQ": "À quoi sert la graine (seed) ?",
      "faqSeedA": "Avec le même prompt et les mêmes paramètres, la graine aide à reproduire des résultats similaires.",
      "faqPromptExtendQ": "Qu'est-ce que l'amélioration du prompt ?",
      "faqPromptExtendA": "Lorsqu'elle est activée, elle renforce les détails du prompt pour obtenir un rendu plus riche."
    },
    "creditsRemaining": "Remaining:",
    "whyChoose": {
      "items": [
        "Smart creation powered by {name}",
        "Complete complex creative tasks quickly and efficiently",
        "Generated content can be used commercially",
        "Continuous updates and improving capabilities",
        "Unified credit system, pay as you go"
      ]
    }
  },
  "modelIntro": {
    "common": {
      "videoMode": "Mode vidéo",
      "textToVideo": "Texte vers vidéo",
      "imageToVideo": "Image vers vidéo",
      "referenceImage": "Image de référence",
      "referenceAudio": "Audio de référence",
      "negativePrompt": "Prompt négatif",
      "duration": "Durée",
      "resolution": "Résolution",
      "aspectRatio": "Ratio d'aspect",
      "seed": "Graine",
      "generateAudio": "Générer l'audio",
      "watermark": "Ajouter un filigrane",
      "endFrame": "Image de fin",
      "promptEnhance": "Améliorer le prompt",
      "promptExtend": "Étendre le prompt",
      "imageSize": "Taille de l'image",
      "imageCount": "Nombre d'images",
      "style": "Style",
      "sizeMode": "Mode de taille",
      "width": "Largeur",
      "height": "Hauteur",
      "optional": "Facultatif",
      "uploading": "Téléchargement...",
      "clickToUpload": "Cliquez pour télécharger",
      "quality": "Qualité",
      "qualityAuto": "Auto",
      "qualityLow": "Basse",
      "qualityMedium": "Moyenne",
      "qualityHigh": "Haute",
      "multipleOf64Hint": "La largeur et la hauteur doivent être des multiples de 64."
    },
    "seegen": {
      "aspectAdaptive": "Auto",
      "genMode": "Mode de génération",
      "modeStand": "Standard",
      "modeSpeed": "Rapide"
    },
    "pollodance": {
      "variantLabel": "Variante du modèle",
      "card20": "2.0",
      "card20Fast": "2.0 FAST",
      "card20Ref": "2.0 REF",
      "card20FastRef": "2.0 FAST REF",
      "opt20Desc": "Contrôle du mouvement avancé, transfert de style cinéma et génération industrielle.",
      "opt20FastDesc": "Génération rapide et faible latence.",
      "opt20RefDesc": "Références entre vidéos, transfert de style et suivi du sujet.",
      "opt20FastRefDesc": "Rapidité et contrôle de référence précis.",
      "refImages": "Images de référence (plusieurs)",
      "refVideo": "Vidéo de référence",
      "refAudio": "Audio de référence",
      "webSearch": "Recherche web"
    },
    "nanoBanana": {
      "version": "Version du modèle",
      "title": "Générateur d'image IA Nano Banana Pro",
      "desc": "Nano Banana est un modèle de génération d'image IA haute performance qui prend en charge la génération d'images de style réaliste, excellant dans les portraits et les scènes naturelles. Disponible en versions Standard et Pro pour répondre à différents besoins.",
      "v25Type": "Faible latence",
      "v25TypeBadge": "Rapide",
      "v25TypeDesc": "Résolution fixe 1024px, vitesse de génération rapide",
      "v31Type": "Haute fidélité",
      "v31TypeBadge": "Haute qualité",
      "v31TypeDesc": "Prend en charge plusieurs résolutions 1K/2K/4K",
      "demoPrompt": "Portrait cinématique, lumière de l'heure dorée, texture de peau naturelle, fond bokeh doux",
      "multiSize": "Multiples tailles",
      "multiSizeDesc": "Prend en charge auto, 1:1, 4:3, 3:4, 16:9, 9:16, 3:2, 2:3 et autres tailles d'image.",
      "featuresDesc": "Nano Banana fournit des capacités de génération d'image de haute qualité avec plusieurs options de taille et de résolution.",
      "flexiblePricing": "Tarification flexible",
      "flexiblePricingDesc": "Standard 5 crédits, Pro 20 crédits, choisissez selon vos besoins.",
      "commercial": "Licence commerciale",
      "commercialDesc": "Toutes les images générées peuvent être utilisées à des fins commerciales.",
      "enterPrompt": "Veuillez entrer une invite",
      "generateFailed": "Échec de la génération",
      "requestFailed": "Échec de la requête, veuillez réessayer",
      "faq": [
        {
          "q": "Quelle est la différence entre les versions Standard et Pro ?",
          "a": "La version Standard convient à la génération rapide d'images de qualité standard, consommant 5 crédits. La version Pro prend en charge des résolutions plus élevées (1K/2K/4K) avec une meilleure qualité d'image, consommant 20 crédits."
        },
        {
          "q": "Comment fonctionne Nano Banana ?",
          "a": "Entrez simplement une description textuelle, et le modèle Nano Banana générera des images de style réaliste de haute qualité basées sur votre invite."
        },
        {
          "q": "Quelles tailles d'image sont prises en charge ?",
          "a": "Prend en charge auto, 1:1 (carré), 4:3, 3:4, 16:9 (paysage), 9:16 (portrait), 3:2, 2:3 et autres tailles."
        },
        {
          "q": "Les images générées peuvent-elles être utilisées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Nano Banana peut être utilisé à des fins commerciales."
        }
      ]
    },
    "nanoBanana2": {
      "genType": "Version de génération"
    },
    "seedream": {
      "title": "Générateur d'image IA Seedream 4",
      "desc": "Seedream 4 est un modèle avancé de génération d'image IA spécialisé dans les images artistiques et créatives. Parfait pour les illustrations, les arts conceptuels et les visuels stylisés.",
      "webSearch": "Recherche Web",
      "webSearchDesc": "Activer la recherche Web pour des informations de référence plus précises",
      "watermark": "Ajouter un filigrane",
      "watermarkDesc": "Ajouter un filigrane aux images générées",
      "sizeModeResolution": "Par résolution",
      "sizeModeCustom": "Taille personnalisée",
      "customWidth": "Largeur",
      "customHeight": "Hauteur",
      "sizeHint": "Surface 1024×1024–4096×4096, rapport d'aspect 1/16–16",
      "sizeErrorArea": "La surface doit être comprise entre 1024×1024 et 4096×4096",
      "sizeErrorRatio": "Le rapport d'aspect doit être compris entre 1/16 et 16",
      "demoPromptExample": "La lumière latérale de l'après-midi éclaire la tente de camping, la texture rugueuse de la toile est nettement visible. Un berger allemand est couché à l'intérieur ; son propriétaire s'accroupit pour lui serrer la patte.",
      "features": [
        {
          "icon": "🎨",
          "title": "Style artistique",
          "desc": "Générer des images artistiques époustouflantes avec divers styles de peinture et d'illustration."
        },
        {
          "icon": "🖼️",
          "title": "Haute résolution",
          "desc": "Prend en charge jusqu'à 4K pour des œuvres d'art détaillées."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "La plupart des images sont générées en 15 secondes."
        },
        {
          "icon": "🎭",
          "title": "Transfert de style",
          "desc": "Appliquer divers styles artistiques à vos créations."
        },
        {
          "icon": "📐",
          "title": "Multiples tailles",
          "desc": "Prend en charge divers rapports d'aspect pour différents besoins."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les images générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Pour quoi Seedream 4 est-il le meilleur ?",
          "a": "Seedream 4 excelle dans la génération d'images artistiques et créatives, notamment les illustrations, les arts conceptuels et les visuels stylisés."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "L'utilisation de Seedream 4 coûte 8 crédits par génération. Vous pouvez obtenir de meilleurs taux de crédit grâce aux plans d'abonnement."
        },
        {
          "q": "Quels styles sont pris en charge ?",
          "a": "Seedream 4 prend en charge divers styles artistiques, notamment la peinture à l'huile, l'aquarelle, l'art numérique, l'anime, etc."
        },
        {
          "q": "Les images générées peuvent-elles être utilisées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Seedream 4 peut être utilisé à des fins commerciales."
        }
      ]
    },
    "midjourney": {
      "title": "Générateur d'image IA Midjourney",
      "desc": "Midjourney est un modèle de génération d'image IA de premier plan connu pour sa qualité artistique exceptionnelle et ses capacités créatives. Parfait pour les œuvres d'art professionnelles et les projets créatifs.",
      "referenceBoxTitle": "Ajouter des images de référence pour l'image-vers-image",
      "referenceBoxSubtitle": "Prend en charge PNG, JPEG, WEBP (max 100 Ko). Jusqu'à 5 images. Moins d'images, résultats plus précis.",
      "demoPrompt": "Une île flottante mystique dans le ciel, anciennes ruines couvertes de cristaux lumineux, cascades tombant dans les nuages en contrebas, éclairage éthéré, style fantasy art",
      "referenceImages": "Images de référence",
      "referenceImagesCount": "Jusqu'à 5",
      "refImageMaxSize": "Chaque image ne doit pas dépasser 100 Ko",
      "style": "Style",
      "styleRealistic": "Réaliste",
      "styleAnime": "Anime",
      "generationSpeed": "Vitesse de génération",
      "fastDesc": "Génération à vitesse standard",
      "turboDesc": "Génération rapide, traitement prioritaire",
      "creative": "Créatif",
      "highQuality": "Haute qualité",
      "fastTurbo": "Rapide/Turbo",
      "creativeGeneration": "Génération créative",
      "speed": "Vitesse",
      "features": [
        {
          "icon": "🎨",
          "title": "Excellence artistique",
          "desc": "Qualité artistique et créativité de premier plan dans l'industrie."
        },
        {
          "icon": "🖼️",
          "title": "Haute résolution",
          "desc": "Générer des images de haute qualité adaptées à un usage professionnel."
        },
        {
          "icon": "🎭",
          "title": "Styles uniques",
          "desc": "Styles artistiques distinctifs qui démarquent votre travail."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "La plupart des images sont générées en 20 secondes."
        },
        {
          "icon": "📐",
          "title": "Multiples tailles",
          "desc": "Prend en charge divers rapports d'aspect et résolutions."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les images générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Quelle est la différence entre Rapide et Turbo ?",
          "a": "Le mode Rapide coûte 10 crédits avec vitesse standard. Le mode Turbo coûte 20 crédits avec génération plus rapide et traitement prioritaire."
        },
        {
          "q": "Comment fonctionne Midjourney ?",
          "a": "Entrez simplement une description textuelle, et Midjourney générera des images artistiques basées sur votre invite."
        },
        {
          "q": "Quelles tailles d'image sont prises en charge ?",
          "a": "Prend en charge 1:1 (carré), 4:3, 3:4, 16:9 (paysage), 9:16 (portrait), 3:2, 2:3 et autres tailles."
        },
        {
          "q": "Les images générées peuvent-elles être utilisées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Midjourney peut être utilisé à des fins commerciales."
        }
      ]
    },
    "gptImage": {
      "title": "Générateur d'image IA GPT-Image-1",
      "desc": "GPT-Image-1 est le modèle de génération d'image polyvalent d'OpenAI, capable de créer une grande variété d'images à partir de descriptions textuelles. Excellent pour la génération d'image à usage général.",
      "demoPromptExample": "Champs de Toscane au crépuscule, collines ondulantes couvertes de blé doré, cyprès et vieille ferme en pierre au loin, le coucher de soleil teintant le ciel d'une lueur rouge chaleureuse, chaleureux, apaisant, photographie de paysage, heure dorée.",
      "imageCount": "Nombre d'images",
      "promptEnhance": "Amélioration d'invite",
      "promptEnhanceDesc": "Optimiser automatiquement les invites pour de meilleurs résultats de génération",
      "count": "Nombre",
      "multiPurpose": "Polyvalent",
      "batchGeneration": "Génération par lots",
      "size1024Square": "1024×1024 (carré)",
      "size1536Landscape": "1536×1024 (paysage)",
      "size1024Portrait": "1024×1536 (portrait)",
      "threeSizes": "Trois tailles fixes",
      "tagQuality": "Haute qualité",
      "tagCommercialShort": "Usage commercial",
      "features": [
        {
          "icon": "🎨",
          "title": "Génération polyvalente",
          "desc": "Créer une grande variété d'images pour n'importe quel usage."
        },
        {
          "icon": "🖼️",
          "title": "Haute qualité",
          "desc": "Générer des images de haute qualité avec des détails précis."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "La plupart des images sont générées en 15 secondes."
        },
        {
          "icon": "📝",
          "title": "Compréhension du texte",
          "desc": "Excellente compréhension des descriptions textuelles complexes."
        },
        {
          "icon": "📐",
          "title": "Trois tailles fixes",
          "desc": "1024×1024 (carré), 1536×1024 (paysage), 1024×1536 (portrait)."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les images générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne GPT-Image-1 ?",
          "a": "Entrez simplement une description textuelle, et GPT-Image-1 générera des images de haute qualité basées sur votre invite."
        },
        {
          "q": "Quelles tailles d'image sont prises en charge ?",
          "a": "Trois tailles fixes : 1024×1024 (carré), 1536×1024 (paysage) et 1024×1536 (portrait)."
        },
        {
          "q": "Les images générées peuvent-elles être utilisées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant GPT-Image-1 peut être utilisé à des fins commerciales."
        }
      ]
    },
    "gptImage15": {
      "title": "Générateur d'image IA GPT-Image-1.5",
      "desc": "GPT-Image-1.5 est le modèle de génération d'image polyvalent d'OpenAI, capable de créer une grande variété d'images à partir de descriptions textuelles. Excellent pour la génération d'image à usage général.",
      "demoPromptExample": "Champs de Toscane au crépuscule, collines ondulantes couvertes de blé doré, cyprès et vieille ferme en pierre au loin, le coucher de soleil teintant le ciel d'une lueur rouge chaleureuse, chaleureux, apaisant, photographie de paysage, heure dorée.",
      "imageCount": "Nombre d'images",
      "promptEnhance": "Amélioration d'invite",
      "promptEnhanceDesc": "Optimiser automatiquement les invites pour de meilleurs résultats de génération",
      "count": "Nombre",
      "multiPurpose": "Polyvalent",
      "batchGeneration": "Génération par lots",
      "size1024Square": "1024×1024 (carré)",
      "size1536Landscape": "1536×1024 (paysage)",
      "size1024Portrait": "1024×1536 (portrait)",
      "threeSizes": "Trois tailles fixes",
      "tagQuality": "Haute qualité",
      "tagCommercialShort": "Usage commercial",
      "features": [
        {
          "icon": "🎨",
          "title": "Génération polyvalente",
          "desc": "Créer une grande variété d'images pour n'importe quel usage."
        },
        {
          "icon": "🖼️",
          "title": "Haute qualité",
          "desc": "Générer des images de haute qualité avec des détails précis."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "La plupart des images sont générées en 15 secondes."
        },
        {
          "icon": "📝",
          "title": "Compréhension du texte",
          "desc": "Excellente compréhension des descriptions textuelles complexes."
        },
        {
          "icon": "📐",
          "title": "Trois tailles fixes",
          "desc": "1024×1024 (carré), 1536×1024 (paysage), 1024×1536 (portrait)."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les images générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne GPT-Image-1.5 ?",
          "a": "Entrez simplement une description textuelle, et GPT-Image-1.5 générera des images de haute qualité basées sur votre invite."
        },
        {
          "q": "Quelles tailles d'image sont prises en charge ?",
          "a": "Trois tailles fixes : 1024×1024 (carré), 1536×1024 (paysage) et 1024×1536 (portrait)."
        },
        {
          "q": "Les images générées peuvent-elles être utilisées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant GPT-Image-1.5 peut être utilisé à des fins commerciales."
        }
      ]
    },
    "fluxKontext": {
      "title": "Générateur d'image IA Flux Kontext",
      "desc": "Découvrez la puissance de Flux Kontext : images photo-réalistes jusqu'en 2K, avec une esthétique et une qualité professionnelles.",
      "imageCount": "Nombre d'images",
      "count": "Nombre",
      "demoPrompt1": "À l'heure dorée, une jeune femme assise sur un toit, veste en jean oversize, écouteurs blancs autour du cou, sirotant un café glacé dans un gobelet en plastique transparent. Ses cheveux courts bouclés flottent légèrement dans le vent tandis que les lumières de la ville s'allument au loin.",
      "demoPrompt2": "Un homme vingtenaire assis sur le sol d'un atelier d'art en désordre, entouré de toiles inachevées et de tubes de peinture. Il porte un débardeur blanc taché de couleurs et un jean déchiré.",
      "demoPrompt3": "Une jeune mère ajustant le bonnet de son bébé assise sur une couverture de pique-nique. Elle porte un pull crème et une longue jupe en velours côtelé, pieds nus dans l'herbe.",
      "highQuality": "Haute qualité",
      "fastGen": "Génération rapide",
      "multiSize": "Multiples tailles",
      "outputStyle": "Style de sortie",
      "outputStyleDesc": {
        "auto": "Par défaut — le modèle détermine automatiquement le style, sans forcer un rendu",
        "photographic": "Photographique — photos réalistes, lumière et ombres naturelles",
        "digital_art": "Art digital — style CG/illustration, couleurs vives et riches",
        "anime": "Anime — style anime/cartoon japonais, lignes propres"
      },
      "outputStyleLabel": {
        "auto": "Par défaut",
        "photographic": "Photographique",
        "digital_art": "Art digital",
        "anime": "Anime"
      },
      "features": [
        {
          "icon": "✨",
          "title": "Sortie haute qualité",
          "desc": "Générer des images détaillées et fidèles."
        },
        {
          "icon": "🎨",
          "title": "Texte vers image",
          "desc": "Générer précisément des images à partir de descriptions textuelles."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "La plupart des images sont prêtes en environ 15 secondes."
        },
        {
          "icon": "📐",
          "title": "Multiples tailles",
          "desc": "Prise en charge des rapports 1:1, 3:2, 2:3."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Les images générées peuvent être utilisées commercialement."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne Flux Kontext ?",
          "a": "Saisissez une description textuelle ; Flux Kontext génère des images haute qualité et prend en charge une ou plusieurs images par requête."
        },
        {
          "q": "Quelles tailles d'image sont prises en charge ?",
          "a": "1:1 (carré), 3:2 (paysage), 2:3 (portrait)."
        },
        {
          "q": "Puis-je générer plusieurs images à la fois ?",
          "a": "Oui, vous pouvez générer 1 à 3 images, chacune facturée séparément."
        },
        {
          "q": "Les images générées peuvent-elles être utilisées commercialement ?",
          "a": "Oui, le contenu généré avec Flux Kontext peut être utilisé à des fins commerciales."
        }
      ]
    },
    "fluxPro11Ultra": {
      "title": "Générateur d'image IA Flux Pro 1.1 Ultra",
      "desc": "Flux Pro 1.1 Ultra pour du texte vers image haute qualité, plusieurs rapports d'aspect et génération par lots.",
      "imageCount": "Nombre d'images",
      "count": "Nombre",
      "demoPrompt1": "À l'heure dorée, une jeune femme assise sur un toit, veste en jean oversize, écouteurs blancs autour du cou, sirotant un café glacé dans un gobelet en plastique transparent. Ses cheveux courts bouclés flottent légèrement dans le vent tandis que les lumières de la ville s'allument au loin.",
      "demoPrompt2": "Un homme vingtenaire assis sur le sol d'un atelier d'art en désordre, entouré de toiles inachevées et de tubes de peinture. Il porte un débardeur blanc taché de couleurs et un jean déchiré.",
      "demoPrompt3": "Une jeune mère ajustant le bonnet de son bébé assise sur une couverture de pique-nique. Elle porte un pull crème et une longue jupe en velours côtelé, pieds nus dans l'herbe.",
      "highQuality": "Haute qualité",
      "fastGen": "Génération rapide",
      "multiSize": "Multiples tailles",
      "outputStyle": "Style de sortie",
      "outputStyleDesc": {
        "auto": "Par défaut — le modèle détermine automatiquement le style, sans forcer un rendu",
        "photographic": "Photographique — photos réalistes, lumière et ombres naturelles",
        "digital_art": "Art digital — style CG/illustration, couleurs vives et riches",
        "anime": "Anime — style anime/cartoon japonais, lignes propres"
      },
      "outputStyleLabel": {
        "auto": "Par défaut",
        "photographic": "Photographique",
        "digital_art": "Art digital",
        "anime": "Anime"
      },
      "features": [
        {
          "icon": "✨",
          "title": "Sortie haute qualité",
          "desc": "Générer des images détaillées et fidèles."
        },
        {
          "icon": "🎨",
          "title": "Texte vers image",
          "desc": "Générer précisément des images à partir de descriptions textuelles."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "La plupart des images sont prêtes en environ 15 secondes."
        },
        {
          "icon": "📐",
          "title": "Multiples tailles",
          "desc": "21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Les images générées peuvent être utilisées commercialement."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne Flux Pro 1.1 Ultra ?",
          "a": "Saisissez une description pour générer des images haute qualité ; 1 à 4 images par requête."
        },
        {
          "q": "Quelles tailles d'image sont prises en charge ?",
          "a": "21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "q": "Puis-je générer plusieurs images à la fois ?",
          "a": "Oui, 1 à 4 images, chacune facturée séparément."
        },
        {
          "q": "Les images générées peuvent-elles être utilisées commercialement ?",
          "a": "Oui, le contenu peut être utilisé à des fins commerciales."
        }
      ]
    },
    "fluxSchnell": {
      "title": "Générateur d'image IA Flux Schnell",
      "desc": "Flux Schnell pour un texte vers image rapide, plusieurs rapports d'aspect et génération par lots.",
      "imageCount": "Nombre d'images",
      "count": "Nombre",
      "demoPrompt1": "À l'heure dorée, une jeune femme assise sur un toit, veste en jean oversize, écouteurs blancs autour du cou, sirotant un café glacé dans un gobelet en plastique transparent. Ses cheveux courts bouclés flottent légèrement dans le vent tandis que les lumières de la ville s'allument au loin.",
      "demoPrompt2": "Un homme vingtenaire assis sur le sol d'un atelier d'art en désordre, entouré de toiles inachevées et de tubes de peinture. Il porte un débardeur blanc taché de couleurs et un jean déchiré.",
      "demoPrompt3": "Une jeune mère ajustant le bonnet de son bébé assise sur une couverture de pique-nique. Elle porte un pull crème et une longue jupe en velours côtelé, pieds nus dans l'herbe.",
      "highQuality": "Haute qualité",
      "fastGen": "Génération rapide",
      "multiSize": "Multiples tailles",
      "outputStyle": "Style de sortie",
      "outputStyleDesc": {
        "auto": "Par défaut — le modèle détermine automatiquement le style, sans forcer un rendu",
        "photographic": "Photographique — photos réalistes, lumière et ombres naturelles",
        "digital_art": "Art digital — style CG/illustration, couleurs vives et riches",
        "anime": "Anime — style anime/cartoon japonais, lignes propres"
      },
      "outputStyleLabel": {
        "auto": "Par défaut",
        "photographic": "Photographique",
        "digital_art": "Art digital",
        "anime": "Anime"
      },
      "features": [
        {
          "icon": "✨",
          "title": "Sortie haute qualité",
          "desc": "Générer des images détaillées et fidèles."
        },
        {
          "icon": "🎨",
          "title": "Texte vers image",
          "desc": "Générer précisément des images à partir de descriptions textuelles."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "La plupart des images sont prêtes en environ 15 secondes."
        },
        {
          "icon": "📐",
          "title": "Multiples tailles",
          "desc": "21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Les images générées peuvent être utilisées commercialement."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne Flux Schnell ?",
          "a": "Saisissez une description pour générer rapidement des images haute qualité ; 1 à 4 images par requête."
        },
        {
          "q": "Quelles tailles d'image sont prises en charge ?",
          "a": "21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "q": "Puis-je générer plusieurs images à la fois ?",
          "a": "Oui, 1 à 4 images, chacune facturée séparément."
        },
        {
          "q": "Les images générées peuvent-elles être utilisées commercialement ?",
          "a": "Oui, le contenu peut être utilisé à des fins commerciales."
        }
      ]
    },
    "flux2": {
      "title": "Générateur d'images IA FLUX.2",
      "desc": "FLUX.2 offre une efficacité entreprise et une précision professionnelle pour la génération d'images texte-vers-image avec des détails photoréalistes.",
      "variantLabel": "Variante du modèle",
      "variantDesc": {
        "klein-04": "Temps réel",
        "klein-09": "Équilibré",
        "max": "Haute qualité",
        "pro": "Production",
        "flex": "Personnalisable"
      },
      "promptUpsampling": "Suréchantillonnage du prompt",
      "promptUpsamplingHint": "Améliore les détails du prompt pour un rendu plus riche (non disponible pour Klein).",
      "steps": "Étapes",
      "stepsHint": "Plus d'étapes = plus de détails mais plus lent. Variante Flex uniquement.",
      "guidance": "Guidance",
      "guidanceHint": "Contrôle la fidélité au prompt. Variante Flex uniquement.",
      "tagPhotorealism": "Photoréalisme",
      "tagMultilingual": "Multilingue",
      "tagVariants": "5 Variantes",
      "demoPrompt1": "A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.",
      "features": [
        { "icon": "✨", "title": "Détails photoréalistes", "desc": "Mains, visages, tissus, logos et petits objets précis jusqu'à 4MP." },
        { "icon": "🎨", "title": "Typographie et design", "desc": "Rendu de typographie claire et lisible, respect des instructions de mise en page complexes." },
        { "icon": "🌍", "title": "Multilingue", "desc": "Support natif des prompts dans votre langue avec suivi d'instructions de pointe." },
        { "icon": "🎯", "title": "5 variantes", "desc": "Klein 4B/9B (rapidité), Max (qualité), Pro (production), Flex (contrôle personnalisé)." },
        { "icon": "⚙️", "title": "Contrôle flexible", "desc": "Étapes, guidance, taille et tolérance de sécurité ajustables." }
      ],
      "faq": [
        { "q": "Quelles sont les variantes FLUX.2 ?", "a": "FLUX.2 propose 5 variantes : Klein 4B et 9B (rapide), Max (qualité maximale avec recherche), Pro (production), Flex (étapes et guidance ajustables)." },
        { "q": "Quelles tailles d'image sont supportées ?", "a": "FLUX.2 utilise des dimensions en pixels (largeur x hauteur), multiples de 16. Presets : 1:1, 4:3, 3:4, 16:9, 9:16, 21:9, 9:21." },
        { "q": "Qu'est-ce que le suréchantillonnage du prompt ?", "a": "Active l'amélioration interne du prompt pour plus de détails. Disponible pour Max, Pro et Flex (pas Klein)." },
        { "q": "Que sont les étapes et le guidance en mode Flex ?", "a": "Étapes (1-50) : qualité d'inférence, plus élevé = plus de détails. Guidance (1.5-10) : fidélité au prompt, plus élevé = plus proche de la description." },
        { "q": "Les images peuvent-elles être utilisées commercialement ?", "a": "Oui, le contenu généré peut être utilisé à des fins commerciales." }
      ]
    },
    "seedance": {
      "title": "Générateur de vidéo IA Seedance",
      "desc": "Seedance est un modèle vidéo IA de nouvelle génération qui prend en charge la synchronisation audiovisuelle native, le mouvement cinématographique et l'expression émotionnelle. Couvre les modes texte-vers-vidéo, image-vers-vidéo et extension vidéo.",
      "textToVideo": "Texte vers vidéo",
      "imageToVideo": "Image vers vidéo",
      "videoExtend": "Extension vidéo",
      "uploadImage": "Cliquez pour télécharger l'image de référence",
      "uploadHint": "PNG, JPG, JPEG (max 20 Mo)",
      "endFrame": "Image de trame finale",
      "endFrameHint": "(Facultatif) Téléchargez la trame finale pour contrôler la fin de la vidéo",
      "uploadEndFrame": "Cliquez pour télécharger l'image de trame finale",
      "uploadVideo": "Cliquez pour télécharger la vidéo de référence",
      "uploadVideoHint": "MP4, MOV, WebM (max 100 Mo)",
      "videoPrompt": "Invite de vidéo",
      "promptPlaceholder": "Décrivez la vidéo que vous souhaitez générer...",
      "videoPromptPlaceholder": "Décrivez la vidéo que vous souhaitez générer...",
      "negativePrompt": "Invite négative",
      "negativePromptPlaceholder": "Décrivez ce que vous ne voulez pas dans la vidéo (facultatif)",
      "duration": "Durée",
      "videoDuration": "Durée de la vidéo",
      "resolution": "Résolution",
      "aspectRatio": "Ratio d'aspect",
      "promptEnhance": "Amélioration d'invite",
      "promptEnhanceDesc": "Optimiser automatiquement les invites pour de meilleurs résultats de génération",
      "generateAudio": "Générer l'audio",
      "audioOn": "Audio natif (voix + effets sonores)",
      "audioOff": "Vidéo uniquement, pas d'audio",
      "seedValue": "Graine (graine aléatoire)",
      "seedHint": "La valeur de seed est l'identifiant unique du style global. Utiliser la même seed permet de conserver le style, puis ajuster légèrement les autres paramètres pour optimiser les détails visuels.",
      "seedPlaceholder": "-1 (aléatoire)",
      "characters": "caractères",
      "creditsRequired": "Crédits requis :",
      "creditsRemaining": "Restants :",
      "remaining": "Restants :",
      "getMoreCredits": "Obtenir plus de crédits",
      "generate": "Générer",
      "generating": "Génération en cours...",
      "demoPrompt": "Invite de démonstration",
      "demoPromptExample": "Un chaton blanc doux et mignon danse joyeusement sur la pointe des pattes, son corps duveteux se balançant doucement avec de petites pattes roses levées. Sur un tapis moelleux sous une lumière jaune chaude, style cartoon apaisant, détails exquis, couleurs douces et délicates.",
      "modelLabel": "Modèle :",
      "durationLabel": "Durée :",
      "techSpecsTitle": "Spécifications techniques",
      "techSpecsDesc": "Seedance prend en charge la synchronisation audiovisuelle native, le mouvement cinématographique et l'expression émotionnelle. Couvre les modes texte-vers-vidéo, image-vers-vidéo et extension vidéo.",
      "t2vTitle": "Texte vers vidéo (T2V)",
      "t2vDesc": "Transformer les invites en scènes vidéo cinématographiques",
      "i2vTitle": "Image vers vidéo (I2V)",
      "i2vDesc": "Animer une seule image en utilisant l'IA",
      "input": "Entrée :",
      "textPrompt": "Invite textuelle",
      "imagePrompt": "Image + invite",
      "audio": "Audio :",
      "nativeAudio": "Génération audio native",
      "bestFor": "Idéal pour :",
      "t2vBestFor": "Parfait pour la création de contenu cinématographique, la publicité et les vidéos de médias sociaux.",
      "i2vBestFor": "Meilleur pour l'animation de portraits, les présentations de produits et le contenu créatif.",
      "featuresDesc": "Que vous soyez designer, marketeur, créateur de contenu ou utilisateur occasionnel, Seedance vous aide à créer rapidement du contenu IA de haute qualité.",
      "features": [
        {
          "icon": "🎬",
          "title": "Génération audiovisuelle native",
          "desc": "Générer simultanément vidéo et audio en un seul passage, offrant une qualité cinématographique. Synchro labiale naturelle et doublage de dialogue."
        },
        {
          "icon": "😊",
          "title": "Expression pilotée par les émotions",
          "desc": "Nouvelle performance sensible aux émotions pour des expressions faciales plus réalistes. Les expressions subtiles incluent l'hésitation, la tristesse, la tension ou la retenue émotionnelle."
        },
        {
          "icon": "🎥",
          "title": "Contrôle de caméra au niveau du réalisateur",
          "desc": "Prend en charge les mouvements de caméra push, pull, panoramique, orbite et suivi. Guidance de trame première et dernière pour des transitions fluides."
        },
        {
          "icon": "📱",
          "title": "Entrée multimodale",
          "desc": "Prend en charge le texte-vers-vidéo, l'image-vers-vidéo et d'autres flux de travail créatifs flexibles."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "Moteur d'inférence optimisé pour assurer une production rapide, la plupart des vidéos sont terminées en quelques minutes."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales, adaptées à la publicité, aux médias sociaux, etc."
        }
      ],
      "enterPrompt": "Veuillez entrer une invite",
      "imageRequired": "Le mode image-vers-vidéo nécessite une image de référence",
      "videoRequired": "Le mode extension vidéo nécessite une vidéo de référence",
      "generateFailed": "Échec de la génération",
      "requestFailed": "Échec de la requête, veuillez réessayer",
      "faq": [
        {
          "q": "Comment fonctionne Seedance ?",
          "a": "Vous pouvez télécharger une image de référence ou entrer une description textuelle directement, et le modèle Seedance générera du contenu vidéo de haute qualité basé sur vos instructions, avec un audio synchronisé. Le processus est simple et intuitif, ne nécessitant aucune compétence professionnelle."
        },
        {
          "q": "Les vidéos générées peuvent-elles être utilisées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Seedance peut être utilisé à des fins commerciales, y compris les matériaux marketing, les médias sociaux, les présentations de produits, etc."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "L'utilisation de Seedance coûte 18 crédits par génération. Vous pouvez obtenir de meilleurs taux de crédit grâce aux plans d'abonnement."
        },
        {
          "q": "Quelle est la vitesse de génération ?",
          "a": "La vitesse moyenne de génération de Seedance est d'environ 1,5 minute. Nous optimisons continuellement notre infrastructure pour garantir une génération rapide et stable."
        },
        {
          "q": "Quels formats de sortie sont pris en charge ?",
          "a": "Les vidéos sont sorties au format MP4, prenant en charge les résolutions 480p, 720p et 1080p, avec des durées de 5 ou 10 secondes, et plusieurs rapports d'aspect."
        }
      ]
    },
    "veo": {
      "title": "Générateur de vidéo IA Veo 3.1",
      "desc": "Google Veo 3.1 est un modèle vidéo IA d'état de l'art prenant en charge la génération audio native, la résolution ultra-haute et la création de longues vidéos. Parfait pour la production vidéo professionnelle.",
      "fastType": "Type rapide",
      "fastTypeBadge": "Vitesse rapide, coût inférieur",
      "fastTypeDesc": "(Prend en charge les images de référence 16:9)",
      "qualityType": "Type qualité",
      "qualityTypeBadge": "Détails plus riches",
      "qualityTypeDesc": "Mouvement plus fluide. La trame finale est facultative en mode image pour contrôler la dernière trame.",
      "imageMode": "Mode de génération",
      "startEndFrames": "Trames de début/fin",
      "referenceImage": "Image de référence",
      "startFrame": "Trame de début",
      "startFrameHint": "Définir la première trame. La vidéo s'anime depuis cette trame.",
      "uploadStartFrame": "Cliquez pour télécharger la trame de début",
      "endFrame": "Trame de fin",
      "endFrameHint": "Définir la dernière trame. La vidéo se termine à cette trame.",
      "uploadEndFrame": "Cliquez pour télécharger la trame de fin",
      "negativePrompt": "Invite négative",
      "negativePromptPlaceholder": "Décrivez ce que vous ne voulez pas dans la vidéo...",
      "features": [
        {
          "icon": "🎬",
          "title": "Génération audio native",
          "desc": "Générer simultanément vidéo et audio, y compris dialogue et effets sonores."
        },
        {
          "icon": "📺",
          "title": "Résolution Ultra HD",
          "desc": "Prend en charge la sortie jusqu'à 4K pour une production vidéo professionnelle."
        },
        {
          "icon": "⏱️",
          "title": "Support de longue vidéo",
          "desc": "Générer des vidéos jusqu'à 2 minutes, adaptées à divers besoins créatifs."
        },
        {
          "icon": "🎥",
          "title": "Mouvement cinématographique",
          "desc": "Mouvements de caméra professionnels et transitions fluides."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "Moteur d'inférence optimisé pour une production rapide."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Quelle est la différence entre les types Rapide et Qualité ?",
          "a": "Le type Rapide est plus rapide et moins coûteux, adapté à l'itération rapide. Le type Qualité produit des détails plus riches et un mouvement plus fluide, idéal pour la sortie finale."
        },
        {
          "q": "Comment fonctionne Veo 3.1 ?",
          "a": "Entrez une description textuelle ou téléchargez une image de référence, et Veo 3.1 générera du contenu vidéo de haute qualité basé sur vos instructions, éventuellement avec un audio synchronisé."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "L'utilisation de Veo 3.1 coûte 30 crédits par génération. Vous pouvez obtenir de meilleurs taux de crédit grâce aux plans d'abonnement."
        },
        {
          "q": "Quelles résolutions et durées sont prises en charge ?",
          "a": "Prend en charge les résolutions 720p et 1080p, avec des durées de 5s, 10s et jusqu'à 2 minutes pour les vidéos plus longues."
        }
      ]
    },
    "veo30": {
      "title": "Générateur de vidéo IA Veo 3.0",
      "desc": "Google Veo 3.0 est un modèle vidéo IA avancé prenant en charge le texte-vers-vidéo et l'image-vers-vidéo, avec 4s/6s/8s de durée et sortie 720p/1080p.",
      "fastType": "Type rapide",
      "fastTypeBadge": "Plus rapide, coût inférieur",
      "fastTypeDesc": "(Prend en charge l'image de référence 16:9)",
      "qualityType": "Type qualité",
      "qualityTypeBadge": "Détails plus riches",
      "qualityTypeDesc": "Mouvement plus fluide. La trame finale en mode image est facultative pour contrôler la dernière trame.",
      "imageMode": "Mode image",
      "startEndFrames": "Trame de début/fin",
      "referenceImage": "Image de référence",
      "referenceImageHint": "Téléchargez une image de référence ; la vidéo sera générée à partir de celle-ci.",
      "uploadReferenceImage": "Cliquez pour télécharger l'image de référence",
      "startFrame": "Trame de début",
      "startFrameHint": "Définir la première trame. La vidéo s'anime depuis cette trame.",
      "uploadStartFrame": "Cliquez pour télécharger la trame de début",
      "endFrame": "Trame de fin",
      "endFrameHint": "Définir la dernière trame. La vidéo se termine à cette trame.",
      "uploadEndFrame": "Cliquez pour télécharger la trame de fin",
      "negativePrompt": "Invite négative",
      "negativePromptPlaceholder": "Décrivez ce que vous ne voulez pas dans la vidéo...",
      "seedRangeError": "La graine doit être un entier entre 0 et 2147483647.",
      "duration": "Durée",
      "resolution": "Résolution",
      "demoPrompt": "Une adolescente dessinant dans un carnet à une fenêtre de café, la pluie tapotant sur la vitre...",
      "features": [
        {
          "icon": "🎬",
          "title": "Génération audio native",
          "desc": "Générer simultanément vidéo et audio, y compris dialogue et effets sonores."
        },
        {
          "icon": "📺",
          "title": "Résolution HD",
          "desc": "Prend en charge la sortie 720p et 1080p pour une production vidéo professionnelle."
        },
        {
          "icon": "⏱️",
          "title": "Multiples durées",
          "desc": "Prend en charge la génération de vidéos de 4s, 6s et 8s."
        },
        {
          "icon": "🎥",
          "title": "Mouvement cinématographique",
          "desc": "Mouvements de caméra professionnels et transitions fluides."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "Moteur d'inférence optimisé pour une production rapide."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Quelle est la différence entre les types Rapide et Qualité ?",
          "a": "Le type Rapide est plus rapide et moins coûteux, adapté à l'itération rapide. Le type Qualité produit des détails plus riches et un mouvement plus fluide, idéal pour la sortie finale."
        },
        {
          "q": "Comment fonctionne Veo 3.0 ?",
          "a": "Entrez une description textuelle ou téléchargez une image de référence, et Veo 3.0 générera du contenu vidéo de haute qualité basé sur vos instructions, éventuellement avec un audio synchronisé."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "L'utilisation de Veo 3.0 coûte 25 crédits par génération. Vous pouvez obtenir de meilleurs taux de crédit grâce aux plans d'abonnement."
        },
        {
          "q": "Quelles résolutions et durées sont prises en charge ?",
          "a": "Prend en charge les résolutions 720p et 1080p, avec des durées de 4s, 6s ou 8s."
        }
      ]
    },
    "veo31fast": {
      "title": "Générateur de vidéo IA Veo 3.1 Rapide",
      "desc": "Google Veo 3.1 Rapide pour une génération plus rapide, prenant en charge le texte-vers-vidéo et l'image-vers-vidéo avec trame finale facultative, 4s/6s/8s de durée et sortie 720p/1080p/4K.",
      "referenceImage": "Image de référence",
      "referenceImageHint": "Téléchargez une image de référence ; la vidéo sera générée à partir de celle-ci.",
      "uploadReferenceImage": "Cliquez pour télécharger l'image de référence",
      "endFrame": "Trame finale",
      "endFrameHint": "Facultatif. Définissez l'image pour la dernière trame de la vidéo pour contrôler la fin.",
      "uploadEndFrame": "Cliquez pour télécharger la trame finale",
      "duration": "Durée",
      "resolution": "Résolution",
      "seedRangeError": "La graine doit être un entier entre 0 et 2147483647.",
      "demoPrompt": "Une adolescente dessinant dans un carnet à une fenêtre de café, la pluie tapotant sur la vitre...",
      "features": [
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "Optimisé pour une sortie plus rapide."
        },
        {
          "icon": "📺",
          "title": "Résolution 4K",
          "desc": "Prend en charge les sorties 720p, 1080p et 4K."
        },
        {
          "icon": "⏱️",
          "title": "Multiples durées",
          "desc": "Prend en charge les vidéos de 4s, 6s et 8s."
        },
        {
          "icon": "🖼️",
          "title": "Trame finale facultative",
          "desc": "L'image-vers-vidéo peut télécharger une trame finale pour contrôler la fin."
        },
        {
          "icon": "🎥",
          "title": "Mouvement cinématographique",
          "desc": "Mouvements de caméra professionnels et transitions fluides."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Quelle est la différence entre Veo 3.1 Rapide et Veo 3.1 ?",
          "a": "Veo 3.1 Rapide est optimisé pour la vitesse et un coût de crédit inférieur, avec support 4K et trame finale facultative."
        },
        {
          "q": "Qu'est-ce que la trame finale ?",
          "a": "Pour l'image-vers-vidéo, vous pouvez télécharger une image de trame finale afin que la vidéo se termine sur cette trame, vous donnant le contrôle sur la fin."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "L'utilisation de Veo 3.1 Rapide coûte 20 crédits par génération."
        },
        {
          "q": "Quelles résolutions et durées sont prises en charge ?",
          "a": "Prend en charge les résolutions 720p, 1080p et 4K, avec des durées de 4s, 6s ou 8s."
        }
      ]
    },
    "kling": {
      "title": "Générateur de vidéo IA Kling 2.6",
      "desc": "Kling 2.6 est un modèle vidéo IA haute performance prenant en charge le texte-vers-vidéo et l'image-vers-vidéo, avec une excellente qualité de mouvement et une vitesse de génération rapide.",
      "features": [
        {
          "icon": "🎬",
          "title": "Mouvement haute qualité",
          "desc": "Mouvement fluide et naturel avec une sortie de qualité professionnelle."
        },
        {
          "icon": "📱",
          "title": "Multiples rapports d'aspect",
          "desc": "Prend en charge 1:1, 16:9, 9:16 et autres rapports d'aspect."
        },
        {
          "icon": "🔊",
          "title": "Génération audio",
          "desc": "Génération audio native facultative pour une expérience vidéo complète."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "La plupart des vidéos sont générées en 2 minutes."
        },
        {
          "icon": "🖼️",
          "title": "Image vers vidéo",
          "desc": "Animer des images statiques avec un mouvement alimenté par l'IA."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne Kling 2.6 ?",
          "a": "Entrez une description textuelle ou téléchargez une image de référence, et Kling 2.6 générera du contenu vidéo de haute qualité basé sur vos instructions."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "L'utilisation de Kling 2.6 coûte 28 crédits par génération. Vous pouvez obtenir de meilleurs taux de crédit grâce aux plans d'abonnement."
        },
        {
          "q": "Quelles résolutions et durées sont prises en charge ?",
          "a": "Prend en charge les résolutions 720p et 1080p, avec des durées de 5s et 10s."
        },
        {
          "q": "Puis-je utiliser les vidéos générées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Kling 2.6 peut être utilisé à des fins commerciales."
        }
      ]
    },
    "kling3": {
      "title": "Générateur de vidéo IA Kling 3.0",
      "desc": "Kling 3.0 est un modèle vidéo IA haute performance prenant en charge le texte-vers-vidéo et l'image-vers-vidéo, avec une excellente qualité de mouvement et une vitesse de génération rapide.",
      "features": [
        {
          "icon": "🎬",
          "title": "Mouvement haute qualité",
          "desc": "Mouvement fluide et naturel avec une sortie de qualité professionnelle."
        },
        {
          "icon": "📱",
          "title": "Multiples rapports d'aspect",
          "desc": "Prend en charge 1:1, 16:9, 9:16 et autres rapports d'aspect."
        },
        {
          "icon": "🔊",
          "title": "Génération audio",
          "desc": "Génération audio native facultative pour une expérience vidéo complète."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "La plupart des vidéos sont générées en 2 minutes."
        },
        {
          "icon": "🖼️",
          "title": "Image vers vidéo",
          "desc": "Animer des images statiques avec un mouvement alimenté par l'IA."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne Kling 3.0 ?",
          "a": "Entrez une description textuelle ou téléchargez une image de référence, et Kling 3.0 générera du contenu vidéo de haute qualité basé sur vos instructions."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "L'utilisation de Kling 3.0 coûte 28 crédits par génération. Vous pouvez obtenir de meilleurs taux de crédit grâce aux plans d'abonnement."
        },
        {
          "q": "Quelles résolutions et durées sont prises en charge ?",
          "a": "Prend en charge les résolutions 720p et 1080p, avec des durées de 5s et 10s."
        },
        {
          "q": "Puis-je utiliser les vidéos générées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Kling 3.0 peut être utilisé à des fins commerciales."
        }
      ]
    },
    "sora": {
      "title": "Générateur de vidéo IA Sora 2",
      "desc": "Sora 2 est le modèle vidéo IA avancé d'OpenAI, capable de générer des vidéos de haute qualité avec un mouvement réaliste et une qualité cinématographique.",
      "demoPromptExample": "@sama : le PDG d'OpenAI, Sam, présente ce meuble (cabinet), expliquant qu'il a le même chez lui et qu'il est très pratique.",
      "landscape": "Paysage",
      "portrait": "Portrait",
      "removeWatermark": "Supprimer le filigrane",
      "enabled": "Activé",
      "disabled": "Désactivé",
      "noWatermark": "Aucun filigrane",
      "cinematic": "Qualité cinématographique",
      "restrictedAccess": "Accès restreint",
      "60secDuration": "Durée 4 s / 8 s / 12 s",
      "photorealistic": "Photoréaliste",
      "physicsSimulation": "Simulation physique",
      "features": [
        {
          "icon": "🎬",
          "title": "Qualité cinématographique",
          "desc": "Générer des vidéos avec un look et un ressenti cinématographiques professionnels."
        },
        {
          "icon": "🎥",
          "title": "Mouvement réaliste",
          "desc": "Mouvement naturel et réaliste pour les personnages et les scènes."
        },
        {
          "icon": "⏱️",
          "title": "Durée flexible",
          "desc": "Prend en charge diverses longueurs de vidéo pour différents besoins."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "Optimisé pour une production vidéo rapide."
        },
        {
          "icon": "🖼️",
          "title": "Entrée multimodale",
          "desc": "Prend en charge les modes texte-vers-vidéo et image-vers-vidéo."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne Sora 2 ?",
          "a": "Entrez une description textuelle ou téléchargez une image de référence, et Sora 2 générera du contenu vidéo de haute qualité basé sur vos instructions."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "L'utilisation de Sora 2 coûte 15 crédits par génération. Vous pouvez obtenir de meilleurs taux de crédit grâce aux plans d'abonnement."
        },
        {
          "q": "Qu'est-ce qui rend Sora 2 spécial ?",
          "a": "Sora 2 excelle dans la génération de vidéos avec un mouvement réaliste et une qualité cinématographique, ce qui le rend idéal pour la création de contenu professionnel."
        },
        {
          "q": "Puis-je utiliser les vidéos générées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Sora 2 peut être utilisé à des fins commerciales."
        }
      ]
    },
    "wan": {
      "title": "Générateur de vidéo IA Wan",
      "desc": "Wan est un modèle vidéo IA polyvalent prenant en charge le texte-vers-vidéo et l'image-vers-vidéo avec une excellente qualité et vitesse.",
      "multiFormat": "Multiples formats",
      "smoothMotion": "Mouvement fluide",
      "referenceAudio": "Audio de référence",
      "uploadAudio": "Cliquez pour télécharger l'audio de référence",
      "uploadAudioHint": "MP3, WAV, M4A (facultatif, pilote la bande sonore de la vidéo)",
      "features": [
        {
          "icon": "🎬",
          "title": "Sortie haute qualité",
          "desc": "Générer des vidéos de qualité professionnelle à partir de texte ou d'images."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "Production vidéo rapide pour un flux de travail efficace."
        },
        {
          "icon": "📱",
          "title": "Multiples formats",
          "desc": "Prend en charge divers rapports d'aspect et résolutions."
        },
        {
          "icon": "🖼️",
          "title": "Animation d'image",
          "desc": "Donnez vie aux images statiques avec le mouvement IA."
        },
        {
          "icon": "🎥",
          "title": "Mouvement fluide",
          "desc": "Mouvement naturel et fluide dans les vidéos générées."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne Wan ?",
          "a": "Entrez une description textuelle ou téléchargez une image de référence, et Wan générera du contenu vidéo de haute qualité basé sur vos instructions."
        },
        {
          "q": "Quelle version Wan dois-je utiliser ?",
          "a": "Wan 2.5 et 2.6 offrent les dernières fonctionnalités et la meilleure qualité. Wan 2.2 est une option rentable pour les projets plus simples."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "Wan 2.6 coûte 70 crédits, Wan 2.5 coûte 60 crédits, et Wan 2.2 coûte 10 crédits par génération."
        },
        {
          "q": "Puis-je utiliser les vidéos générées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Wan peut être utilisé à des fins commerciales."
        }
      ]
    },
    "wan25": {
      "title": "Générateur de vidéo IA Wan 2.5",
      "desc": "Wan 2.5 est un modèle vidéo IA polyvalent prenant en charge le texte-vers-vidéo et l'image-vers-vidéo avec une excellente qualité et vitesse.",
      "features": [
        {
          "icon": "🎬",
          "title": "Sortie haute qualité",
          "desc": "Générer des vidéos de qualité professionnelle à partir de texte ou d'images."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "Production vidéo rapide pour un flux de travail efficace."
        },
        {
          "icon": "📱",
          "title": "Multiples formats",
          "desc": "Prend en charge divers rapports d'aspect et résolutions."
        },
        {
          "icon": "🖼️",
          "title": "Animation d'image",
          "desc": "Donnez vie aux images statiques avec le mouvement IA."
        },
        {
          "icon": "🎥",
          "title": "Mouvement fluide",
          "desc": "Mouvement naturel et fluide dans les vidéos générées."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne Wan 2.5 ?",
          "a": "Entrez une description textuelle ou téléchargez une image de référence, et Wan 2.5 générera du contenu vidéo de haute qualité basé sur vos instructions."
        },
        {
          "q": "Quelle est la différence entre Wan 2.5 et Wan 2.6 ?",
          "a": "Wan 2.6 offre des améliorations supplémentaires en qualité et stabilité ; Wan 2.5 est rentable et adapté à la plupart des cas d'utilisation."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "Wan 2.5 coûte 60 crédits par génération."
        },
        {
          "q": "Puis-je utiliser les vidéos générées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Wan 2.5 peut être utilisé à des fins commerciales."
        }
      ]
    },
    "wan26": {
      "title": "Générateur de vidéo IA Wan 2.6",
      "desc": "Wan 2.6 est un modèle vidéo IA amélioré avec une qualité et une stabilité accrues, prenant en charge le texte-vers-vidéo et l'image-vers-vidéo.",
      "features": [
        {
          "icon": "🎬",
          "title": "Sortie haute qualité",
          "desc": "Générer des vidéos de qualité professionnelle à partir de texte ou d'images avec une qualité améliorée."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "Production vidéo rapide pour un flux de travail efficace."
        },
        {
          "icon": "📱",
          "title": "Multiples formats",
          "desc": "Prend en charge divers rapports d'aspect et résolutions."
        },
        {
          "icon": "🖼️",
          "title": "Animation d'image",
          "desc": "Donnez vie aux images statiques avec le mouvement IA."
        },
        {
          "icon": "🎥",
          "title": "Mouvement fluide",
          "desc": "Mouvement naturel et fluide dans les vidéos générées."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Quelle est la différence entre Wan 2.6 et Wan 2.5 ?",
          "a": "Wan 2.6 offre des améliorations supplémentaires en qualité et stabilité pour une sortie de qualité supérieure."
        },
        {
          "q": "Comment fonctionne Wan 2.6 ?",
          "a": "Entrez une description textuelle ou téléchargez une image de référence, et Wan 2.6 générera du contenu vidéo de haute qualité basé sur vos instructions."
        },
        {
          "q": "Combien de crédits chaque génération coûte-t-elle ?",
          "a": "Wan 2.6 coûte 70 crédits par génération."
        },
        {
          "q": "Puis-je utiliser les vidéos générées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Wan 2.6 peut être utilisé à des fins commerciales."
        }
      ]
    },
    "wan22": {
      "title": "Générateur vidéo IA Wan 2.2 Classic",
      "desc": "Wan 2.2 est un modèle vidéo IA classique pour texte-vers-vidéo et image-vers-vidéo, stable et économique.",
      "demoPromptExample": "Une fille aux petites taches de rousseur et aux cheveux rouges ébouriffés est assise sur un toit au coucher du soleil, veste en jean légèrement usée, un appareil Polaroid à la main, le panorama urbain luisant dans des teintes douces derrière elle.",
      "resolutionBadge": "720p",
      "classicVersion": "Version classique",
      "stableReliable": "Stable et fiable",
      "costEffective": "Économique",
      "features": [
        {
          "icon": "🎬",
          "title": "Texte/Image vers vidéo",
          "desc": "Prend en charge texte-vers-vidéo et image-vers-vidéo."
        },
        {
          "icon": "⚡",
          "title": "Résultats stables",
          "desc": "Modèle mature avec rendu prévisible."
        },
        {
          "icon": "💰",
          "title": "Coût réduit",
          "desc": "Consommation de crédits plus faible pour les usages fréquents."
        },
        {
          "icon": "📐",
          "title": "Ratios courants",
          "desc": "Prend en charge 16:9 et 9:16."
        },
        {
          "icon": "🎥",
          "title": "Sortie nette",
          "desc": "Qualité vidéo claire et régulière."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Le contenu généré peut être utilisé commercialement."
        }
      ],
      "faq": [
        {
          "q": "Quelle est la différence entre Wan 2.2 et Wan 2.5 ?",
          "a": "Wan 2.2 est plus adapté aux scénarios à volume élevé et coût maîtrisé ; Wan 2.5/2.6 offrent des capacités plus avancées."
        },
        {
          "q": "Comment fonctionne Wan 2.2 ?",
          "a": "Saisissez un prompt ou importez une image de référence, puis le modèle génère la vidéo."
        },
        {
          "q": "Puis-je utiliser les vidéos générées commercialement ?",
          "a": "Oui, les contenus Wan 2.2 peuvent être utilisés à des fins commerciales."
        }
      ]
    },
    "kling25": {
      "title": "Générateur vidéo IA Kling 2.5",
      "desc": "Kling 2.5 est un modèle vidéo IA standard prenant en charge le texte-vers-vidéo et l'image-vers-vidéo, offrant une génération vidéo stable et fiable avec un excellent rapport qualité-prix.",
      "standard": "Standard",
      "reliable": "Stable et fiable",
      "costEffective": "Rapport qualité-prix",
      "standardQuality": "Qualité standard",
      "textToVideo": "Texte vers vidéo",
      "imageToVideo": "Image vers vidéo",
      "referenceImage": "Image de référence",
      "referenceImageHint": "Cliquez pour télécharger ou glisser-déposer un fichier",
      "referenceImageFormats": "Prend en charge PNG, JPG, JPEG, WEBP (≤10MB), téléchargement URL uniquement",
      "endFrame": "Image de fin",
      "endFrameOptional": "Optionnel",
      "endFrameFormats": "PNG, JPG, JPEG",
      "endFrameHint": "Utilisé pour contraindre l'image de fin, fonctionne mieux avec le même rapport d'aspect que l'image de référence",
      "videoPrompt": "Prompt vidéo",
      "promptPlaceholder": "Décrivez la vidéo que vous souhaitez générer...",
      "negativePrompt": "Prompt négatif",
      "negativePromptPlaceholder": "Décrivez ce que vous ne voulez pas dans la vidéo...",
      "duration": "Durée",
      "aspectRatio": "Rapport d'aspect",
      "uploading": "Téléchargement...",
      "clickToUpload": "Cliquez pour télécharger",
      "clickToUploadReference": "Cliquez pour télécharger l'image de référence",
      "clickToUploadEndFrame": "Cliquez pour télécharger l'image de fin",
      "remove": "Supprimer",
      "creditsRequired": "Crédits requis :",
      "remaining": "Restants :",
      "generate": "Générer",
      "generating": "Génération en cours...",
      "demoPrompt": "Invite de démonstration",
      "demoPromptExample": "Utilisez l'image de ruelle sci-fi téléchargée comme première image. Gardez la même ruelle, les enseignes néon, les reflets et la femme à capuche qui s'éloigne. Avancez lentement la caméra dans la ruelle...",
      "model": "Modèle :",
      "durationLabel": "Durée :",
      "introTitle": "Générez des vidéos IA de haute qualité avec Kling 2.5 Standard",
      "featuresBadge": "Fonctionnalités principales",
      "featuresTitle": "Que peut faire {name} ?",
      "faqTitle": "FAQ",
      "errorPromptRequired": "Veuillez entrer un prompt",
      "errorImageRequired": "Le mode image-vers-vidéo nécessite le téléchargement d'une image de référence",
      "errorGenerationFailed": "Échec de la génération",
      "errorRequestFailed": "Échec de la requête",
      "errorUploadFailed": "Échec du téléchargement, veuillez réessayer",
      "features": [
        {
          "icon": "🎬",
          "title": "Texte/Image vers vidéo",
          "desc": "Prend en charge les modes texte-vers-vidéo et image-vers-vidéo avec des options de durée de 5s ou 10s."
        },
        {
          "icon": "⚡",
          "title": "Stable et fiable",
          "desc": "Un modèle standard soigneusement testé avec des résultats stables et fiables."
        },
        {
          "icon": "💰",
          "title": "Excellent rapport qualité-prix",
          "desc": "Consommation de crédits inférieure à Kling 2.6, idéal pour la création de contenu en lot."
        },
        {
          "icon": "📐",
          "title": "Rapports d'aspect multiples",
          "desc": "Prend en charge les rapports d'aspect 1:1, 16:9, 9:16 pour différents scénarios."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Quelle est la différence entre Kling 2.5 et Kling 2.6 ?",
          "a": "Kling 2.5 est un modèle standard avec une consommation de crédits inférieure, adapté aux scénarios nécessitant une génération massive sans exigences de haute qualité. Kling 2.6 est la dernière version prenant en charge l'audio natif et le lip-sync parfait."
        },
        {
          "q": "Comment fonctionne Kling 2.5 ?",
          "a": "Vous pouvez télécharger une image de référence ou entrer une description textuelle, et Kling 2.5 générera un contenu vidéo de haute qualité basé sur vos instructions."
        },
        {
          "q": "Les vidéos générées peuvent-elles être utilisées commercialement ?",
          "a": "Oui, tout le contenu généré en utilisant Kling 2.5 peut être utilisé à des fins commerciales."
        }
      ]
    },
    "wanAnimate": {
      "title": "Wan Animate",
      "desc": "Animer un personnage à partir d’une image et d’une vidéo de référence. Qualité standard ou professionnelle, filigrane optionnel.",
      "refImageLabel": "Image de référence",
      "refImageHint": "Personnage à animer (JPG/PNG/JPEG/BMP/WEBP, max. 5 Mo, côtés 200–4096 px, ratio 1:3–3:1).",
      "refVideoLabel": "Vidéo de référence",
      "refVideoHint": "Mouvement de référence (MP4/AVI/MOV, 2–30 s, max. 200 Mo, côtés 200–2048 px, ratio 1:3–3:1).",
      "animateModeLabel": "Mode d’animation",
      "modeAnimate": "Image vers action",
      "modeReplace": "Remplacement de personne vidéo",
      "referenceVideo": "Vidéo de référence",
      "btnAnimate": "Animer",
      "animateModeBadgeAnimate": "Mouvement",
      "animateModeBadgeReplace": "Remplacer",
      "btnAnimateDesc": "Combiner le personnage de l’image avec le mouvement de la vidéo.",
      "btnReplace": "Remplacer",
      "btnReplaceDesc": "Remplacer le personnage dans la vidéo par celui de l’image.",
      "qualityLabel": "Mode qualité",
      "qualityStd": "Standard",
      "qualityPro": "Professionnel",
      "watermarkLabel": "Filigrane",
      "uploadVideoRequired": "Veuillez télécharger une vidéo de référence.",
      "uploadImage": "Téléverser une image",
      "uploadVideo": "Téléverser une vidéo",
      "uploading": "Téléversement…",
      "imageUploadHint": "JPG, PNG, JPEG, BMP, WEBP · max. 5 Mo",
      "videoUploadHint": "MP4, AVI, MOV · 2–30 s · max. 200 Mo",
      "uploadImageRequired": "Veuillez télécharger une image de référence.",
      "errImageFileTooLarge": "L’image est trop volumineuse (max. 5 Mo).",
      "errImageDimensions": "La largeur et la hauteur de l’image doivent être entre 200 et 4096 px.",
      "errImageAspect": "Le ratio de l’image doit être entre 1:3 et 3:1.",
      "errImageInvalid": "Fichier image invalide ou illisible.",
      "errVideoFileTooLarge": "La vidéo est trop volumineuse (max. 200 Mo).",
      "errVideoDuration": "La durée de la vidéo doit être entre 2 et 30 secondes.",
      "errVideoDimensions": "La largeur et la hauteur de la vidéo doivent être entre 200 et 2048 px.",
      "errVideoAspect": "Le ratio de la vidéo doit être entre 1:3 et 3:1.",
      "errVideoInvalid": "Fichier vidéo invalide ou illisible.",
      "defaultModelName": "Wan Animate",
      "demoEmptyHint": "Téléversez une image de personnage et une vidéo de mouvement, et créez de superbes animations avec Wan Animate.",
      "demoEmptyTitle": "Animation de personnages",
      "demoStepCharacter": "Personnage",
      "demoStepMotion": "Mouvement",
      "demoStepAnimate": "Animation",
      "faqCredits": "Le mode professionnel consomme plus de crédits que le mode standard. Voir la ligne ci-dessus.",
      "characterAnimation": "Animation de personnages",
      "faceSwap": "Échange de visage",
      "motionTransfer": "Transfert de mouvement",
      "identityReplacement": "Remplacement d’identité",
      "motionAccuracy": "Fidélité du mouvement",
      "features": [
        { "icon": "🎭", "title": "Deux modes", "desc": "Transfert de mouvement ou remplacement complet du personnage." },
        { "icon": "📐", "title": "DashScope officiel", "desc": "Wan 2.2 Animate sur Alibaba Cloud." },
        { "icon": "⚡", "title": "Std / Pro", "desc": "Qualité standard ou professionnelle par tâche." },
        { "icon": "💧", "title": "Filigrane optionnel", "desc": "Activer ou désactiver le filigrane sur la sortie." }
      ],
      "faq": [
        { "q": "Quelles entrées sont requises ?", "a": "Après upload, des URL HTTPS publiques pour l’image et la vidéo. Respecter les limites de taille et de ratio." },
        { "q": "Différence entre Animer et Remplacer ?", "a": "Animer applique le mouvement de la vidéo à votre personnage image. Remplacer échange le personnage de la vidéo par celui de l’image." },
        { "q": "Comment sont calculés les crédits ?", "a": "Le mode professionnel coûte plus cher par génération que le standard, comme indiqué sur la page." }
      ]
    },
    "viduq3pro": {
      "title": "Vidu Q3 Pro – Vidéo IA",
      "desc": "Vidu Q3 Pro : texte ou image, résolution, 1 à 16 s, formats et audio optionnel.",
      "imageUrlHint": "URL d’image HTTPS uniquement (l’upload fournit une URL publique). Le ratio doit rester entre 1:4 et 4:1.",
      "lengthLabel": "Durée (s)",
      "optional": "Facultatif",
      "tagHighQuality": "Haute qualité",
      "tagLength": "1 à 16 s",
      "tagResolution": "Jusqu’à 2K",
      "demoPromptExample": "Promenade au lever du soleil, joggeurs, mouettes au-dessus de l’eau, voilier au loin.",
      "features": [
        { "icon": "🎬", "title": "Texte et image", "desc": "Génération à partir d’un prompt ou d’une image." },
        { "icon": "📐", "title": "Formats", "desc": "Mode texte : 16:9, 9:16, 1:1, 4:3, 3:4." },
        { "icon": "⏱️", "title": "Durée", "desc": "De 1 à 16 secondes." },
        { "icon": "🎵", "title": "Audio", "desc": "Audio naturel optionnel." },
        { "icon": "🎲", "title": "Seed", "desc": "Graine optionnelle pour plus de reproductibilité." }
      ],
      "faq": [
        { "q": "Image vers vidéo : exigences ?", "a": "URL HTTPS publique (JPG/PNG). Ratio d’aspect entre 1:4 et 4:1." },
        { "q": "Différence texte / image ?", "a": "Le texte utilise le ratio ; l’image envoie l’URL de référence sans champ de ratio texte." },
        { "q": "Crédits ?", "a": "Selon les règles affichées : durée, résolution et audio." }
      ]
    },
    "hailuo": {
      "title": "Générateur vidéo AI Hailuo 2.3",
      "desc": "Hailuo 2.3 est un modèle vidéo IA de nouvelle génération prenant en charge la génération vidéo texte-vers-vidéo de haute qualité, offrant des solutions vidéo créatives.",
      "demoPromptExample": "Plan cinématographique : vagues se brisant sur un rivage rocheux au coucher du soleil, reflets dorés sur l'eau...",
      "highQuality": "Haute qualité",
      "highQualityOutput": "Sortie haute qualité",
      "features": [
        {
          "icon": "🎬",
          "title": "Texte vers vidéo",
          "desc": "Entrez simplement des descriptions textuelles pour générer des vidéos de haute qualité, avec des options de durée de 6s ou 10s."
        },
        {
          "icon": "✨",
          "title": "Amélioration de prompt",
          "desc": "Activez l'optimisation des prompts et les vérifications de sécurité pour optimiser automatiquement vos prompts pour de meilleurs résultats de génération."
        },
        {
          "icon": "🌊",
          "title": "Style créatif",
          "desc": "Excellent pour générer du contenu vidéo créatif et artistique."
        },
        {
          "icon": "⚡",
          "title": "Génération rapide",
          "desc": "Moteur d'inférence optimisé assurant un rendu rapide."
        },
        {
          "icon": "🎨",
          "title": "Sortie haute qualité",
          "desc": "Génère du contenu vidéo de haute qualité adapté à diverses applications."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Toutes les vidéos générées peuvent être utilisées à des fins commerciales."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne Hailuo 2.3 ?",
          "a": "Entrez simplement une description textuelle, et le modèle Hailuo 2.3 générera du contenu vidéo de haute qualité basé sur vos instructions."
        },
        {
          "q": "Qu'est-ce que l'amélioration de prompt ?",
          "a": "La fonction d'amélioration de prompt optimise automatiquement vos prompts et effectue des vérifications de sécurité pour garantir que le contenu généré respecte les directives."
        },
        {
          "q": "Les vidéos générées peuvent-elles être utilisées à des fins commerciales ?",
          "a": "Oui, tout le contenu généré en utilisant Hailuo 2.3 peut être utilisé à des fins commerciales."
        },
        {
          "q": "Combien de crédits sont nécessaires par génération ?",
          "a": "L'utilisation de Hailuo 2.3 consomme 12 crédits par génération."
        }
      ]
    },
    "runway": {
      "title": "Générateur vidéo IA Runway",
      "desc": "Runway est un modèle vidéo IA professionnel avec un contrôle flexible du ratio, de la durée et du seed.",
      "demoPromptExample": "Au crépuscule, les silhouettes des grues sur un chantier à Singapour se découpent sur un coucher de soleil flamboyant. Plusieurs ouvriers casqués rangent leurs outils, prêts à partir...",
      "professional": "Professionnel",
      "multiOption": "Options multiples",
      "highQuality": "Haute qualité",
      "multiFormat": "Ratios multiples",
      "reproducibleSeed": "Seed reproductible",
      "features": [
        {
          "icon": "🎬",
          "title": "Image vers vidéo",
          "desc": "Téléchargez une image de référence et un prompt pour générer rapidement une vidéo de qualité."
        },
        {
          "icon": "📐",
          "title": "Ratios multiples",
          "desc": "Prend en charge 16:9, 9:16, 1:1, 4:3, 3:4 et 21:9."
        },
        {
          "icon": "🎲",
          "title": "Contrôle du seed",
          "desc": "Utilisez un seed pour reproduire des résultats proches."
        },
        {
          "icon": "⚡",
          "title": "Sortie pro",
          "desc": "Sortie stable adaptée aux usages professionnels et commerciaux."
        },
        {
          "icon": "🖼️",
          "title": "Animation d'image",
          "desc": "Transforme les images statiques en plans vidéo dynamiques."
        },
        {
          "icon": "💼",
          "title": "Licence commerciale",
          "desc": "Le contenu généré peut être utilisé commercialement."
        }
      ],
      "faq": [
        {
          "q": "Comment fonctionne Runway ?",
          "a": "Téléchargez une image de référence, saisissez un prompt, puis le modèle génère la vidéo."
        },
        {
          "q": "Quels ratios sont pris en charge ?",
          "a": "16:9, 9:16, 1:1, 4:3, 3:4 et 21:9."
        },
        {
          "q": "Puis-je utiliser les vidéos générées commercialement ?",
          "a": "Oui, les contenus générés via Runway peuvent être utilisés commercialement."
        }
      ]
    },
    "privacy": {
      "title": "Politique de confidentialité",
      "lastUpdated": "Dernière mise à jour : 15 janvier 2025",
      "navTerms": "Conditions d'utilisation →",
      "navTrust": "Confiance et sécurité →",
      "sections": [
        {
          "title": "1. Collecte d'informations",
          "paragraphs": [
            "Nous collectons les informations que vous fournissez lors de l'inscription et de l'utilisation de nos services, notamment l'adresse e-mail, le nom d'utilisateur et les informations de paiement.",
            "Nous collectons également automatiquement des données d'utilisation telles que l'adresse IP, le type de navigateur, l'heure d'accès et les fonctionnalités utilisées."
          ]
        },
        {
          "title": "2. Utilisation des informations",
          "paragraphs": [
            "Nous utilisons les informations collectées pour fournir, maintenir et améliorer nos services, traiter les transactions, envoyer des notifications liées au service et prévenir la fraude et les abus.",
            "Nous ne vendons pas vos informations personnelles à des tiers."
          ]
        },
        {
          "title": "3. Contenu généré par l'IA",
          "paragraphs": [
            "Les images que vous téléchargez et les invites que vous saisissez sont utilisées uniquement pour générer le contenu que vous demandez et ne sont pas utilisées pour entraîner des modèles IA.",
            "Le contenu généré est temporairement stocké sur nos serveurs pour que vous puissiez le télécharger, puis supprimé conformément à notre politique de conservation des données."
          ]
        },
        {
          "title": "4. Sécurité des données",
          "paragraphs": [
            "Nous employons des mesures de sécurité standard de l'industrie pour protéger vos informations personnelles, notamment le cryptage SSL, les contrôles d'accès et les audits de sécurité réguliers.",
            "Bien que nous fassions de notre mieux pour protéger vos données, aucune méthode de transmission Internet n'est sécurisée à 100 %."
          ]
        },
        {
          "title": "5. Utilisation des cookies",
          "paragraphs": [
            "Nous utilisons des cookies et des technologies similaires pour améliorer l'expérience utilisateur, analyser l'utilisation et fournir un contenu personnalisé.",
            "Vous pouvez gérer les préférences de cookie via les paramètres de votre navigateur. La désactivation des cookies peut affecter certaines fonctionnalités."
          ]
        },
        {
          "title": "6. Services tiers",
          "paragraphs": [
            "Nous pouvons utiliser des fournisseurs de services tiers pour nous aider à fournir des services, tels que le traitement des paiements, l'analyse des données et le support client.",
            "Ces fournisseurs de services tiers n'ont accès à vos informations personnelles que dans la mesure nécessaire pour effectuer des services pour nous."
          ]
        },
        {
          "title": "7. Vos droits",
          "paragraphs": [
            "Vous avez le droit d'accéder, corriger ou supprimer vos informations personnelles. Vous avez également le droit de demander que nous restreignions le traitement de vos données ou que nous transférions vos données vers un autre service.",
            "Pour exercer ces droits, veuillez nous contacter à miral_support@miralvis.com. Nous répondrons à votre demande dans les 30 jours."
          ]
        },
        {
          "title": "8. Conformité RGPD",
          "paragraphs": [
            "Pour les utilisateurs de l'Espace économique européen, nous respectons les exigences du Règlement général sur la protection des données (RGPD). Notre base légale pour le traitement de vos données comprend l'exécution du contrat, les intérêts légitimes et votre consentement."
          ]
        },
        {
          "title": "9. Nous contacter",
          "paragraphs": [
            "Si vous avez des questions ou des préoccupations concernant notre politique de confidentialité, veuillez contacter notre équipe de protection des données à miral_support@miralvis.com."
          ]
        }
      ]
    },
    "terms": {
      "title": "Conditions d'utilisation",
      "lastUpdated": "Dernière mise à jour : 15 janvier 2025",
      "navPrivacy": "Politique de confidentialité →",
      "navTrust": "Confiance et sécurité →",
      "sections": [
        {
          "title": "1. Aperçu du service",
          "paragraphs": [
            "Miral (ci-après dénommé \"la Plateforme\") est une plateforme IA intégrant la création d'image, de vidéo et de musique. Ces Conditions d'utilisation (ci-après dénommées \"Conditions\") régissent les conditions et règles relatives à votre utilisation de la Plateforme.",
            "En utilisant la Plateforme, vous acceptez d'être lié par ces Conditions. Si vous n'acceptez pas ces Conditions, veuillez ne pas utiliser la Plateforme."
          ]
        },
        {
          "title": "2. Inscription au compte",
          "paragraphs": [
            "Vous devez avoir au moins 18 ans pour créer un compte. Vous devez fournir des informations d'inscription précises et complètes et être responsable de la sécurité du compte.",
            "Vous êtes responsable de toutes les activités effectuées via votre compte. Si vous découvrez un usage non autorisé, veuillez nous en informer immédiatement."
          ]
        },
        {
          "title": "3. Utilisation du service",
          "paragraphs": [
            "La Plateforme fournit des services de génération de contenu IA basés sur des crédits. Les crédits peuvent être obtenus par abonnement ou achat unique. Différents modèles IA et fonctionnalités consomment différents montants de crédits.",
            "Vous acceptez de ne pas utiliser la Plateforme à des fins illégales, nuisibles ou portant atteinte aux droits. La génération de contenu illégal, pornographique, violent ou portant atteinte aux droits est interdite."
          ]
        },
        {
          "title": "4. Propriété intellectuelle",
          "paragraphs": [
            "Les droits de propriété intellectuelle sur le contenu que vous générez via la Plateforme vous appartiennent, sous réserve des conditions d'utilisation de chaque fournisseur de modèle IA.",
            "Les marques, logos, conceptions d'interface et code logiciel de la Plateforme sont protégés par les lois sur la propriété intellectuelle et ne peuvent être utilisés sans autorisation."
          ]
        },
        {
          "title": "5. Paiement et remboursements",
          "paragraphs": [
            "Tous les paiements sont en dollars américains. Les frais d'abonnement sont facturés mensuellement ou annuellement, selon votre plan choisi.",
            "Pour les premiers achats de paquets uniques ou les premiers abonnements, les remboursements peuvent être demandés dans les 7 jours calendrier si l'utilisation des crédits est inférieure à 3 %."
          ]
        },
        {
          "title": "6. Clause de non-garantie",
          "paragraphs": [
            "La Plateforme fournit les services \"tels quels\" et ne fait aucune garantie expresse ou implicite quant à la disponibilité, l'exactitude ou l'adéquation des services.",
            "Le contenu généré par l'IA peut être inexact ou imparfait. Les utilisateurs doivent juger eux-mêmes de l'applicabilité du contenu généré."
          ]
        },
        {
          "title": "7. Limitation de responsabilité",
          "paragraphs": [
            "Dans la mesure maximale permise par la loi, la Plateforme n'est pas responsable de tout dommage direct, indirect, accessoire ou consécutif résultant de l'utilisation ou de l'impossibilité d'utiliser les services.",
            "La responsabilité totale de la Plateforme ne dépasse pas le total des frais que vous avez payés au cours des 12 derniers mois."
          ]
        },
        {
          "title": "8. Modification des conditions",
          "paragraphs": [
            "Nous nous réservons le droit de modifier ces Conditions à tout moment. Les Conditions modifiées deviennent effectives lorsqu'elles sont publiées sur cette page.",
            "La poursuite de l'utilisation de la Plateforme implique l'acceptation des Conditions modifiées. Les changements importants seront notifiés par e-mail ou notification sur la Plateforme."
          ]
        },
        {
          "title": "9. Nous contacter",
          "paragraphs": [
            "Si vous avez des questions concernant ces Conditions, veuillez nous contacter à miral_support@miralvis.com."
          ]
        }
      ]
    },
    "trustSafety": {
      "tag": "🛡️ Confiance et sécurité",
      "title": "La sécurité de vos données est notre priorité absolue",
      "subtitle": "Découvrez comment nous protégeons votre vie privée et la sécurité de vos données.",
      "badges": [
        {
          "icon": "🛡️",
          "title": "Aucun entraînement IA",
          "desc": "Votre contenu téléchargé et vos œuvres générées ne sont jamais utilisés pour entraîner aucun modèle IA."
        },
        {
          "icon": "🔒",
          "title": "Cryptage de bout en bout",
          "desc": "Tous les transferts de données utilisent le cryptage TLS 1.3, les données stockées utilisent le cryptage AES-256."
        },
        {
          "icon": "✓",
          "title": "Conformité RGPD",
          "desc": "Entièrement conforme aux exigences du Règlement général sur la protection des données de l'UE."
        },
        {
          "icon": "🗑️",
          "title": "Contrôle des données personnelles",
          "desc": "Vous pouvez exporter ou supprimer toutes vos données à tout moment, y compris la suppression du compte."
        }
      ],
      "sections": [
        {
          "title": "Transparence du traitement des données",
          "paragraphs": [
            "Nous sommes entièrement transparents sur la façon dont nous traitons les données. Les images et vidéos que vous téléchargez sont utilisées uniquement pour générer le contenu que vous demandez et sont supprimées des serveurs dans les 24 heures suivant le traitement.",
            "Le contenu généré est stocké dans votre compte, et vous pouvez le télécharger ou le supprimer à tout moment. Nous ne partageons pas votre contenu sans votre consentement."
          ]
        },
        {
          "title": "Infrastructure sécurisée",
          "paragraphs": [
            "Nos services sont déployés sur l'infrastructure cloud de premier plan mondial avec une protection de sécurité multicouche. Tous les serveurs sont situés dans des centres de données certifiés SOC 2 et ISO 27001.",
            "Nous effectuons des audits de sécurité et des tests d'intrusion réguliers pour garantir la sécurité du système. Tous les employés reçoivent une formation stricte en sécurité."
          ]
        },
        {
          "title": "Sécurité du contenu",
          "paragraphs": [
            "Nous déployons des systèmes avancés de sécurité du contenu qui détectent et bloquent automatiquement la génération de contenu nuisible. Cela inclut mais ne se limite pas au contenu violent, pornographique ou portant atteinte aux droits.",
            "Si vous découvrez un contenu enfreignant, veuillez nous le signaler à abuse@miral.org."
          ]
        },
        {
          "title": "Conformité et certification",
          "paragraphs": [
            "Nous respectons les principales réglementations mondiales de protection des données, notamment le RGPD (UE), le CCPA (Californie) et le LGPD (Brésil).",
            "Notre traitement des paiements est conforme aux normes PCI DSS, garantissant la sécurité de vos informations de paiement."
          ]
        }
      ],
      "ctaTitle": "Préoccupations de sécurité ?",
      "ctaDesc": "Notre équipe de sécurité est prête à répondre à vos questions",
      "ctaButton": "Contacter l'équipe de sécurité",
      "navTerms": "Conditions d'utilisation →",
      "navPrivacy": "Politique de confidentialité →"
    },
    "gallery": {
      "tag": "Mes créations",
      "title": "Historique des créations",
      "subtitle": "Consultez tout votre historique de créations IA, y compris les enregistrements de génération d'images et de vidéos.",
      "loadMore": "Charger plus",
      "loginRequired": "Veuillez vous connecter pour voir votre historique de créations",
      "empty": "Aucun enregistrement de création. Commencez à créer maintenant !",
      "filters": {
        "all": "Tous",
        "pending": "En cours",
        "finish": "Fini",
        "failed": "Échoué"
      },
      "status": {
        "pending": "En cours",
        "finish": "Fini",
        "failed": "Échoué"
      },
      "usePrompt": "Générer avec cette invite",
      "download": "Télécharger"
    },
    "watermarkRemover": {
      "breadcrumb": {
        "home": "Accueil"
      },
      "tag": "Outil IA",
      "title": "Suppression de filigrane",
      "subtitle": "Détecter et supprimer intelligemment les filigranes des images tout en préservant la qualité originale",
      "uploadText": "Cliquez ou glissez pour télécharger une image",
      "uploadHint": "Supporte JPG, PNG, BMP, WEBP, max 50MB",
      "keepAlphaChannel": "Conserver le canal alpha",
      "keepAlphaChannelDesc": "Activer pour préserver les informations du canal alpha dans le résultat",
      "removeWatermark": "Supprimer le filigrane",
      "processing": "Traitement en cours...",
      "result": "Résultat",
      "download": "Télécharger le résultat",
      "newImage": "Traiter une nouvelle image",
      "watermarkDetected": "Filigrane détecté",
      "noWatermark": "Aucun filigrane détecté",
      "before": "Avant",
      "after": "Après",
      "emptyText": "Téléchargez une image pour commencer à supprimer les filigranes",
      "invalidFormat": "Veuillez télécharger un fichier image valide",
      "fileTooLarge": "La taille du fichier ne peut pas dépasser 50MB",
      "processFailed": "Échec du traitement, veuillez réessayer",
      "features": {
        "title": "Fonctionnalités",
        "ai": {
          "title": "Détection IA",
          "desc": "Détecter automatiquement la position et le type de filigrane"
        },
        "fast": {
          "title": "Traitement rapide",
          "desc": "Algorithme efficace pour une suppression rapide"
        },
        "formats": {
          "title": "Support multi-format",
          "desc": "Supporte JPG, PNG, BMP, WEBP et plus"
        },
        "quality": {
          "title": "Qualité préservée",
          "desc": "Maintenir la qualité originale, suppression sans perte"
        }
      }
    },
    "profile": {
      "joinTime": "Inscrit le",
      "tabs": {
        "account": "Compte",
        "billing": "Facturation",
        "privacy": "Données et confidentialité"
      },
      "balance": {
        "title": "Aperçu du solde",
        "available": "Crédits disponibles"
      },
      "subscription": {
        "currentPlan": "Plan actuel",
        "status": "Statut",
        "activated": "Activé",
        "cancelled": "Se termine à la fin de la période en cours",
        "pending": "En traitement",
        "failed": "Échec du paiement",
        "expiryDate": "Valable jusqu'au",
        "permanent": "Permanent",
        "upgradePlan": "Mettre à niveau ou changer de plan",
        "cancelPlan": "Annuler l'abonnement",
        "cancelNote": "Votre abonnement reste actif jusqu'à la fin de la période de facturation en cours",
        "cancelWarning": "Votre abonnement sera annulé. Vous pouvez continuer à utiliser toutes les fonctionnalités jusqu'au",
        "restorePlan": "Reprendre l'abonnement"
      },
      "upgrade": {
        "title": "Mettre à niveau",
        "desc": "Obtenez un accès illimité et des avantages exclusifs",
        "btn": "Voir les plans"
      },
      "billing": {
        "title": "Historique des paiements",
        "subtitle": "Consultez vos enregistrements de paiement et téléchargez les factures",
        "empty": "Aucun enregistrement de facturation pour le moment",
        "creditsPack": "Pack de crédits",
        "oneTime": "Ponctuel",
        "monthly": "Mensuel",
        "yearly": "Annuel",
        "refresh": "Actualiser",
        "plan": "Plan",
        "date": "Date",
        "amount": "Montant",
        "invoice": "Facture",
        "download": "Télécharger",
        "invoiceModal": {
          "title": "Détails de la facture",
          "orderInfo": "Informations de commande",
          "invoiceInfo": "Informations de facture",
          "plan": "Plan",
          "date": "Date de paiement",
          "amount": "Montant",
          "paymentId": "ID de commande",
          "close": "Fermer",
          "download": "Télécharger la facture",
          "fullName": "Nom complet",
          "fullNamePlaceholder": "Entrez votre nom complet",
          "email": "Email",
          "emailPlaceholder": "Entrez votre email",
          "company": "Entreprise",
          "companyPlaceholder": "Nom légal de l'entreprise",
          "taxId": "Numéro fiscal",
          "taxIdPlaceholder": "Entrez le numéro fiscal",
          "addressLine1": "Adresse ligne 1",
          "addressLine1Placeholder": "Adresse postale",
          "addressLine2": "Adresse ligne 2",
          "addressLine2Placeholder": "Appartement, suite, etc. (facultatif)",
          "city": "Ville",
          "cityPlaceholder": "Ville",
          "province": "Province",
          "provincePlaceholder": "Province",
          "postalCode": "Code postal",
          "postalCodePlaceholder": "Code postal",
          "country": "Pays",
          "countryPlaceholder": "Pays",
          "invoiceRemarks": "Remarques",
          "invoiceRemarksPlaceholder": "Remarques de facture",
          "optional": "facultatif",
          "required": "Ce champ est requis"
        }
      },
      "privacy": {
        "title": "Paramètres de confidentialité",
        "cardTitle": "Vos données sont protégées",
        "cardSubtitle": "Notre engagement envers votre vie privée et la sécurité de vos données",
        "item1": "Vos données ne sont jamais utilisées pour l'entraînement des modèles IA",
        "item2": "La transmission et le stockage des données sont entièrement cryptés",
        "item3": "Les œuvres générées sont automatiquement supprimées après la période de stockage",
        "item4": "Aucun circuit de rétroaction, aucune réutilisation secondaire des données dérivées",
        "item5": "Conformité stricte aux réglementations de protection des données"
      },
      "support": {
        "title": "Besoin d'aide ?",
        "desc": "Notre équipe d'assistance est là pour vous aider",
        "btn": "Contacter le support",
        "note": "miral_support@miralvis.com · Réponse sous 24 heures"
      }
    },
    "payment": {
      "success": {
        "title": "Paiement réussi",
        "message": "Merci pour votre achat ! Votre commande a été traitée avec succès et les crédits ont été ajoutés à votre compte.",
        "goHome": "Aller à l'accueil",
        "viewProfile": "Voir le profil"
      },
      "cancel": {
        "title": "Paiement annulé",
        "message": "Votre paiement a été annulé. Si vous avez des questions, n'hésitez pas à contacter notre équipe d'assistance.",
        "tryAgain": "Réessayer",
        "goHome": "Aller à l'accueil"
      }
    }
  },
  "privacy": {
    "title": "Privacy Policy",
    "lastUpdated": "Last updated: January 15, 2025",
    "navTerms": "Terms of Service →",
    "navTrust": "Trust & Safety →",
    "sections": [
      {
        "title": "1. Information Collection",
        "paragraphs": [
          "We collect information you provide when registering and using our services, including email address, username, and payment information.",
          "We also automatically collect usage data such as IP address, browser type, access time, and features used."
        ]
      },
      {
        "title": "2. Information Use",
        "paragraphs": [
          "We use the collected information to provide, maintain, and improve our services, process transactions, send service-related notifications, and prevent fraud and abuse.",
          "We do not sell your personal information to third parties."
        ]
      },
      {
        "title": "3. AI Generated Content",
        "paragraphs": [
          "Images you upload and prompts you enter are used solely to generate the content you request and are not used to train AI models.",
          "Generated content is temporarily stored on our servers for you to download, then deleted according to our data retention policy."
        ]
      },
      {
        "title": "4. Data Security",
        "paragraphs": [
          "We employ industry-standard security measures to protect your personal information, including SSL encryption, access controls, and regular security audits.",
          "While we do our best to protect your data, no internet transmission method is 100% secure."
        ]
      },
      {
        "title": "5. Cookie Usage",
        "paragraphs": [
          "We use cookies and similar technologies to improve user experience, analyze usage, and provide personalized content.",
          "You can manage cookie preferences through your browser settings. Disabling cookies may affect certain features."
        ]
      },
      {
        "title": "6. Third-Party Services",
        "paragraphs": [
          "We may use third-party service providers to assist us in providing services, such as payment processing, data analytics, and customer support.",
          "These third-party service providers only access your personal information to the extent necessary to perform services for us."
        ]
      },
      {
        "title": "7. Your Rights",
        "paragraphs": [
          "You have the right to access, correct, or delete your personal information. You also have the right to request that we restrict processing of your data or transfer your data to another service.",
          "To exercise these rights, please contact us at miral_support@miralvis.com. We will respond to your request within 30 days."
        ]
      },
      {
        "title": "8. GDPR Compliance",
        "paragraphs": [
          "For users in the European Economic Area, we comply with the requirements of the General Data Protection Regulation (GDPR). Our legal basis for processing your data includes contract performance, legitimate interests, and your consent."
        ]
      },
      {
        "title": "9. Contact Us",
        "paragraphs": [
          "If you have any questions or concerns about our privacy policy, please contact our data protection team at miral_support@miralvis.com."
        ]
      }
    ]
  },
  "terms": {
    "title": "Terms of Service",
    "lastUpdated": "Last updated: January 15, 2025",
    "navPrivacy": "Privacy Policy →",
    "navTrust": "Trust & Safety →",
    "sections": [
      {
        "title": "1. Service Overview",
        "paragraphs": [
          "Miral (hereinafter referred to as \"the Platform\") is an AI platform integrating image, video, and music creation. These Terms of Service (hereinafter referred to as \"Terms\") govern the conditions and rules for your use of the Platform.",
          "By using the Platform, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use the Platform."
        ]
      },
      {
        "title": "2. Account Registration",
        "paragraphs": [
          "You must be at least 18 years old to register an account. You need to provide accurate and complete registration information and are responsible for maintaining account security.",
          "You are responsible for all activities conducted through your account. If you discover any unauthorized use, please notify us immediately."
        ]
      },
      {
        "title": "3. Service Usage",
        "paragraphs": [
          "The Platform provides credit-based AI content generation services. Credits can be obtained through subscription or one-time purchase. Different AI models and features consume different amounts of credits.",
          "You agree not to use the Platform for any illegal, harmful, or infringing purposes. Generating illegal, pornographic, violent, or rights-infringing content is prohibited."
        ]
      },
      {
        "title": "4. Intellectual Property",
        "paragraphs": [
          "Intellectual property rights for content you generate through the Platform belong to you, subject to the terms of use of each AI model provider.",
          "The Platform's trademarks, logos, interface designs, and software code are protected by intellectual property laws and may not be used without authorization."
        ]
      },
      {
        "title": "5. Payment and Refunds",
        "paragraphs": [
          "All payments are in US dollars. Subscription fees are charged monthly or annually, depending on your chosen plan.",
          "For first-time purchases of one-time packages or first subscriptions, refunds can be requested within 7 calendar days if credit usage is below 3%."
        ]
      },
      {
        "title": "6. Disclaimer",
        "paragraphs": [
          "The Platform provides services \"as is\" and makes no express or implied warranties regarding the availability, accuracy, or suitability of the services.",
          "AI-generated content may be inaccurate or imperfect. Users should judge the applicability of generated content themselves."
        ]
      },
      {
        "title": "7. Limitation of Liability",
        "paragraphs": [
          "To the maximum extent permitted by law, the Platform is not liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use the services.",
          "The Platform's total liability does not exceed the total fees you paid in the past 12 months."
        ]
      },
      {
        "title": "8. Terms Modification",
        "paragraphs": [
          "We reserve the right to modify these Terms at any time. Modified Terms become effective when posted on this page.",
          "Continued use of the Platform indicates acceptance of the modified Terms. Significant changes will be notified via email or Platform notification."
        ]
      },
      {
        "title": "9. Contact Us",
        "paragraphs": [
          "If you have any questions about these Terms, please contact us at miral_support@miralvis.com."
        ]
      }
    ]
  },
  "trustSafety": {
    "tag": "🛡️ Trust & Safety",
    "title": "Your Data Security is Our Top Priority",
    "subtitle": "Learn how we protect your privacy and data security.",
    "badges": [
      {
        "icon": "🛡️",
        "title": "No AI Training",
        "desc": "Your uploaded content and generated works are never used to train any AI models."
      },
      {
        "icon": "🔒",
        "title": "End-to-End Encryption",
        "desc": "All data transfers use TLS 1.3 encryption, stored data uses AES-256 encryption."
      },
      {
        "icon": "✓",
        "title": "GDPR Compliant",
        "desc": "Fully compliant with EU General Data Protection Regulation requirements."
      },
      {
        "icon": "🗑️",
        "title": "Self Data Control",
        "desc": "You can export or delete all your data at any time, including account deletion."
      }
    ],
    "sections": [
      {
        "title": "Data Processing Transparency",
        "paragraphs": [
          "We are completely transparent about how we handle data. Images and videos you upload are used only to generate the content you request and are deleted from servers within 24 hours after processing.",
          "Generated content is stored in your account, and you can download or delete it at any time. We do not share your content without your consent."
        ]
      },
      {
        "title": "Secure Infrastructure",
        "paragraphs": [
          "Our services are deployed on world-leading cloud infrastructure with multi-layer security protection. All servers are located in SOC 2 and ISO 27001 certified data centers.",
          "We conduct regular security audits and penetration tests to ensure system security. All employees receive strict security training."
        ]
      },
      {
        "title": "Content Safety",
        "paragraphs": [
          "We deploy advanced content safety systems that automatically detect and block harmful content generation. This includes but is not limited to violent, pornographic, and infringing content.",
          "If you discover any violating content, please report it to us at abuse@miral.org."
        ]
      },
      {
        "title": "Compliance & Certification",
        "paragraphs": [
          "We comply with major global data protection regulations, including GDPR (EU), CCPA (California), and LGPD (Brazil).",
          "Our payment processing complies with PCI DSS standards, ensuring your payment information is secure."
        ]
      }
    ],
    "ctaTitle": "Security Concerns?",
    "ctaDesc": "Our security team is ready to answer your questions",
    "ctaButton": "Contact Security Team",
    "navTerms": "Terms of Service →",
    "navPrivacy": "Privacy Policy →"
  },
  "gallery": {
    "tag": "Creation History",
    "title": "My Creations",
    "subtitle": "View all your AI creation history.",
    "loginRequired": "Please login to view your creation history",
    "empty": "No creations yet",
    "loadMore": "Load More",
    "filters": {
      "all": "All",
      "pending": "Processing",
      "finish": "Finished",
      "failed": "Failed"
    },
    "usePrompt": "Generate with this prompt",
    "download": "Download",
    "status": {
      "pending": "Processing",
      "finish": "Finished",
      "failed": "Failed"
    }
  },
  "inspiration": {
    "title": "Inspiration",
    "subtitle": "See what creators are building with Miral — from hyper-realistic images to cinematic videos, inspiration at your fingertips.",
    "filters": {
      "all": "All",
      "image": "Image",
      "video": "Video",
      "portrait": "Portrait",
      "landscape": "Landscape",
      "fantasy": "Fantasy",
      "anime": "Anime"
    }
  },
  "profile": {
    "joinTime": "Joined",
    "tabs": {
      "account": "Account",
      "billing": "Billing",
      "privacy": "Data & Privacy"
    },
    "balance": {
      "title": "Balance Overview",
      "available": "Available Credits"
    },
    "subscription": {
      "currentPlan": "Current Plan",
      "status": "Status",
      "activated": "Activated",
      "cancelled": "Cancels at end of current period",
      "pending": "Processing",
      "failed": "Payment Failed",
      "expiryDate": "Valid Until",
      "permanent": "Permanent",
      "upgradePlan": "Upgrade or Change Plan",
      "cancelPlan": "Cancel Subscription",
      "cancelNote": "Your subscription remains active until the end of the current billing period",
      "cancelWarning": "Your subscription will be cancelled. You can continue to use all features until",
      "restorePlan": "Resume Subscription"
    },
    "upgrade": {
      "title": "Upgrade",
      "desc": "Get unlimited access and exclusive benefits",
      "btn": "View Plans"
    },
    "billing": {
      "title": "Payment History",
      "subtitle": "View your payment records and download invoices",
      "empty": "No billing records yet",
      "creditsPack": "Credits Pack",
      "oneTime": "One-time",
      "monthly": "Monthly",
      "yearly": "Yearly",
      "refresh": "Refresh",
      "plan": "Plan",
      "date": "Date",
      "amount": "Amount",
      "invoice": "Invoice",
      "download": "Download",
      "invoiceModal": {
        "title": "Invoice Details",
        "orderInfo": "Order Information",
        "invoiceInfo": "Invoice Information",
        "plan": "Plan",
        "date": "Payment Date",
        "amount": "Amount",
        "paymentId": "Order ID",
        "close": "Close",
        "download": "Download Invoice",
        "fullName": "Full Name",
        "fullNamePlaceholder": "Enter your full name",
        "email": "Email",
        "emailPlaceholder": "Enter your email",
        "company": "Company",
        "companyPlaceholder": "Company legal name",
        "taxId": "Tax ID",
        "taxIdPlaceholder": "Enter tax ID",
        "addressLine1": "Address Line 1",
        "addressLine1Placeholder": "Street address",
        "addressLine2": "Address Line 2",
        "addressLine2Placeholder": "Apt, suite, etc. (optional)",
        "city": "City",
        "cityPlaceholder": "City",
        "province": "Province",
        "provincePlaceholder": "Province",
        "postalCode": "Postal Code",
        "postalCodePlaceholder": "Postal code",
        "country": "Country",
        "countryPlaceholder": "Country",
        "invoiceRemarks": "Remarks",
        "invoiceRemarksPlaceholder": "Invoice remarks",
        "optional": "optional",
        "required": "This field is required"
      }
    },
    "privacy": {
      "title": "Privacy Settings",
      "cardTitle": "Your Data is Protected",
      "cardSubtitle": "Our commitment to your data privacy and security",
      "item1": "Your data is never used for AI model training",
      "item2": "Data transmission and storage are fully encrypted",
      "item3": "Generated works are automatically deleted after storage period",
      "item4": "No feedback loops, no secondary use of derived data",
      "item5": "Strict compliance with data protection regulations"
    },
    "support": {
      "title": "Need Help?",
      "desc": "Our support team is here to help",
      "btn": "Contact Support",
      "note": "miral_support@miralvis.com · Response within 24 hours"
    }
  },
  "payment": {
    "success": {
      "title": "Payment Successful",
      "message": "Thank you for your purchase! Your order has been processed successfully and credits have been added to your account.",
      "goHome": "Go to Home",
      "viewProfile": "View Profile"
    },
    "cancel": {
      "title": "Payment Cancelled",
      "message": "Your payment has been cancelled. If you have any questions, please feel free to contact our support team.",
      "tryAgain": "Try Again",
      "goHome": "Go to Home"
    }
  },
  "seo": {
    "default": {
      "title": "Miral - Plateforme de création AI d'images, vidéos et musique",
      "description": "Miral est une plateforme tout-en-un soutenant les meilleurs modèles IA comme Seedream 4, Midjourney, GPT Image, Veo 3 et Sora 2.",
      "keywords": "générateur d'images IA, générateur de vidéos IA, générateur de musique IA, texte vers image, Seedream, Midjourney, Veo, Sora, Miral"
    },
    "home": { "title": "Miral : générateur d’images, vidéos et musique IA", "description": "Créez des images, des vidéos et de la musique de haute qualité sur Miral avec Seedream 5, Midjourney, Veo 3.1, Sora 2 et d’autres modèles IA de pointe." },
    "pricing": { "title": "Tarifs - Miral", "description": "Miral offre des tarifs flexibles. Achetez des crédites, payez à l'usage, sans abonnement." },
    "profile": { "title": "Profil - Miral", "description": "Gérez votre compte Miral, consultez l'historique des commandes." },
    "models": { "title": "Modèles IA - Miral", "description": "Explorez les meilleurs modèles IA sur Miral : image, vidéo et musique." },
    "music": { "title": "Générateur de musique IA - Miral", "description": "Créez de la musique unique à partir de descriptions textuelles avec l'IA de Miral." },
    "tools": { "title": "Outils d'image IA - Miral", "description": "Miral propose des outils de traitement d'image IA : suppression de filigrane, fond, amélioration." },
    "inspiration": { "title": "Inspiration - Miral", "description": "Parcourez les créations sélectionnées de la communauté Miral." },
    "gallery": { "title": "Ma galerie - Miral", "description": "Consultez et gérez toutes vos créations sur Miral." },
    "faq": { "title": "FAQ - Miral", "description": "Questions fréquentes sur la plateforme Miral." },
    "about": {
      "title": "About Us - Miral",
      "description": "Learn about the Miral AI platform for image, video, and music creation."
    },
    "contact": {
      "title": "Contact Us - Miral",
      "description": "Contact Miral support for help and feedback."
    },
    "terms": { "title": "Conditions d'utilisation - Miral", "description": "Conditions d'utilisation et accord utilisateur de Miral." },
    "privacy": { "title": "Politique de confidentialité - Miral", "description": "Politique de confidentialité et protection des données de Miral." },
    "trustSafety": { "title": "Confiance et sécurité - Miral", "description": "Politiques de confiance et sécurité de Miral." },
    "models": {
      "wan25": { "title": "Wan 2.5 - Modèle vidéo IA puissant", "description": "Wan 2.5 offre une génération vidéo IA de nouvelle génération. Créez des vidéos réalistes et fluides avec un mouvement et des détails avancés, idéal pour créateurs et entreprises." },
      "wan26": { "title": "Wan 2.6 - Générateur vidéo IA amélioré", "description": "Améliorez votre création vidéo avec Wan 2.6. Ce modèle IA avancé génère des vidéos ultra-réalistes avec un mouvement, des détails et une vitesse améliorés." },
      "wan22": { "title": "Wan 2.2 - Générateur vidéo IA rapide", "description": "Wan 2.2 est un modèle vidéo IA rapide et fiable. Générez des vidéos de haute qualité rapidement, idéal pour les créateurs needing une production efficace." },
      "wanAnimate": { "title": "Wan Animate - Animation de personnages - Miral", "description": "Animez des personnages avec image et vidéo de référence via Alibaba Wan 2.2 Animate." },
      "veo30": { "title": "Veo 3.0 - Modèle vidéo IA de premier plan", "description": "Veo 3.0 est un générateur vidéo IA de premier plan. Créez des vidéos réalistes et cinématographiques avec une IA avancée, parfait pour la création de contenu professionnel." },
      "veo31": { "title": "Veo 3.1 - Meilleure génération vidéo IA", "description": "Veo 3.1 est un modèle vidéo IA leader pour des vidéos époustouflantes et réalistes. Créez des clips cinématographiques et animations avec une qualité et vitesse inégalées." },
      "kling26": { "title": "Kling 2.6 - Modèle vidéo IA premium", "description": "Kling 2.6 donne vie à la génération vidéo IA professionnelle. Générez des vidéos de haute qualité et fluides avec une IA avancée pour créateurs et marketeurs." },
      "kling25": { "title": "Kling 2.5 - Modèle vidéo IA fiable", "description": "Kling 2.5 offre une génération vidéo IA puissante pour créateurs. Produisez des vidéos de haute qualité avec un mouvement fluide, parfait pour le contenu et le marketing." },
      "seedance": { "title": "Seedance AI - Générateur vidéo IA avancé", "description": "Générez des vidéos IA de haute qualité avec Seedance AI. Créez clips, animations et contenu cinématographique avec des modèles IA de pointe pour des résultats professionnels rapides." },
      "sora2": { "title": "Générateur vidéo IA Sora 2 – Texte et image en vidéo | Miral", "description": "Créez des vidéos Sora 2 à partir de texte ou d’images sur Miral. Testez avec des crédits gratuits et choisissez 4 à 12 s, 720p/1080p et 16:9/9:16." },
      "hailuo23": { "title": "Hailuo 2.3 - Générateur vidéo IA intelligent", "description": "Hailuo 2.3 offre une génération vidéo IA intelligente. Créez des vidéos créatives de haute qualité avec une IA avancée pour créateurs et entreprises." },
      "runway": { "title": "Runway - Plateforme de création vidéo IA", "description": "Runway est une plateforme vidéo IA de premier plan pour créateurs. Modifiez, générez et améliorez des vidéos avec des outils IA puissants pour la production professionnelle." },
      "nanobanana": { "title": "Nano Banana - Générateur image IA - Miral", "description": "Générez rapidement des images créatives avec Nano Banana." },
      "seedream4": { "title": "Seedream 4 - Générateur d'images IA", "description": "Créez des images IA époustouflantes en haute résolution avec Seedream 4. Générez art photoréaliste, illustrations et designs avec une IA avancée pour le travail créatif professionnel." },
      "midjourney": { "title": "Midjourney - Générateur d'art IA", "description": "Midjourney est un générateur d'art IA leader. Créez images et designs époustouflants à partir de texte, parfait pour artistes, designers et créateurs de contenu." },
      "gptimage1": { "title": "GPT-Image-1 - Modèle d'images IA OpenAI", "description": "GPT-Image-1 d'OpenAI génère des images IA de haute qualité à partir de texte. Créez visuels réalistes et créatifs pour design, marketing et création de contenu." },
      "gptimage15": { "title": "GPT Image 1.5 - OpenAI image IA - Miral", "description": "Générez des images IA avec OpenAI GPT Image 1.5." },
      "fluxpro11ultra": { "title": "Flux Pro 1.1 Ultra - Générateur d'images IA premium", "description": "Flux Pro 1.1 Ultra offre une génération d'images IA ultra haute qualité. Créez images photoréalistes et détaillées avec une IA avancée pour le design professionnel." },
      "fluxschnell": { "title": "Flux Schnell - Générateur d'images IA rapide", "description": "Flux Schnell est un générateur d'images IA ultra rapide. Créez des images de haute qualité rapidement, idéal pour les créateurs needing du contenu visuel professionnel rapide." },
      "flux2": {
        "title": "FLUX.2 - Générateur d'images IA - Miral",
        "description": "Générez des images IA professionnelles avec FLUX.2 — 5 variantes pour la vitesse, la qualité et le contrôle."
      },
      "zimageturbo": {
        "title": "Z Image Turbo - Générateur d'images IA - Miral",
        "description": "Générez des images haute résolution avec le modèle Z Image Turbo."
      }
    },
    "tools": {
      "watermarkRemover": { "title": "Suppresseur de filigrane IA gratuit | Miral", "description": "Supprimez en ligne filigranes, logos, dates, textes et marques des photos avec l’IA. Préservez les détails et exportez un résultat net en JPG, PNG ou WebP." },
      "backgroundRemover": { "title": "Suppresseur d'arrière-plan IA gratuit en ligne | Miral", "description": "Supprimez gratuitement le fond d'une image avec l'IA. Détourez portraits et produits, préservez cheveux et contours, puis créez un PNG transparent depuis JPG, PNG ou WebP." },
      "imageEraser": { "title": "Gomme Photo IA - Effacer des objets sur les photos", "description": "Effacez les objets, personnes, filigranes et textes indésirables de vos photos avec l'IA. Brossez la zone et l'IA la supprime en remplissant le vide avec un contenu naturel, parfait pour nettoyer vos images." },
      "objectRemover": { "title": "Suppression d'objet IA - Supprimer des objets des photos", "description": "Supprimez les objets indésirables de vos photos avec l'IA. Brossez l'objet et l'IA le supprime en remplissant la zone avec un contenu naturel. Parfait pour nettoyer vos photos." },
      "aiPersonRemover": { "title": "Suppression de personne IA - Supprimer des personnes des photos", "description": "Supprimez les personnes de vos photos avec l'IA. Brossez n'importe quelle personne et l'IA la supprime en remplissant la zone avec un contenu naturel. Parfait pour supprimer les passants et les inconnus de vos clichés." },
            "whiteBackground": { "title": "Fond Blanc IA - Remplacer le fond par du blanc", "description": "Remplacez automatiquement les fonds d images par du blanc avec l IA. Ideal pour photos produit e-commerce, photos d identite et images catalogue." },
            "blueBackground": { "title": "Fond Bleu IA - Remplacer le fond par du bleu", "description": "Remplacez automatiquement les fonds d images par du bleu avec l IA. Ideal pour photos d identite, photos de passeport et documents officiels." },
"faceSwap": { "title": "Échange de visage IA - Échanger les visages sur les photos", "description": "Échangez les visages sur les photos avec l'IA. Téléchargez une photo cible et un visage source pour fusionner les visages de manière transparente avec des résultats réalistes et naturels." },
      "imageEnhancer": { "title": "Améliorateur image IA - Agrandir et améliorer", "description": "Améliorez et agrandissez les images avec l'IA. Affinez les détails, corrigez le flou, augmentez la résolution et restaurez les anciennes photos pour des résultats professionnels." },
      "docCropEnhance": { "title": "Recadrage et correction de documents par IA | Miral", "description": "Recadrez et corrigez documents, copies, devoirs et manuels en ligne. Réparez inclinaison, perspective, pages courbes et ombres pour des scans nets." },
      "handwrittenErase": { "title": "Effaceur IA d’écriture sur copies et devoirs | Miral", "description": "Effacez les réponses manuscrites des copies, devoirs et cahiers avec l’IA tout en gardant le texte imprimé. Rotation, recadrage et redressement inclus." }
    },
    imageModels: {
            title: "Modèles d'images IA - Miral",
            description: "Explorez les meilleurs modèles d'images IA sur Miral et générez des images époustouflantes à partir d'invites textuelles.",
            relatedModelsTitle: "Explorez davantage de modèles d'images IA",
            demoPrompt: "Invite de texte",
            demoOutput: "Image générée",
            demoPlaceholder: "Exemple d'image — à venir",
            promptLabel: "Créer avec",
            usePrompt: "Utilisez cette invite →",
            imagePlaceholder: "Exemple d'image IA",
            replaceImageHint: "Généré à partir de l'invite affichée à côté de cette image",
            flux1: {
                title: "FLUX.1 Générateur d'images AI gratuit en ligne | Miral",
                description: "Créez des images IA de haute qualité en ligne avec FLUX.1 à l'aide de Flux Pro 1.1 Ultra ou Flux Schnell. Explorez neuf formats d'image, styles visuels et crédits gratuits.",
                heroHeadline: "Générateur d'images IA FLUX.1",
                heroIntro: "Utilisez gratuitement le générateur d'images FLUX.1 AI de Black Forest Labs sur Miral AI. Inscrivez-vous pour recevoir des crédits gratuits et choisissez entre la sortie de haute qualité de Flux Pro 1.1 Ultra et la création rapide et multistyle de Flux Schnell.",
                eyebrow: "Laboratoires de la Forêt-Noire · FLUX.1",
                sectionKicker: "FLUX.1",
                ctaTag: "FLUX.1 · Miral",
                badges: ["Texte en image", "9 formats d'image", "Pro et Schnell", "Photographie/Art numérique/Anime"],
                previewLabel: "Flux Pro 1.1 Ultra",
                previewMeta: ["1:1", "16:9", "9h16", "9 rapports"],
                previewTitle: "Choisissez entre une qualité raffinée et une exploration créative rapide",
                previewDesc: "Utilisez Pro 1.1 Ultra pour des visuels détaillés ou Schnell pour explorer rapidement les directions photographiques, artistiques numériques et animées.",
                keyFeaturesTitle: "Créez des visuels de haute qualité avec le générateur de texte en image FLUX.1",
                keyFeaturesIntro: "Explorez les fonctionnalités de Flux Pro 1.1 Ultra et Flux Schnell pour une compréhension rapide, une vitesse de sortie, des styles visuels et des proportions flexibles.",
                exploreTitle: "Explorez davantage de modèles d'images IA",
                mainFeaturesTitle: "Principales fonctionnalités de FLUX.1",
                generatedImageLabel: "Image générée",
                versionLabel: "Version",
                featureLabel: "Principales fonctionnalités",
                useCaseLabel: "Idéal pour",
                controlsTitle: "Choisissez le bon modèle, le bon ratio et le bon style visuel",
                controlsIntro: "Utilisez Flux Pro 1.1 Ultra pour des images finales soignées ou Flux Schnell pour une exploration plus rapide, puis adaptez le rapport hauteur/largeur et le style au canal souhaité.",
                galleryTitle: "Plus d'exemples d'images FLUX.1",
                discussionTitle: "Questions courantes de sélection FLUX.1",
                communityTitle: "Façons populaires de créer avec FLUX.1",
                tutorialPrompt: "Une librairie sous serre tranquille au bord de la mer au lever du soleil, des lampes de lecture chaleureuses, des étagères en chêne pâle, de doux reflets sur le sol, des photographies intérieures réalistes.",
                qualityBenefits: [
                    "Rendu des matériaux, de l’éclairage et de la profondeur spatiale avec une finition plus soignée.",
                    "Suivez les invites détaillées qui combinent le sujet, la composition, l'appareil photo et le style.",
                    "Explorez les directions photographiques, artistiques numériques et animées à partir d’instructions textuelles claires."
                ],
                features: [
                    { name: "Texte en image FLUX.1 de haute qualité", short: "Transformez les invites écrites en visuels détaillés et professionnels.", desc: "Flux Pro 1.1 Ultra est adapté aux travaux où les détails de l'image, les matériaux, l'éclairage et la finition globale sont importants. Décrire clairement le sujet, la composition, l'appareil photo et le style permet d'orienter l'image vers la direction de votre projet.", demo: { type: 'table', rows: [
                        { prompt: "Extérieur de l'hôtel-boutique du désert à l'heure bleue, murs en pisé, lueur chaude des fenêtres, herbes indigènes, longues ombres, photographie architecturale réaliste.", image: require('@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp') },
                        { prompt: "Photographie culinaire éditoriale de raviolis faits à la main sur une assiette noire mate, huile de basilic, serviette en lin, lumière de fenêtre directionnelle, faible profondeur de champ.", image: require('@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp') }
                    ] } },
                    { name: "Génération rapide avec Flux Schnell", short: "Créez des brouillons rapides, testez les invites et explorez rapidement les idées.", desc: "Flux Schnell convient parfaitement aux flux de travail qui nécessitent des tests rapides de composition, de style ou de concept. Générez un brouillon, examinez la direction, puis affinez l'invite pour une autre itération.", prompt: "Un concept de stand de salon modulaire en carton pour une startup écologique, des socles de produits simples, des textures de papier recyclé, un éclairage d'exposition lumineux, une mise en page épurée.", image: require('@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp') },
                    { name: "Neuf formats d'image", short: "Couvrez les formats ultra-large, paysage, carré, portrait et grand.", desc: "Flux Pro 1.1 Ultra et Flux Schnell prennent tous deux en charge les formats 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 et 9:21 pour les bannières, les images de produits, le contenu social, les affiches et les visuels mobiles.", prompt: "Un observatoire alpin panoramique 21:9 au-dessus d'une mer de nuages, une terrasse d'observation en verre, une lumière matinale, de minuscules randonneurs à l'échelle, un matte painting cinématographique.", image: require('@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp') },
                    { name: "Plusieurs styles visuels dans Schnell", short: "Choisissez Auto, Photographie, Art numérique ou Anime.", desc: "Flux Schnell propose des directions de style Auto, Photographie, Art numérique et Anime, permettant de basculer facilement entre les visuels photo-réels, illustrés et animés sans changer de modèle.", demo: { type: 'table', rows: [
                        { prompt: "Style photographique : un mécanicien vélo ajustant un vélo de course vintage dans un garage ensoleillé, mains tachées de graisse, reflets chromés réalistes.", image: require('@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp') },
                        { prompt: "Style anime : un café pour chats confortable à l'intérieur d'un train aérien, des nuages ​​de coucher de soleil pastel devant les fenêtres, des personnages expressifs, des dessins au trait épurés.", image: require('@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp') }
                    ] } },
                    { name: "Cas d'utilisation créative flexibles", short: "Créez des visuels de produits, de marketing, de portraits, de concepts et sociaux.", desc: "La famille FLUX.1 prend en charge des images de produits et de marques raffinées ainsi que des concepts de campagne rapides, des portraits, des conceptions d'environnement et des formats d'image spécifiques à la plate-forme.", prompt: "Visuel de lancement de baskets durables avec texture en tissu recyclé, détails en dentelle flottante, fond dégradé vert mousse, espace vide audacieux pour la copie publicitaire sur les réseaux sociaux.", image: require('@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp') }
                ],
                showcaseKicker: "Exemples rapides",
                showcaseTitle: "Exemples d'invites FLUX.1 pour de meilleures images d'IA",
                showcaseIntro: "Utilisez ces invites FLUX.1 comme point de départ. Décrivez clairement le sujet, la composition, l'éclairage, l'appareil photo, les matériaux, la palette de couleurs et le style visuel.",
                variantsKicker: "Guide des modèles",
                variantsTitle: "Flux Pro 1.1 Ultra contre Flux Schnell",
                variantsIntro: "Choisissez un modèle FLUX.1 en fonction de la qualité, de la vitesse et du contrôle de style dont votre projet a besoin.",
                variants: [
                    { name: "Flux Pro 1.1 Ultra", tag: "Haute qualité", desc: "Conçu pour un travail de texte-image détaillé, réaliste et soigné avec neuf formats d'image pris en charge.", bestFor: "Idéal pour la photographie de produits, les images de héros de campagne et les visuels finaux soignés" },
                    { name: "Flux Schnell", tag: "Rapide", desc: "Conçu pour une itération rapide avec neuf formats d’image et styles Auto, Photographie, Art numérique et Anime.", bestFor: "Idéal pour les brouillons, les tests rapides, le contenu social et l'exploration rapide" }
                ],
                useCasesKicker: "Conçu pour un vrai travail",
                useCasesTitle: "Cas d'utilisation populaires de FLUX.1",
                useCases: [
                    { name: "FLUX.1 pour la photographie de produits", desc: "Créez des images de héros de produits, des scènes de style de vie et des concepts visuels de commerce électronique." },
                    { name: "FLUX.1 pour le marketing et la publicité", desc: "Générez des publicités sociales, des bannières de campagne et des visuels marketing de marque." },
                    { name: "FLUX.1 pour les portraits photoréalistes", desc: "Créez des portraits de type photo avec un éclairage, des arrière-plans et une composition contrôlés." },
                    { name: "FLUX.1 pour l'art numérique", desc: "Utilisez Schnell pour explorer rapidement les directions de l’illustration, de la fantaisie et de l’art numérique." },
                    { name: "FLUX.1 pour les images d’anime", desc: "Utilisez le style Schnell Anime pour les personnages et les scènes d’anime." },
                    { name: "FLUX.1 pour l'art conceptuel", desc: "Explorez des environnements cinématographiques, des scènes de jeu, des personnages et des mondes visuels." },
                    { name: "FLUX.1 pour les images de réseaux sociaux", desc: "Utilisez neuf formats d’image pour le contenu de la plate-forme paysage, carré et portrait." },
                    { name: "FLUX.1 pour affiches et banderoles", desc: "Choisissez un ratio adapté aux événements, aux promotions et aux concepts de mise en page mobile." }
                ],
                howToKicker: "Trois étapes simples",
                howToTitle: "Comment utiliser gratuitement le générateur d'images AI FLUX.1 en ligne",
                howToIntro: "Inscrivez-vous pour recevoir des crédits gratuits et utilisez Flux Pro 1.1 Ultra ou Flux Schnell en ligne sur Miral.",
                howToSteps: [
                    { title: "Entrez une invite détaillée", desc: "Décrivez le sujet, le décor, la composition, l'éclairage, l'appareil photo, les matériaux, les couleurs et le style cible." },
                    { title: "Choisissez le modèle et le rapport", desc: "Choisissez Pro 1.1 Ultra pour une qualité soignée ou Schnell pour une exploration rapide, puis définissez un rapport hauteur/largeur et un style Schnell." },
                    { title: "Générer et affiner", desc: "Générez l'image, examinez-la et téléchargez-la, ou ajustez l'invite, le rapport ou le style pour une autre version." }
                ],
                howToCta: "Utilisez le générateur d'images AI FLUX.1 gratuitement",
                faqTitle: "Foire aux questions sur FLUX.1",
                faqs: [
                    { q: "Qu'est-ce que le générateur d'images FLUX.1 AI ?", a: "FLUX.1 est une famille de modèles de génération d'images de Black Forest Labs. Sur Miral, utilisez Flux Pro 1.1 Ultra et Flux Schnell pour transformer les invites textuelles en images de produits, de marketing, de portraits, d'anime et d'art conceptuel." },
                    { q: "Puis-je utiliser gratuitement le générateur d’images FLUX.1 AI ?", a: "Oui. Inscrivez-vous pour recevoir des crédits gratuits et commencez immédiatement à créer des images de haute qualité avec le générateur d'images FLUX.1 AI. La génération d'images utilise les crédits correspondants." },
                    { q: "Quelle est la différence entre Flux Pro 1.1 Ultra et Flux Schnell ?", a: "Flux Pro 1.1 Ultra est adapté aux images finales soignées où les détails et la finition comptent. Flux Schnell est adapté aux brouillons rapides, aux tests rapides et à l'exploration multi-styles, avec les styles Auto, Photographique, Art numérique et Anime." },
                    { q: "Quels formats d’image sont pris en charge par FLUX.1 ?", a: "Flux Pro 1.1 Ultra et Flux Schnell sur Miral prennent en charge 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 et 9:21, pour un total de neuf formats d'image." },
                    { q: "Quels styles Flux Schnell prend-il en charge ?", a: "Flux Schnell prend en charge Auto, Photographic, Digital Art et Anime pour la correspondance automatique, les images photoréalistes, l'illustration numérique et les visuels d'anime." },
                    { q: "Comment utiliser le générateur d'images FLUX.1 AI en ligne ?", a: "Saisissez une invite de texte, choisissez Flux Pro 1.1 Ultra ou Flux Schnell et définissez un rapport hauteur/largeur. Avec Schnell, vous pouvez également sélectionner un style visuel avant de cliquer sur Générer." },
                    { q: "Quels sont les meilleurs exemples d'invites FLUX.1 ?", a: "Les invites FLUX.1 efficaces décrivent clairement le sujet, le décor, la composition, l'éclairage, l'appareil photo, les matériaux, la palette de couleurs et le style cible. Utilisez les exemples de cette page comme point de départ et adaptez-les à votre projet." },
                    { q: "FLUX.1 vs FLUX.2 : lequel dois-je utiliser ?", a: "Choisissez FLUX.1 pour une sortie soignée avec Flux Pro 1.1 Ultra ou une création multistyle rapide avec Flux Schnell. Choisissez la page FLUX.2 sur Miral lorsque vous avez besoin de ses variantes Klein, Max, Pro et Flex." },
                    { q: "FLUX.1 vs Midjourney : lequel dois-je utiliser ?", a: "FLUX.1 convient parfaitement aux formats d'image explicites, au flux de travail rapide de Schnell ou à la sortie Pro 1.1 Ultra raffinée. Midjourney peut convenir aux utilisateurs qui préfèrent ses styles artistiques, son flux de travail d'images de référence et son processus créatif." }
                ],
                ctaTitle: "Utilisez FLUX.1 gratuitement sur Miral !",
                ctaDesc: "Inscrivez-vous pour recevoir des crédits gratuits. Choisissez Flux Pro 1.1 Ultra ou Flux Schnell et créez des images avec le rapport et le style dont votre projet a besoin."
            },
            flux2: {
                title: "FLUX.2 Générateur d'images AI gratuit en ligne | Miral",
                description: "Créez des images IA photoréalistes en ligne avec FLUX.2. Choisissez cinq variantes de modèles pour les photos de produits, les affiches, les illustrations et les visuels marketing raffinés.",
                heroHeadline: "Générateur d'images IA FLUX.2",
                heroIntro: "Utilisez gratuitement le générateur d'images FLUX.2 AI de Black Forest Labs sur Miral AI. Inscrivez-vous pour recevoir des crédits gratuits et créer instantanément des images photoréalistes de haute qualité, des photographies de produits, des affiches et des visuels marketing.",
                eyebrow: "Laboratoires de la Forêt-Noire · FLUX.2",
                sectionKicker: "FLUX.2",
                ctaTag: "FLUX.2 · Miral",
                badges: ["Texte en image", "Photoréaliste", "Typographie précise", "Rapports d'aspect multiples"],
                previewLabel: "FLUX.2",
                previewMeta: ["1:1", "1024 × 1024", "PNG"],
                previewTitle: "D'une invite précise à un visuel prêt pour la production",
                previewDesc: "Créez des photos de produits détaillées, des concepts de campagne, des portraits et des conceptions riches en texte dans un seul flux de travail rationalisé.",
                keyFeaturesTitle: "Créez des visuels professionnels avec le générateur de texte en image FLUX.2",
                keyFeaturesIntro: "Explorez les principales fonctionnalités du générateur d'images FLUX.2 AI pour des invites précises, des détails soignés, une sortie réaliste et un contrôle visuel fiable.",
                exploreTitle: "Explorez davantage de modèles d'images IA",
                mainFeaturesTitle: "Principales fonctionnalités de FLUX.2",
                generatedImageLabel: "Image générée",
                versionLabel: "Version",
                featureLabel: "Principales fonctionnalités",
                useCaseLabel: "Idéal pour",
                controlsTitle: "Choisissez la bonne version de FLUX.2 et les bons paramètres de sortie",
                controlsIntro: "Utilisez Klein pour une itération rapide, Max pour une qualité finale optimale, Pro pour les flux de production ou Flex pour la typographie et le contrôle des détails.",
                galleryTitle: "Plus d'exemples d'images FLUX.2",
                discussionTitle: "Questions courantes sur le modèle FLUX.2",
                communityTitle: "Façons populaires de créer avec FLUX.2",
                tutorialPrompt: "Photographie de campagne haut de gamme d'un flacon de parfum émeraude translucide sur pierre calcaire pâle, lumière douce du matin, réfraction du verre réaliste, typographie raffinée, espace négatif généreux.",
                qualityBenefits: [
                    "Suivez des instructions détaillées avec un contrôle plus fort sur le sujet, la composition, l'éclairage et le style.",
                    "Créez des textures réalistes, de la profondeur et des détails soignés pour un travail visuel professionnel.",
                    "Gérez des affiches riches en texte, des étiquettes de produits et des graphiques de campagne avec une typographie plus claire."
                ],
                features: [
                    { name: "Synthèse d'images haut de gamme", short: "Offre une adhésion rapide et une qualité d’image améliorées sans latence supplémentaire.", desc: "FLUX.2 améliore considérablement l'alignement des invites et prend même en charge les entrées longues telles que les scripts détaillés et les descriptions de scènes. Il garantit que les images générées offrent une plus grande fidélité sans compromettre la vitesse, ce qui réduit le besoin d'ajustements itératifs et permet aux créateurs d'atteindre un résultat final plus rapidement.", demo: { type: 'table', rows: [
                        { prompt: "Un paysage époustouflant aux couleurs vibrantes et aux détails complexes, mettant en valeur un coucher de soleil sur une chaîne de montagnes.",image: require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
                        { prompt: "Art abstrait pour la traduction entre langages fonctionnels et langages de bas niveau." ,image: require('@/assets/images/flux2/sample.webp')},
                        { prompt: "Une photo d'un personnage d'anime/de dessin animé, détaillée et bien faite, mais qui semble faite par l'homme." ,image: require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp')}
                    ] } },
                    { name: "Détails et réalisme supérieurs", short: "Produit des textures, un éclairage et une profondeur réalistes pour des visuels de qualité studio.", desc: "FLUX.2 capture des textures fines, un éclairage réaliste et une profondeur naturelle qui donnent aux images générées un aspect véritablement photographique. Cela en fait un choix idéal pour les photos de produits, les portraits et les visuels cinématographiques où la crédibilité compte le plus.", prompt: "Photographie de produit en studio d'une montre mécanique argentée sur ardoise sombre, éclairage latéral doux, texture réaliste en métal brossé, faible profondeur de champ, reflets subtils, composition éditoriale haut de gamme." ,image: require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
                    { name: "Forte adhésion rapide", short: "Suit de près les invites complexes, y compris les sujets, styles et compositions spécifiques.", desc: "FLUX.2 interprète les invites superposées en plusieurs parties avec une précision impressionnante – en gérant des sujets spécifiques, des styles artistiques, des palettes de couleurs et des instructions de composition en une seule génération. Cela donne aux créateurs plus de contrôle et moins de relances lorsqu'ils décrivent exactement ce qu'ils veulent.", prompt: "Un tramway rouge traversant une place européenne pluvieuse au crépuscule, trois cyclistes au premier plan, des fenêtres de café chaleureuses à gauche, un ciel horaire bleu, une composition symétrique, une photographie cinématographique.",image: require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
                    { name: "Gestion avancée de la typographie", short: "Rend le texte dans les images avec une orthographe et une cohérence de style plus claires.", desc: "FLUX.2 offre une génération et un contrôle de texte améliorés sur les images, avec une cohérence plus précise des styles de police. Cela permet de produire du matériel textuel et de la signalisation pour des affiches, des publicités, des bandes dessinées et des graphiques de marque avec beaucoup moins d'artefacts.", demo: { type: 'table', rows: [
                        { prompt: "Une belle photo de paysage mystique avec le texte \"FLUX 2\", d'une beauté subtile, intégrant des myrtilles." ,image: require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
                        { prompt: "Un gâteau Forêt-Noire épelant les mots \"FLUX 2 Pro\", une photographie culinaire savoureuse." ,image: require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
                    ] } },
                    { name: "Génération rapide et évolutive", short: "Choisissez entre une itération inférieure à la seconde et une sortie de qualité maximale.", desc: "FLUX.2 couvre les modèles Klein rapides et les variantes Pro, Max et Flex axées sur la production. Cette gamme est pratique pour les brouillons rapides, la production de contenu par lots et les ressources marketing ou créatives de qualité finale.", prompt: "Une photo de produit éditoriale épurée représentant un flacon de parfum vert translucide sur du calcaire, une douce lumière matinale, des ombres subtiles, une esthétique de campagne haut de gamme." ,image: require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp')}
                ],
                showcaseKicker: "Exemples rapides",
                showcaseTitle: "Exemples d'invites FLUX.2 pour de meilleures images d'IA",
                showcaseIntro: "Utilisez ces exemples d'invites FLUX.2 comme point de départ, personnalisez le sujet, la composition, l'éclairage et le style, puis envoyez votre invite directement au générateur.",
                variantsKicker: "Guide des modèles",
                variantsTitle: "Comparaison des modèles FLUX.2 : Klein vs Max vs Pro vs Flex",
                variantsIntro: "Comparez FLUX.2 Klein, Max, Pro et Flex pour choisir le bon modèle d'image IA pour une itération rapide, des ressources de qualité finale, une échelle de production ou un contrôle précis de la typographie.",
                variants: [
                    { name: "FLUX.2 Klein 4B / 9B", tag: "Le plus rapide", desc: "Choisissez FLUX.2 Klein pour une génération rapide d'images, de brouillons et de prototypage rapides à grand volume.", bestFor: "Idéal pour les brouillons, les lots et les itérations rapides" },
                    { name: "FLUX.2 Max", tag: "La plus haute qualité", desc: "Choisissez FLUX.2 Max pour les actifs finaux, le suivi des invites le plus puissant et la génération ancrée.", bestFor: "Idéal pour les campagnes premium et les images de héros" },
                    { name: "FLUX.2 Pro", tag: "Fabrication", desc: "Choisissez FLUX.2 Pro pour un équilibre de qualité production entre qualité d’image, délai d’exécution et sortie évolutive.", bestFor: "Idéal pour le marketing et la production de contenu" },
                    { name: "FLUX.2 Flex", tag: "Contrôle", desc: "Choisissez FLUX.2 Flex pour un guidage, une typographie, un rendu de texte et une préservation des petits détails réglables.", bestFor: "Idéal pour les affiches, les étiquettes et les éléments de conception" }
                ],
                useCasesKicker: "Conçu pour un vrai travail",
                useCasesTitle: "Cas d'utilisation populaires de FLUX.2",
                useCases: [
                    { name: "FLUX.2 pour la photographie de produits", desc: "Créez des photos de produits soignées, des scènes de style de vie et des variations d'images de commerce électronique." },
                    { name: "FLUX.2 pour le marketing et la publicité", desc: "Transformez les concepts de campagne en publicités sociales, bannières et visuels de marque cohérents." },
                    { name: "FLUX.2 pour affiches et typographie", desc: "Utilisez le rendu de texte FLUX.2 pour produire des titres, des étiquettes, des affiches et des graphiques textuels plus clairs." },
                    { name: "FLUX.2 pour les portraits photoréalistes", desc: "Générez des portraits IA détaillés avec un éclairage, un style et une composition contrôlés." },
                    { name: "FLUX.2 pour l'art conceptuel", desc: "Explorez rapidement les environnements cinématographiques, les personnages et les directions visuelles." },
                    { name: "FLUX.2 pour la conception éditoriale", desc: "Créez des illustrations et des couvertures distinctives pour les articles et les présentations." }
                ],
                howToKicker: "Trois étapes simples",
                howToTitle: "Comment utiliser le générateur d'images AI FLUX.2 en ligne",
                howToIntro: "Utilisez le générateur d'images FLUX.2 AI en ligne sur Miral pour passer d'une invite de texte détaillée à une image générée.",
                howToSteps: [
                    { title: "Entrez votre invite", desc: "Décrivez le sujet, la composition, l'éclairage, les couleurs, le style et tout texte que vous souhaitez voir apparaître dans l'image." },
                    { title: "Choisissez les paramètres FLUX.2", desc: "Ouvrez le générateur, sélectionnez Klein, Max, Pro ou Flex, puis choisissez la taille de sortie qui correspond à votre projet." },
                    { title: "Générez votre image", desc: "Démarrez la génération, examinez le résultat et téléchargez l'image ou affinez votre invite pour une autre version." }
                ],
                howToCta: "Essayez le générateur d'images AI FLUX.2",
                faqTitle: "Foire aux questions sur FLUX.2",
                faqs: [
                    { q: "Qu’est-ce que FLUX.2 ?", a: "FLUX.2 est le modèle d'IA texte-image de nouvelle génération de Black Forest Labs. Il transforme les invites écrites en images détaillées de haute qualité et est disponible sur Miral pour l'art, le design, le marketing et la création visuelle de produits directement dans votre navigateur." },
                    { q: "Quel outil puis-je utiliser pour créer des photographies de produits et des visuels marketing riches en texte ?", a: "FLUX.2 combine cohérence rapide, détails, photoréalisme et gestion de la typographie pour une photographie de produits professionnelle et des visuels marketing riches en texte qui exigent fidélité et précision." },
                    { q: "Puis-je utiliser le générateur d’images FLUX.2 AI gratuitement ?", a: "Oui. Inscrivez-vous pour recevoir des crédits gratuits et commencez immédiatement à créer des images de haute qualité avec le générateur d'images FLUX.2 AI. La génération d'images utilise les crédits correspondants." },
                    { q: "Comment utiliser le générateur d'images FLUX.2 AI en ligne ?", a: "Entrez une invite de texte détaillée, choisissez FLUX.2 Klein, Max, Pro ou Flex, sélectionnez une taille d'image et cliquez sur Générer. FLUX.2 fonctionne bien pour les supports marketing, la photographie de produits, les concepts cinématographiques, les créations sociales et la conception d'affiches." },
                    { q: "Combien de temps faut-il pour générer FLUX.2 ?", a: "Le temps de génération dépend de la variante FLUX.2 sélectionnée, de la taille de l'image et de la charge de service actuelle. Klein est conçu pour une itération très rapide, tandis que Max, Pro et Flex donnent la priorité à différents équilibres de qualité et de contrôle." },
                    { q: "Comment réparer une image FLUX.2 qui ne suit pas mon invite ?", a: "Décrivez plus explicitement le sujet, le décor, la composition, l'éclairage, l'appareil photo ou le style artistique, les couleurs et tout texte requis. Utilisez les exemples d'invites FLUX.2 sur cette page comme point de départ et personnalisez-les pour votre projet." },
                    { q: "Quel modèle FLUX.2 dois-je choisir ?", a: "Choisissez FLUX.2 Klein pour des brouillons et des lots rapides, Max pour des ressources finales de la plus haute qualité, Pro pour la génération d'images à l'échelle de la production ou Flex lorsque la typographie et le contrôle précis sont les plus importants." },
                    { q: "FLUX.2 Max vs Pro : quelle est la différence ?", a: "FLUX.2 Max donne la priorité à une qualité maximale, à un suivi rapide des invites et à une génération fondée. FLUX.2 Pro équilibre qualité de production, délais d'exécution plus rapides et sortie évolutive pour les flux de travail créatifs quotidiens." },
                    { q: "FLUX.2 vs Midjourney : lequel dois-je utiliser ?", a: "Choisissez en fonction du flux de travail plutôt que d'un gagnant universel. FLUX.2 convient parfaitement au suivi précis des invites, à la typographie, aux visuels de produits et à la production basée sur des API. Midjourney peut convenir aux créateurs qui préfèrent son flux de travail artistique distinctif et ses outils communautaires." }
                ],
                ctaTitle: "Essayez FLUX.2 gratuitement sur Miral !",
                ctaDesc: "Entrez votre idée ci-dessus et utilisez le générateur d'images FLUX.2 AI pour créer des images détaillées avec la variante de modèle qui correspond à votre flux de travail."
            },
            seedream: {
                title: "Générateur d'images Seedream AI gratuit en ligne | Miral",
                description: "Générez des images IA de haute qualité en ligne avec Seedream. Obtenez une compréhension précise et rapide, un rendu de texte clair et une sortie 2K-4K détaillée pour vos projets créatifs.",
                heroHeadline: "Générateur d'images Seedream IA",
                heroIntro: "Utilisez gratuitement le générateur d’images Seedream AI. Inscrivez-vous pour recevoir des crédits gratuits et créer instantanément des visuels de produits, des affiches, des portraits et des images marketing de haute qualité.",
                eyebrow: "Graine ByteDance · Seedream IA",
                sectionKicker: "IA Seedream",
                ctaTag: "Rêve de graines · Miral",
                badges: ["Texte en image", "Compréhension de l'intention", "Sortie 2K/3K/4K", "Rendu de texte clair"],
                previewLabel: "IA Seedream",
                previewMeta: ["1:1", "2K/3K/4K", "Taille personnalisée"],
                previewTitle: "De l’intention créative au visuel précis et haute résolution",
                previewDesc: "Créez des compositions complexes, des photos de produits, des portraits et des conceptions riches en texte avec des détails raffinés et un contrôle rapide fiable.",
                keyFeaturesTitle: "Créez des visuels précis avec le générateur de texte en image Seedream AI",
                keyFeaturesIntro: "Explorez les fonctionnalités de Seedream AI pour une compréhension plus approfondie des intentions, une composition complexe, une sortie haute résolution, des détails réalistes et un rendu de texte précis grâce à la génération de texte en image.",
                exploreTitle: "Explorez les modèles d'IA Seedream",
                mainFeaturesTitle: "Principales fonctionnalités de synthèse texte-image de Seedream AI",
                seedream5Desc: "Utilisez le dernier modèle Seedream pour des invites précises, un réalisme raffiné, un rendu de texte et une sortie haute résolution.",
                seedream4Desc: "Ouvrez le flux de travail Seedream 4 établi pour une création de texte en image fiable et des paramètres de sortie flexibles.",
                features: [
                    { name: "Compréhension rapide et plus approfondie", short: "Interprète l’intention créative, les relations spatiales et les instructions détaillées.", desc: "Seedream AI va au-delà de la simple correspondance de termes d'invite isolés. Il raisonne sur les relations entre les sujets, la mise en page, les attributs et le contexte visuel pour produire des résultats plus cohérents à partir d'instructions textuelles complexes.", demo: { type: 'table', rows: [
                        { prompt: "Une étagère d'exposition 3x3, vue de face, avec neuf objets différents disposés par matériau et couleur, un éclairage de studio cohérent et un alignement spatial précis.", image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
                        { prompt: "Photo de produit éditorial d'une montre à côté de linge plié et d'une tasse en céramique, composition triangulaire équilibrée, douce lumière du matin.", image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp') },
                        { prompt: "Une scène de marché cinématographique avec des acheteurs au premier plan, un sujet central clair, une profondeur superposée et une lumière chaude réfléchie sur un trottoir mouillé.", image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp') }
                    ] } },
                    { name: "Contrôle de composition complexe", short: "Gère plusieurs sujets, attributs et mises en page structurées avec une plus grande cohérence.", desc: "Le générateur d'images Seedream AI suit des instructions en plusieurs parties sur des scènes complexes, aidant ainsi à préserver les attributs, les positions, les couleurs et les relations des objets demandés dans une seule composition.", prompt: "Une scène éditoriale de face avec trois vases en céramique de formes différentes sur des plates-formes en pierre décalées, une sphère rouge derrière le vase le plus haut, un éclairage latéral doux, un espacement équilibré, un fond de studio neutre.", image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
                    { name: "Sortie 2K, 3K et 4K", short: "Sélectionnez une résolution de sortie en fonction des détails et des dimensions dont votre projet a besoin.", desc: "Seedream AI prend en charge les sorties 2K, 3K et 4K sélectionnables sur Miral, ainsi que des tailles d'image personnalisées. Choisissez en fonction des dimensions et du niveau de détail requis pour votre utilisation finale.", prompt: "Un vaste paysage cinématographique d'une ville côtière futuriste au lever du soleil, une architecture en couches, une eau réfléchissante, une profondeur atmosphérique, des détails de construction complexes, une composition panoramique.", image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp') },
                    { name: "Rendu de texte amélioré", short: "Crée un texte plus clair pour les affiches, les mises en page, les étiquettes et les graphiques de présentation.", desc: "Seedream AI combine le raisonnement visuel avec une création de texte améliorée, ce qui la rend utile pour les affiches, les graphiques de présentation, les publicités, les concepts d'emballage et autres mises en page où le texte lisible fait partie de l'image.", demo: { type: 'table', rows: [
                        { prompt: "Affiche d'événement minimaliste avec le titre \"DESIGN FOR TOMORROW\", caractères géométriques gras, fond blanc, grille d'accents verts.", image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp') },
                        { prompt: "Emballage de café haut de gamme étiqueté « MIRAL ROAST », notes de dégustation concises, texture de papier chaude, photographie de produits en studio.", image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
                    ] } },
                    { name: "Détails raffinés et réalisme", short: "Produit un éclairage, des matériaux, une profondeur et une présentation du produit convaincants.", desc: "Seedream AI produit des textures raffinées et un éclairage cohérent pour la photographie de produits, les portraits, les visuels éditoriaux et les concepts cinématographiques où la clarté et la structure crédible sont importantes.", prompt: "Une photo de produit éditoriale épurée représentant un flacon de parfum vert translucide sur du calcaire, une douce lumière matinale, des ombres subtiles, une esthétique de campagne haut de gamme.", image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp') }
                ],
                showcaseKicker: "Exemples rapides",
                showcaseTitle: "Exemples d'invites Seedream AI pour de meilleures images IA",
                showcaseIntro: "Utilisez ces exemples d’invites Seedream AI comme point de départ. Décrivez clairement les sujets, les relations spatiales, le texte, l'éclairage et la mise en page, puis envoyez l'invite directement au générateur.",
                variantsKicker: "Guide de résolution",
                variantsTitle: "Guide de résolution Seedream AI : 2K contre 3K contre 4K",
                variantsIntro: "Choisissez une résolution de sortie Seedream AI en fonction de la rapidité avec laquelle vous souhaitez itérer et du niveau de détails requis par l'élément final.",
                variants: [
                    { name: "2K", tag: "Sortie standard", desc: "Une solution pratique pour le contenu social, le travail créatif quotidien et les mises en page numériques standard.", bestFor: "Idéal pour le contenu numérique régulier" },
                    { name: "3K", tag: "Plus de détails", desc: "Ajoute plus de détails à l'image et prend en charge des mises en page plus grandes pour le travail de marketing et de présentation.", bestFor: "Idéal pour les ressources de marketing et de présentation" },
                    { name: "4K", tag: "Détails maximaux", desc: "Utilisez le préréglage le plus élevé lorsque des textures fines, des mises en page contenant beaucoup de texte ou une qualité de livraison supérieure sont importantes.", bestFor: "Idéal pour les campagnes finales et les sorties haute résolution" }
                ],
                useCasesKicker: "Conçu pour un vrai travail",
                useCasesTitle: "Cas d'utilisation populaires de l'IA Seeddream",
                useCases: [
                    { name: "Seedream AI pour la photographie de produits", desc: "Créez des photos de produits soignées, des scènes de style de vie et des concepts d'image de commerce électronique." },
                    { name: "Seedream IA pour le marketing", desc: "Transformez vos idées de campagne structurées en publicités sociales, bannières et visuels de marque." },
                    { name: "Seedream AI pour les affiches et le texte", desc: "Produisez des concepts d’affiches, des graphiques de présentation, des étiquettes et des mises en page basées sur du texte." },
                    { name: "Seedream AI pour les compositions complexes", desc: "Organisez plusieurs sujets et attributs demandés dans une structure visuelle cohérente." },
                    { name: "L'IA Seeddream pour l'art conceptuel", desc: "Explorez des environnements cinématographiques, des personnages et des instructions visuelles détaillées." },
                    { name: "Seedream AI pour les visuels éditoriaux", desc: "Créez des couvertures, des illustrations, des infographies et des images prêtes pour la présentation." }
                ],
                howToKicker: "Trois étapes simples",
                howToTitle: "Comment utiliser gratuitement le générateur d'images Seedream AI en ligne",
                howToIntro: "Inscrivez-vous pour recevoir des crédits gratuits et utilisez le générateur d'images Seedream AI en ligne avec une invite claire et la résolution requise par votre projet.",
                howToSteps: [
                    { title: "Entrez votre intention créative", desc: "Décrivez les sujets, les relations spatiales, la composition, l'éclairage, le style et le texte requis aussi clairement que possible." },
                    { title: "Choisissez la résolution et la taille", desc: "Ouvrez le générateur et sélectionnez 2K, 3K, 4K ou une taille personnalisée prise en charge en fonction de votre utilisation finale." },
                    { title: "Générer et réviser", desc: "Démarrez la génération, examinez la composition et les détails, puis téléchargez le résultat ou ajustez votre invite." }
                ],
                howToCta: "Utilisez le générateur d'images Seedream AI gratuitement",
                faqTitle: "Foire aux questions sur Seedream AI",
                faqs: [
                    { q: "Qu'est-ce que le générateur d'images Seedream AI ?", a: "Seedream AI est un modèle de création d'images intelligent de l'équipe Seed de ByteDance. Sur Miral, il transforme des invites textuelles détaillées en images haute résolution pour la conception, le marketing, les concepts de produits, les affiches et les visuels éditoriaux." },
                    { q: "Quel outil puis-je utiliser pour créer des affiches haute résolution avec du texte clair ?", a: "Seedream AI combine une compréhension plus approfondie des intentions, une composition précise, une création de texte améliorée et une sortie haute résolution sélectionnable pour les affiches et autres mises en page riches en texte." },
                    { q: "Puis-je utiliser le générateur d’images Seedream AI gratuitement ?", a: "Oui. Inscrivez-vous pour recevoir des crédits gratuits et commencez immédiatement à créer des images de haute qualité avec le générateur d'images Seedream AI. La génération d'images utilise les crédits correspondants." },
                    { q: "Comment utiliser le générateur d'images Seedream AI en ligne ?", a: "Entrez une invite de texte détaillée, choisissez la sortie 2K, 3K ou 4K, sélectionnez éventuellement une taille personnalisée et cliquez sur Générer. Pour de meilleurs résultats, décrivez clairement les sujets, les relations spatiales, les attributs, l'éclairage, le texte et la mise en page." },
                    { q: "Seedream AI prend-il en charge les images 2K, 3K et 4K ?", a: "Oui. Miral expose les préréglages de résolution 2K, 3K et 4K pour Seedream AI, ainsi que les dimensions personnalisées prises en charge pour différents rapports d'aspect et besoins de livraison." },
                    { q: "Comment réparer les images Seedream avec un texte ou une composition incorrecte ?", a: "Décrivez plus explicitement le sujet, les relations entre les objets, la composition, l'éclairage, les couleurs, le style et le texte requis. Utilisez les exemples Seedream sur cette page comme point de départ et énoncez clairement chaque exigence visuelle." },
                    { q: "Quelle résolution Seedream AI dois-je choisir ?", a: "Choisissez 2K pour le contenu numérique standard, 3K lorsque les mises en page de marketing ou de présentation nécessitent plus de détails et 4K lorsqu'un maximum de détails est important pour les grandes campagnes finales, les affiches ou les éléments de conception haut de gamme." },
                    { q: "Seedream AI vs Midjourney : lequel dois-je utiliser ?", a: "Seedream AI convient parfaitement aux invites structurées, aux compositions complexes, aux mises en page riches en texte et aux sorties haute résolution sélectionnables dans Miral. Midjourney peut convenir aux créateurs qui préfèrent son flux de travail artistique distinctif et ses outils communautaires." }
                ],
                ctaTitle: "Utilisez Seedream AI gratuitement sur Miral !",
                ctaDesc: "Inscrivez-vous pour recevoir des crédits gratuits. Décrivez votre idée, choisissez la bonne résolution et utilisez le générateur d'images Seedream AI pour créer des visuels précis et haute résolution."
            },
            gptImage: {
                title: "GPT Image AI Générateur d'images gratuit en ligne | Miral",
                description: "Générez des images IA de haute qualité en ligne avec GPT Image et GPT-Image-1.5 sur Miral AI. Choisissez des formats et des niveaux de qualité pratiques pour vos affiches, produits et portraits.",
                heroHeadline: "Générateur d'images IA d'images GPT",
                heroIntro: "Utilisez gratuitement le générateur d'images GPT Image AI sur Miral AI. Inscrivez-vous pour recevoir des crédits gratuits et créer instantanément des images de produits, des affiches, des portraits et des visuels marketing de haute qualité avec GPT-Image-1.5.",
                eyebrow: "OpenAI · GPT-Image-1.5",
                sectionKicker: "Image GPT",
                ctaTag: "Image GPT · Miral",
                badges: ["Texte en image", "Qualité sélectionnable", "Paysage / Portrait / Carré", "Compréhension précise et rapide"],
                previewLabel: "GPT-Image-1.5",
                previewMeta: ["1024 × 1024", "1536 × 1024", "1024 × 1536"],
                previewTitle: "D'une idée écrite à une image d'IA soignée et pratique",
                previewDesc: "Utilisez des invites claires et une qualité sélectionnable pour créer des visuels de produits, des affiches, des portraits et du contenu de marque.",
                keyFeaturesTitle: "Créez des visuels de haute qualité avec le générateur d'images GPT Image AI",
                keyFeaturesIntro: "Explorez les fonctionnalités de GPT-Image-1.5 pour une compréhension rapide, un contrôle qualité, des tailles d'image pratiques et une création visuelle professionnelle.",
                features: [
                    { name: "Invites en langage naturel et multi-sujets", short: "Décrire les sujets, la composition, l'éclairage, le style et les relations visuelles en langage naturel.", desc: "Le générateur d'images GPT Image AI prend en charge les invites en langage naturel avec plusieurs sujets, attributs et exigences de composition. Commencez par une simple invite ou spécifiez la position, la couleur et la relation de chaque sujet pour créer des images multi-sujets plus cohérentes.", demo: { type: 'table', rows: [
                        { prompt: "Photographie de produit éditoriale d'un flacon de parfum transparent sur un socle en pierre pâle, douce lumière du matin venant de la gauche, arrière-plan épuré, faible profondeur de champ, esthétique de marque haut de gamme.", image: require('@/assets/images/gptImage/perfume-editorial.webp') },
                        { prompt: "Une rue pluvieuse de la ville la nuit, trois piétons au premier plan tenant des parapluies de différentes couleurs, un tramway passant au loin, un néon réfléchi sur un trottoir mouillé, une large composition cinématographique.", image: require('@/assets/images/gptImage/rainy-city-tram.webp') }
                    ] } },
                    { name: "GPT-Image-1.5 Contrôle qualité", short: "Choisissez Auto, Faible, Moyen ou Élevé en fonction des besoins en matière de vitesse et de détails.", desc: "GPT-Image-1.5 propose des paramètres de qualité automatique, faible, moyenne et élevée. Utilisez une qualité inférieure pour une exploration rapide et une qualité supérieure pour les images du produit final, les affiches ou les ressources marketing.", prompt: "Publicité alimentaire de haute qualité représentant un gâteau aux fraises sur fond noir, texture crème croustillante, lumière douce du bord, photographie culinaire détaillée, composition commerciale.", image: require('@/assets/images/gptImage/strawberry-cake.webp') },
                    { name: "Trois tailles d'image pratiques", short: "Créez une sortie carrée, paysage et portrait.", desc: "Choisissez 1024×1024, 1536×1024 ou 1024×1536 pour les publications sociales, les bannières et les visuels de présentation, ou les affiches de portraits et le contenu mobile.", prompt: "Une affiche de voyage en format portrait 1024×1536 avec une falaise en bord de mer et un phare dans la brume matinale, un espace pour un titre en haut, une mise en page éditoriale moderne.", image: require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
                    { name: "Création de texte clair et de mise en page", short: "Créez des concepts d'affiches, d'étiquettes et de marque incluant du texte.", desc: "En indiquant clairement la copie requise, l'emplacement, l'ambiance typographique et les relations de mise en page, GPT Image peut aider à explorer les affiches, les emballages, les graphiques d'événements et les images marketing avec des titres.", demo: { type: 'table', rows: [
                        { prompt: "Affiche d'événement technologique minimaliste avec le titre « CRÉER LE FUTUR », caractères gras sans empattement, fond bleu profond, grille géométrique verte, titre clair centré.", image: require('@/assets/images/gptImage/create-the-future.webp') },
                        { prompt: "Concept d'emballage de café haut de gamme avec le texte « MIRAL ROAST » sur le devant, texture de papier brun chaud, étiquette propre, photographie de produits en studio.", image: require('@/assets/images/gptImage/miral-roast-package.webp') }
                    ] } },
                    { name: "Détail et réalisme", short: "Rendre les matériaux, l'éclairage, les personnes et les détails des produits crédibles.", desc: "GPT Image fonctionne bien pour la photographie de produits, les portraits, les intérieurs et les visuels éditoriaux lorsque l'invite décrit clairement les matériaux, les choix d'appareil photo, l'éclairage et la profondeur de champ.", prompt: "Portrait éditorial rapproché d'un artiste céramiste dans la lumière naturelle d'une fenêtre, texture de peau réaliste, poussière d'argile sur les mains, fond d'atelier, faible profondeur de champ, photographie éditoriale chaleureuse.", image: require('@/assets/images/gptImage/ceramic-artist.webp') }
                ],
                showcaseKicker: "Exemples rapides",
                showcaseTitle: "Exemples d'invites d'images GPT pour de meilleures images IA",
                showcaseIntro: "Utilisez ces invites d’image GPT comme point de départ. Décrivez clairement le sujet, la composition, l'éclairage, le style, les matériaux et tout texte requis.",
                variantsKicker: "Guide des versions",
                variantsTitle: "GPT-Image-1.5 vs GPT-Image-1",
                variantsIntro: "Choisissez une version d'image GPT selon que vous avez ou non besoin d'un contrôle qualité. Les deux prennent en charge les formats carrés, paysage et portrait pratiques.",
                variants: [
                    { name: "GPT-Image-1.5", tag: "Recommandé", desc: "Prend en charge 1024 × 1024, 1536 × 1024 et 1024 × 1536 avec les options de qualité automatique, faible, moyenne et haute.", bestFor: "Idéal pour le travail quotidien et professionnel nécessitant un contrôle qualité" },
                    { name: "GPT-Image-1", tag: "Classique", desc: "Prend en charge les trois mêmes tailles d’image pratiques avec un ensemble de commandes plus simples.", bestFor: "Idéal pour la création simple et générale de texte en image" }
                ],
                useCasesKicker: "Conçu pour un vrai travail",
                useCasesTitle: "Cas d'utilisation d'images GPT populaires",
                useCases: [
                    { name: "Image GPT pour la photographie de produits et les maquettes", desc: "Créez des images de héros de produits, des scènes de style de vie, des maquettes de produits et des concepts visuels de commerce électronique." },
                    { name: "Image GPT pour les images de listes de commerce électronique", desc: "Explorez les images de listes de produits, les graphiques de présentation, les présentations d'emballages et les concepts publicitaires." },
                    { name: "Image GPT pour les publicités marketing et sur les réseaux sociaux", desc: "Créez des publicités sur les réseaux sociaux, des bannières de campagne, des bannières de courrier électronique et des visuels marketing de marque." },
                    { name: "Image GPT pour l'UI/UX et les mises en page de sites Web", desc: "Générez des concepts visuels pour les interfaces d'applications, les mises en page de sites Web, les pages de destination et les pages de présentation de produits." },
                    { name: "Image GPT pour les infographies et les rapports visuels", desc: "Explorez les concepts de mise en page pour les infographies, les rapports visuels et les graphiques de présentation ; Vérifiez tous les textes et données avant utilisation finale." },
                    { name: "Image GPT pour les affiches et les emballages de produits", desc: "Explorez les affiches, les étiquettes de produits et les modèles d'emballage avec des exigences en matière de titre et de mise en page." },
                    { name: "Image GPT pour les couvertures de livres et les images de blog", desc: "Créez des couvertures de livres, des illustrations éditoriales, des en-têtes de blog et des concepts visuels de publication." },
                    { name: "Image GPT pour les portraits", desc: "Créez des portraits éditoriaux avec un éclairage, des arrière-plans et un style contrôlés." },
                    { name: "Image GPT pour les concepts de personnages de jeu", desc: "Explorez rapidement les personnages du jeu, les costumes, les accessoires et différentes directions artistiques." },
                    { name: "Image GPT pour les environnements de jeu", desc: "Générez des environnements de jeu, des scènes cinématographiques et des concepts de construction du monde pour une exploration créative précoce." },
                    { name: "Image GPT pour le contenu social", desc: "Générez des images carrées, paysagères et portraits pour différentes plates-formes." }
                ],
                howToKicker: "Trois étapes simples",
                howToTitle: "Comment utiliser gratuitement le générateur d'images GPT Image AI en ligne",
                howToIntro: "Inscrivez-vous pour recevoir des crédits gratuits et utilisez le générateur d'images GPT Image AI en ligne sur Miral.",
                howToSteps: [
                    { title: "Entrez une invite détaillée", desc: "Décrivez le sujet, le décor, la composition, l'éclairage, le style, les matériaux et tout texte requis." },
                    { title: "Choisissez la taille et la qualité", desc: "Choisissez une taille carrée, paysage ou portrait et définissez la qualité GPT-Image-1.5 en fonction de vos besoins." },
                    { title: "Générer et réviser", desc: "Démarrez la génération, examinez et téléchargez l'image, ou ajustez l'invite et créez une autre version." }
                ],
                howToCta: "Utilisez gratuitement le générateur d'images GPT Image AI",
                faqTitle: "Foire aux questions sur l'image GPT",
                faqs: [
                    { q: "Qu'est-ce que le générateur d'images GPT Image AI ?", a: "GPT Image est la famille de modèles texte-image à usage général d'OpenAI. Sur Miral, le générateur d'images GPT Image AI transforme les invites écrites en images de haute qualité pour la conception, le marketing, les concepts de produits, les affiches et le contenu social." },
                    { q: "Puis-je utiliser le générateur d'images GPT Image AI gratuitement ?", a: "Oui. Inscrivez-vous pour recevoir des crédits gratuits et commencez immédiatement à créer des images de haute qualité avec le générateur d'images GPT Image AI. La génération d'images utilise les crédits correspondants." },
                    { q: "Comment utiliser le générateur d'images GPT Image AI en ligne ?", a: "Entrez une invite détaillée et choisissez 1024×1024, 1536×1024 ou 1024×1536. Avec GPT-Image-1.5, vous pouvez également sélectionner la qualité automatique, faible, moyenne ou élevée avant de cliquer sur Générer." },
                    { q: "Quelle est la différence entre GPT-Image-1.5 et GPT-Image-1 ?", a: "Les deux versions prennent en charge les trois mêmes tailles d'image pratiques. GPT-Image-1.5 sur Miral fournit également un contrôle de qualité automatique, faible, moyen et élevé, tandis que GPT-Image-1 dispose d'un ensemble de paramètres plus simple." },
                    { q: "Quelles tailles d'image sont prises en charge par GPT Image ?", a: "Sur Miral, GPT-Image-1 et GPT-Image-1.5 prennent en charge les images carrées de 1 024 × 1 024, paysage de 1 536 × 1 024 et portrait de 1 024 × 1 536." },
                    { q: "Quelle qualité d’image GPT dois-je choisir ?", a: "Choisissez faible ou moyen lorsque les invites de test sont rapides, élevé pour les images de produits finaux, les affiches ou les ressources marketing, et automatique en cas de doute. Les options de qualité s'appliquent à GPT-Image-1.5." },
                    { q: "Comment corriger les résultats d'image GPT qui ne correspondent pas à mon invite ?", a: "Décrivez plus explicitement le sujet, le décor, la composition, l'éclairage, l'appareil photo, les matériaux, le style et tout texte requis. Utilisez les exemples d'images GPT sur cette page comme point de départ et adaptez-les à votre projet." },
                    { q: "Ai-je besoin d’une expérience rapide en ingénierie pour utiliser GPT Image ?", a: "Non. Commencez par une simple invite en langage naturel, puis ajoutez la position du sujet, la composition, l'éclairage, les couleurs, les matériaux et les exigences en matière de texte si nécessaire. Des descriptions plus claires aident généralement le résultat à correspondre plus étroitement à votre intention créative." },
                    { q: "Quel outil puis-je utiliser pour créer des images de produits, des affiches et des concepts d'interface utilisateur pour le commerce électronique ?", a: "GPT Image peut créer des images de listes de commerce électronique, des maquettes de produits, des affiches, des concepts UI/UX, des mises en page de sites Web, des mises en page d'infographies, des couvertures de livres, des images de blog, des bannières de courrier électronique et des concepts de jeux. Vérifiez le texte, les données, les éléments de marque et les détails structurels avant l'utilisation finale." },
                    { q: "GPT Image vs Midjourney : que dois-je utiliser ?", a: "GPT Image convient parfaitement à un contrôle clair des invites, à des tailles d'image pratiques et à la génération directe du navigateur. Midjourney peut convenir aux utilisateurs qui préfèrent ses styles artistiques, son flux de travail d'images de référence et son processus créatif." }
                ],
                ctaTitle: "Utilisez l'image GPT gratuitement sur Miral !",
                ctaDesc: "Inscrivez-vous pour recevoir des crédits gratuits. Décrivez votre idée, choisissez une taille et une qualité, et utilisez le générateur d'images GPT Image AI pour créer des visuels de haute qualité."
            },
            qwenImage2Pro: {
                title: "Qwen Image 2.0 Pro Générateur d'images AI gratuit en ligne | Miral",
                description: "Créez des images IA en ligne avec Qwen Image 2.0 Pro. Utilisez des invites négatives, une amélioration rapide, des proportions flexibles et générez jusqu'à quatre images par exécution.",
                heroHeadline: "Générateur d'images IA Qwen Image 2.0 Pro",
                heroIntro: "Utilisez gratuitement le générateur d'images Qwen Image 2.0 Pro AI sur Miral AI. Inscrivez-vous pour recevoir des crédits gratuits et créer rapidement des images de haute qualité avec des invites négatives, une amélioration rapide et des proportions flexibles.",
                eyebrow: "Alibaba Tongyi Qwen · Qwen-Image-2.0-Pro",
                sectionKicker: "Qwen Image 2.0 Pro",
                ctaTag: "Qwen Image 2.0 Pro · Miral",
                badges: ["Texte en image", "Invite négative", "Amélioration rapide", "1-4 Images / Exécuter", "Rapports d'aspect flexibles"],
                previewLabel: "Qwen Image 2.0 Pro",
                previewMeta: ["1:1", "2048 × 2048", "Jusqu'à 1 à 4 images"],
                previewTitle: "D'une invite précise avec des exclusions à des visuels soignés",
                previewDesc: "Combinez des invites positives avec des invites négatives et une amélioration des invites pour générer plusieurs images ciblées en une seule fois.",
                keyFeaturesTitle: "Créez des visuels précis avec le générateur de texte en image Qwen Image 2.0 Pro",
                keyFeaturesIntro: "Explorez les principales fonctionnalités du générateur d'images Qwen Image 2.0 Pro AI pour un contrôle précis, des invites négatives, une amélioration des invites, une sortie par lots et des proportions flexibles.",
                mainFeaturesTitle: "Principales fonctionnalités de Qwen Image 2.0 Pro",
                promptLabel: "Invite positive",
                negativePromptLabel: "Invite négative",
                shortPromptLabel: "Invite courte",
                negativePromptFallback: "faible clarté, détails déformés, composition encombrée",
                features: [
                    { name: "Contrôle d'invite négatif", short: "Décrivez ce qu'il faut exclure pour obtenir des résultats plus précis et conformes à l'objectif.", desc: "Le générateur d'images Qwen Image 2.0 Pro AI prend en charge une invite négative dédiée, vous permettant ainsi d'indiquer au modèle ce qu'il doit éviter, comme une faible clarté, des mains déformées ou une composition encombrée. Cela vous donne un contrôle plus précis sur l'image finale et réduit le besoin de relancer à plusieurs reprises.", demo: { type: 'table', rows: [
                        { prompt: "Une photo de produit haut de gamme d'une bouteille de soin en verre sur pierre humide, lumière douce du matin, fond propre. (Négatif : fond encombré, faible résolution, reflets déformés.)", image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
                        { prompt: "Portrait d'une jeune femme dans la lumière d'automne, texture naturelle de la peau, faible profondeur de champ. (Négatif : peau trop lissée, aspect cireux, couleurs sursaturées.)", image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp') }
                    ] } },
                    { name: "Amélioration rapide", short: "Éventuellement, développez une courte invite avec des détails plus riches.", desc: "Activez l'amélioration des invites et Qwen Image 2.0 Pro enrichit automatiquement une brève invite avec des détails supplémentaires avant la génération. Cela aide les invites non expertes à produire des images plus complètes et plus vives sans réécriture manuelle.", demo: { type: 'table', rows: [
                        { prompt: "Un coin lecture confortable près d'une fenêtre pluvieuse.", image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp') },
                        { prompt: "Un bureau de lecture en bois à côté d'une fenêtre recouverte de pluie la nuit, une lampe de travail chaleureuse éclairant un livre ouvert et du thé fumant, un intérieur calme et confortable.", image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp') }
                    ] } },
                    { name: "Générez 1 à 4 images à la fois", short: "Produisez plusieurs variantes en une seule fois.", desc: "Qwen Image 2.0 Pro peut générer jusqu'à quatre images par demande, vous pouvez donc comparer côte à côte les variantes d'un concept, d'un angle ou d'un style et choisir la meilleure. Cela accélère l’exploration créative des visuels marketing et produits.", prompt: "Une lampe de table minimaliste en céramique sur une table d'appoint en noyer, un intérieur de soirée chaleureux, un mur crème, des ombres douces, une photographie de produits scandinaves.", image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
                    { name: "Rapports d'aspect flexibles", short: "Choisissez des formats paysage, portrait, carré ou personnalisés.", desc: "Choisissez parmi des formats d'image prêts à l'emploi tels que 2688 × 1536 paysage, 1536 × 2688 portrait, 2048 × 2048 carré et 2368 × 1728/1728 × 2368, ou entrez une taille personnalisée de 512 × 512 à 2048 × 2048. Cela rend le générateur de texte en image Qwen Image 2.0 Pro adapté aussi bien aux bannières, aux affiches, aux publications sociales et aux vignettes carrées.", prompt: "Un large paysage cinématographique d'une falaise côtière à l'heure d'or, des nuages spectaculaires, de fins détails rocheux, 2688 × 1536.", image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp') },
                    { name: "Détails raffinés et réalisme", short: "Rendre des textures, un éclairage et une profondeur réalistes.", desc: "Qwen Image 2.0 Pro produit des textures fines, un éclairage réaliste et une profondeur naturelle, ce qui en fait un choix idéal pour la photographie de produits, les portraits et les visuels éditoriaux où la crédibilité compte.", prompt: "Portrait éditorial en gros plan d'un céramiste âgé dans un atelier ensoleillé, texture naturelle de la peau, poussière d'argile sur les mains, lumière chaude de la fenêtre, faible profondeur de champ.", image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp') }
                ],
                showcaseKicker: "Exemples rapides",
                showcaseTitle: "Exemples d'invites Qwen Image 2.0 Pro pour de meilleures images IA",
                showcaseIntro: "Utilisez ces exemples d'invites Qwen Image 2.0 Pro comme point de départ. Associez chaque invite positive à une invite négative pour supprimer les éléments indésirables, puis envoyez-la directement au générateur.",
                useCasesKicker: "Conçu pour un vrai travail",
                useCasesTitle: "Cas d'utilisation populaires de Qwen Image 2.0 Pro",
                useCases: [
                    { name: "Qwen Image 2.0 Pro pour la photographie de produits", desc: "Créez des photos de produits nettes avec des arrière-plans contrôlés à l'aide d'invites négatives pour supprimer l'encombrement." },
                    { name: "Qwen Image 2.0 Pro pour le marketing", desc: "Générez des concepts de campagne, des publicités sociales et des bannières dans plusieurs formats." },
                    { name: "Qwen Image 2.0 Pro pour les affiches et la typographie", desc: "Produisez des mises en page d'affiches et des conceptions riches en texte avec des titres et des étiquettes clairs." },
                    { name: "Qwen Image 2.0 Pro pour les portraits", desc: "Générez des portraits détaillés avec une texture de peau naturelle à l'aide d'invites négatives pour éviter les artefacts." },
                    { name: "Qwen Image 2.0 Pro pour l'art conceptuel", desc: "Explorez les personnages, les environnements et les directions visuelles avec 1 à 4 variations par exécution." },
                    { name: "Qwen Image 2.0 Pro pour le commerce électronique", desc: "Produisez plusieurs variantes d'images pour les annonces et les annonces en une seule génération." }
                ],
                howToKicker: "Trois étapes simples",
                howToTitle: "Comment utiliser le générateur d'images Qwen Image 2.0 Pro AI en ligne",
                howToIntro: "Utilisez le générateur d'images Qwen Image 2.0 Pro AI en ligne sur Miral avec des invites positives, des invites négatives et des contrôles de sortie flexibles.",
                howToSteps: [
                    { title: "Entrez votre invite principale", desc: "Décrivez le sujet, la scène, la composition, l'éclairage, le style et les détails visuels souhaités." },
                    { title: "Configurer les contrôles de génération", desc: "Ajoutez une invite négative si nécessaire, activez l'amélioration de l'invite, choisissez la taille et sélectionnez une à quatre images." },
                    { title: "Générer et comparer", desc: "Démarrez la génération, comparez les variantes renvoyées et téléchargez l'image qui correspond le mieux à votre intention." }
                ],
                howToCta: "Essayez le générateur d'images Qwen Image 2.0 Pro AI",
                faqTitle: "Questions fréquemment posées sur Qwen Image 2.0 Pro",
                faqs: [
                    { q: "Qu'est-ce que le générateur d'images Qwen Image 2.0 Pro AI ?", a: "Qwen Image 2.0 Pro est le modèle texte-image Tongyi Qwen d'Alibaba. Le générateur d'images Qwen Image 2.0 Pro AI transforme les invites écrites en images détaillées de haute qualité et est disponible sur Miral pour l'art, le design, le marketing et la création visuelle de produits directement dans votre navigateur." },
                    { q: "Quel outil puis-je utiliser pour créer plusieurs variantes d'image de produit avec des invites négatives ?", a: "Qwen Image 2.0 Pro fournit une invite négative dédiée, une amélioration facultative de l'invite, 1 à 4 images par exécution et des formats d'image flexibles pour la photographie de produits, le marketing et les variations visuelles du commerce électronique." },
                    { q: "Puis-je utiliser gratuitement le générateur d’images Qwen Image 2.0 Pro AI ?", a: "Oui. Inscrivez-vous pour recevoir des crédits gratuits et commencez immédiatement à créer des images de haute qualité avec le générateur d'images Qwen Image 2.0 Pro AI. La génération d'images utilise les crédits correspondants." },
                    { q: "Comment utiliser le générateur d'images Qwen Image 2.0 Pro AI en ligne ?", a: "Entrez une invite de texte détaillée, ajoutez éventuellement une invite négative décrivant ce qu'il faut éviter, activez l'amélioration de l'invite si nécessaire, choisissez un rapport hauteur/largeur ou une taille personnalisée, définissez le nombre d'images à générer (1-4) et cliquez sur Générer. Qwen Image 2.0 Pro fonctionne bien pour les supports marketing, la photographie de produits, les portraits et la conception d'affiches." },
                    { q: "Comment corriger les éléments indésirables dans les résultats de Qwen Image 2.0 Pro ?", a: "Ajoutez une invite négative décrivant les éléments dont vous ne souhaitez pas, tels qu'une faible clarté, des mains déformées ou un arrière-plan encombré. Qwen Image 2.0 Pro l'utilise pour éloigner la génération de ces résultats." },
                    { q: "Combien d’images Qwen Image 2.0 Pro peut-il générer à la fois ?", a: "Qwen Image 2.0 Pro peut générer jusqu'à 4 images en une seule requête (n = 1 à 4), vous pouvez donc comparer les variations d'un concept, d'un angle ou d'un style et choisir la meilleure." },
                    { q: "Quelles tailles et quels formats d'image Qwen Image 2.0 Pro prend-il en charge ?", a: "Sur Miral, Qwen Image 2.0 Pro propose des ratios prêts à l'emploi tels que 2688×1536, 1536×2688, 2048×2048, 2368×1728 et 1728×2368, ainsi qu'une taille personnalisée de 512×512 jusqu'à 2048×2048. Cela couvre les sorties paysage, portrait et carré pour les bannières, les affiches, les publications sociales et les vignettes." },
                    { q: "Quels sont les meilleurs exemples d'invites Qwen Image 2.0 Pro ?", a: "Les invites efficaces de Qwen Image 2.0 Pro décrivent clairement le sujet, le décor, la composition, l'éclairage et le style, puis associent une invite positive à une invite négative pour supprimer les détails indésirables. Utilisez les exemples d'invites Qwen Image 2.0 Pro sur cette page comme point de départ et personnalisez-les pour votre projet." },
                    { q: "Qwen Image 2.0 Pro vs Midjourney : lequel dois-je utiliser ?", a: "Choisissez en fonction du flux de travail plutôt que d'un gagnant universel. Qwen Image 2.0 Pro convient parfaitement lorsque vous avez besoin d'invites négatives explicites, d'une amélioration des invites, de 1 à 4 images par exécution et de proportions flexibles dans un générateur basé sur un navigateur sur Miral. Midjourney peut convenir aux créateurs qui préfèrent son flux de travail artistique distinctif et ses outils communautaires." }
                ],
                ctaTitle: "Essayez Qwen Image 2.0 Pro gratuitement sur Miral !",
                ctaDesc: "Entrez votre idée ci-dessus et utilisez le générateur d'images Qwen Image 2.0 Pro AI avec des commandes optionnelles pour créer des variations d'image précises."
            },
            stableDiffusion: {
                title: "Stable Diffusion 3.5 Générateur d'images AI gratuit en ligne | Miral",
                description: "Générez des images IA en ligne avec Stable Diffusion 3.5. Utilisez des invites négatives, des proportions prédéfinies et des tailles personnalisées de 512 à 2 048 pixels sur Miral.",
                heroHeadline: "Générateur d'images IA à diffusion stable 3.5",
                heroIntro: "Utilisez gratuitement le générateur d'images Stable Diffusion 3.5 AI sur Miral AI. Inscrivez-vous pour recevoir des crédits gratuits et créer rapidement des images de haute qualité avec des invites détaillées, des invites négatives et des tailles flexibles.",
                eyebrow: "Stabilité IA · Diffusion stable 3.5",
                sectionKicker: "Diffusion stable 3,5",
                ctaTag: "Diffusion stable 3,5 · Miral",
                badges: ["Texte en image", "Invite négative", "Rapports d'aspect flexibles", "Taille personnalisée"],
                previewLabel: "Diffusion stable 3,5",
                previewMeta: ["1:1", "512 – 2048", "Multiples de 64"],
                previewTitle: "D'une invite détaillée à une image contrôlée et soignée",
                previewDesc: "Associez des invites positives à des invites négatives et choisissez le bon rapport hauteur/largeur pour orienter Stable Diffusion 3.5 vers des visuels propres et ciblés.",
                keyFeaturesTitle: "Créez des visuels contrôlés avec le générateur de texte en image Stable Diffusion 3.5",
                keyFeaturesIntro: "Explorez les principales fonctionnalités du générateur d'images IA de Stable Diffusion 3.5 pour les invites négatives, les proportions flexibles, les tailles personnalisées et la compréhension détaillée des invites.",
                exploreTitle: "Explorez davantage de modèles d'images IA",
                mainFeaturesTitle: "Principales fonctionnalités de Diffusion Stable 3.5",
                generatedImageLabel: "Image générée",
                versionLabel: "Contrôle",
                featureLabel: "Ce que ça change",
                useCaseLabel: "Idéal pour",
                variantsTitle: "Contrôles de sortie de diffusion stable 3.5",
                variantsIntro: "Combinez le modèle Stable Diffusion 3.5 avec des proportions prédéfinies ou des dimensions personnalisées exactes en fonction de la disposition finale dont vous avez besoin.",
                variants: [
                    { name: "Diffusion stable 3,5", desc: "Génération texte-image détaillée avec contrôle d'invite positif et négatif.", bestFor: "Visuels de produits, portraits, art conceptuel et images marketing." },
                    { name: "Rapports d'aspect prédéfinis", desc: "Dimensions de sortie paysage, portrait et carré prêtes à l'emploi.", bestFor: "Publications sociales, bannières, affiches et miniatures." },
                    { name: "Taille d'image personnalisée", desc: "Largeur et hauteur exactes de 512 à 2048 en multiples de 64.", bestFor: "Emplacements de mise en page et projets nécessitant des dimensions de pixels précises." }
                ],
                controlsTitle: "Choisissez les bons contrôles d'invite et la bonne taille d'image",
                controlsIntro: "Utilisez une invite négative pour réduire les détails indésirables, puis sélectionnez un rapport prédéfini ou entrez des dimensions personnalisées pour le canal souhaité.",
                galleryTitle: "Exemples d'images de diffusion plus stable 3.5",
                discussionTitle: "Questions courantes sur la diffusion stable 3.5",
                communityTitle: "Méthodes populaires de création avec Stable Diffusion 3.5",
                tutorialPrompt: "Photographie éditoriale d'un haut-parleur sculptural en céramique sur pierre pâle, lumière douce du matin, texture réaliste, composition équilibrée, ombres subtiles, arrière-plan épuré.",
                qualityBenefits: [
                    "Utilisez des invites négatives pour réduire l’encombrement, les détails mal formés et les styles visuels indésirables.",
                    "Suivez des descriptions superposées du sujet, de la composition, de l'éclairage, des matériaux et de l'ambiance.",
                    "Créez des images paysage, portrait et carrées avec des préréglages ou des dimensions personnalisées précises."
                ],
                features: [
                    { name: "Contrôle d'invite négatif", short: "Décrivez ce qu'il faut exclure pour obtenir des résultats plus précis et conformes à l'objectif.", desc: "Le générateur d'images IA Stable Diffusion 3.5 prend en charge une invite négative dédiée, vous permettant ainsi d'indiquer au modèle ce qu'il doit éviter, comme une faible clarté, des mains déformées ou un arrière-plan encombré. Cela vous donne un contrôle plus précis sur l'image finale et réduit le besoin de relancer à plusieurs reprises.", demo: { type: 'table', rows: [
                        { prompt: "Une photo de produit haut de gamme d'un vase en céramique noir mat sur un socle en marbre, une lumière douce de studio, un fond épuré. (Négatif : fond encombré, faible résolution, reflets déformés.)", image: require('@/assets/images/stableDiffusion/1783501013638.webp') },
                        { prompt: "Portrait d'un jeune homme dans une lumière douce de fenêtre, une texture naturelle de la peau, une faible profondeur de champ. (Négatif : peau trop lissée, aspect cireux, couleurs sursaturées.)", image: require('@/assets/images/stableDiffusion/1783501332038.webp') }
                    ] } },
                    { name: "Rapports d'aspect flexibles", short: "Choisissez un format paysage, portrait, carré ou personnalisé.", desc: "Choisissez parmi des formats d'image prêts à l'emploi tels que 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 et 1536×1536, ou entrez une taille personnalisée de 512×512 à 2048×2048. Cela rend le générateur de texte en image Stable Diffusion 3.5 adapté aussi bien aux bannières, aux affiches, aux publications sociales et aux vignettes carrées.", prompt: "Un large paysage cinématographique d'une falaise côtière à l'heure d'or, des nuages spectaculaires, de fins détails rocheux, 1536 × 896.", image: require('@/assets/images/stableDiffusion/1783501396803.webp') },
                    { name: "Tailles d'image personnalisées", short: "Définissez les dimensions exactes des pixels pour une sortie précise.", desc: "Lorsqu'un préréglage ne convient pas, passez à une taille personnalisée et entrez n'importe quelle largeur et hauteur de 512 à 2048 par multiples de 64. Cela vous permet de faire correspondre une mise en page, un emplacement de bannière ou un aspect d'impression spécifique sans recadrage manuel.", prompt: "Un fond d'affiche minimaliste avec une composition géométrique centrée, un dégradé de bleu profond, un grain subtil, 1280×1280.", image: require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
                    { name: "Compréhension détaillée et rapide", short: "Suit des descriptions en couches du sujet, de la lumière et du style.", desc: "Stable Diffusion 3.5 lit les instructions de texte en couches et restitue le sujet, le décor, l'éclairage et l'ambiance que vous décrivez. Combinez une invite positive claire avec une invite négative pour rapprocher le résultat de votre intention en moins d’essais.", demo: { type: 'table', rows: [
                        { prompt: "Photo de produit éditorial d'une montre-bracelet à côté de linge plié et d'une tasse en céramique, composition triangulaire équilibrée, douce lumière du matin.", image: require('@/assets/images/stableDiffusion/1783501741652.webp') },
                        { prompt: "Un coin lecture confortable près d’une fenêtre pluvieuse, une lampe chaude, des livres empilés, une couverture texturée, une ambiance cinématographique.", image: require('@/assets/images/stableDiffusion/1783501817217.webp') }
                    ] } },
                    { name: "Détails raffinés et réalisme", short: "Rendre un éclairage, des matériaux et une profondeur crédibles.", desc: "Stable Diffusion 3.5 produit des textures fines, un éclairage réaliste et une profondeur naturelle, ce qui fait du générateur d'images IA Stable Diffusion 3.5 un choix idéal pour la photographie de produits, les portraits, l'art conceptuel et les visuels éditoriaux où la crédibilité compte.", prompt: "Portrait éditorial en gros plan d'un céramiste âgé dans un atelier ensoleillé, texture naturelle de la peau, poussière d'argile sur les mains, lumière chaude de la fenêtre, faible profondeur de champ.", image: require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
                ],
                showcaseKicker: "Exemples rapides",
                showcaseTitle: "Exemples d'invites Stable Diffusion 3.5 pour de meilleures images d'IA",
                showcaseIntro: "Utilisez ces exemples d’invites Stable Diffusion 3.5 comme point de départ. Décrivez clairement le sujet, la composition, l'éclairage et le style, associez chaque invite à une invite négative, puis envoyez-la directement au générateur.",
                useCasesKicker: "Conçu pour un vrai travail",
                useCasesTitle: "Cas d’utilisation populaires de Diffusion stable 3.5",
                useCases: [
                    { name: "Diffusion stable 3.5 pour la photographie de produits", desc: "Créez des photos de produits nettes avec des arrière-plans contrôlés à l'aide d'invites négatives pour supprimer l'encombrement." },
                    { name: "Diffusion stable 3.5 pour le marketing", desc: "Générez des concepts de campagne, des publicités sociales et des bannières dans plusieurs formats." },
                    { name: "Diffusion stable 3.5 pour les affiches et les mises en page", desc: "Produisez des arrière-plans d'affiches et des visuels prêts à être mis en page dans des dimensions en pixels personnalisées." },
                    { name: "Diffusion stable 3.5 pour les portraits", desc: "Générez des portraits détaillés avec une texture de peau naturelle, en utilisant des invites négatives pour éviter les artefacts." },
                    { name: "Diffusion stable 3.5 pour l'art conceptuel", desc: "Explorez les personnages, les environnements et les directions visuelles avec des invites superposées." },
                    { name: "Diffusion stable 3.5 pour le contenu social", desc: "Créez des images carrées, portraits et paysages dimensionnées pour différentes plateformes sociales." }
                ],
                howToKicker: "Trois étapes simples",
                howToTitle: "Comment utiliser le générateur d'images AI Stable Diffusion 3.5 en ligne",
                howToIntro: "Utilisez le générateur d'images AI Stable Diffusion 3.5 en ligne sur Miral avec une invite claire, une invite négative et le rapport hauteur/largeur dont votre projet a besoin.",
                howToSteps: [
                    { title: "Entrez votre invite principale", desc: "Décrivez le sujet, la scène, la composition, l'éclairage, le style et les détails visuels souhaités." },
                    { title: "Configurer les contrôles de génération", desc: "Ajoutez une invite négative si nécessaire, puis choisissez un rapport hauteur/largeur prêt à l'emploi ou entrez une taille personnalisée." },
                    { title: "Générer et réviser", desc: "Démarrez la génération, examinez le résultat et téléchargez l'image ou ajustez votre invite pour une autre passe." }
                ],
                howToCta: "Essayez le générateur d'images AI Stable Diffusion 3.5",
                faqTitle: "Foire aux questions sur la diffusion stable 3.5",
                faqs: [
                    { q: "Qu'est-ce que le générateur d'images AI Stable Diffusion 3.5 ?", a: "Stable Diffusion 3.5 est un modèle texte-image de Stability AI. Le générateur d'images Stable Diffusion 3.5 AI transforme les invites écrites en images détaillées et est disponible sur Miral pour l'art, le design, le marketing et la création visuelle de produits directement dans votre navigateur." },
                    { q: "Quel outil puis-je utiliser pour créer des images de taille personnalisée avec des invites négatives ?", a: "Stable Diffusion 3.5 propose une invite négative dédiée, des formats d'image prêts à l'emploi et des tailles personnalisées de 512 à 2048 pour la photographie de produits, les visuels marketing, les portraits et l'art conceptuel." },
                    { q: "Puis-je utiliser gratuitement le générateur d’images AI Stable Diffusion 3.5 ?", a: "Oui. Inscrivez-vous pour recevoir des crédits gratuits et commencez immédiatement à créer des images de haute qualité avec le générateur d'images Stable Diffusion 3.5 AI. La génération d'images utilise les crédits correspondants." },
                    { q: "Comment utiliser le générateur d'images AI Stable Diffusion 3.5 en ligne ?", a: "Entrez une invite de texte détaillée, ajoutez éventuellement une invite négative décrivant ce qu'il faut éviter, choisissez un rapport hauteur/largeur prêt à l'emploi ou entrez une taille personnalisée, puis cliquez sur Générer. Stable Diffusion 3.5 fonctionne bien pour les supports marketing, les photographies de produits, les portraits et les mises en page d'affiches." },
                    { q: "Comment corriger les détails indésirables ou déformés dans les images Stable Diffusion 3.5 ?", a: "Ajoutez une invite négative décrivant les éléments dont vous ne souhaitez pas, tels qu'une faible clarté, des mains déformées ou un arrière-plan encombré. Stable Diffusion 3.5 l'utilise pour éloigner la génération de ces résultats." },
                    { q: "Quelles tailles et quels formats d’image Stable Diffusion 3.5 prend-il en charge ?", a: "Sur Miral, Stable Diffusion 3.5 propose des ratios prêts à l'emploi tels que 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 et 1536×1536, ainsi qu'une taille personnalisée de 512 × 512 jusqu'à 2 048 × 2 048 en multiples de 64. Cela couvre les sorties paysage, portrait et carré pour les bannières, les affiches, les publications sociales et les vignettes." },
                    { q: "Quels sont les meilleurs exemples d’invites Stable Diffusion 3.5 ?", a: "Les invites Effective Stable Diffusion 3.5 décrivent clairement le sujet, le décor, la composition, l'éclairage et le style, puis associent une invite positive à une invite négative pour supprimer les détails indésirables. Utilisez les exemples d'invites Stable Diffusion 3.5 sur cette page comme point de départ et personnalisez-les pour votre projet." },
                    { q: "Stable Diffusion 3.5 vs Midjourney : lequel dois-je utiliser ?", a: "Choisissez en fonction du flux de travail plutôt que d'un gagnant universel. Stable Diffusion 3.5 convient parfaitement lorsque vous avez besoin d'invites négatives explicites, de formats d'image prêts à l'emploi et de tailles de pixels personnalisées dans un générateur basé sur un navigateur sur Miral. Midjourney peut convenir aux créateurs qui préfèrent son flux de travail artistique distinctif et ses outils communautaires." }
                ],
                ctaTitle: "Essayez Stable Diffusion 3.5 gratuitement sur Miral !",
                ctaDesc: "Entrez votre idée ci-dessus et utilisez le générateur d'images AI Stable Diffusion 3.5 avec des invites négatives et des tailles flexibles pour créer des visuels contrôlés."
            },
            zImageTurbo: {
                title: "Z Image Turbo AI Générateur d'images gratuit en ligne | Miral",
                description: "Créez des images IA de haute qualité en ligne avec Z Image Turbo. Étendez les invites, choisissez des proportions flexibles, définissez des dimensions personnalisées et contrôlez les graines sur Miral.",
                heroHeadline: "Générateur d'images Z Image Turbo AI",
                heroIntro: "Utilisez gratuitement le générateur d'images Z Image Turbo AI sur Miral AI. Inscrivez-vous pour recevoir des crédits gratuits et créer rapidement des images de haute qualité avec une extension rapide, des formats d'image flexibles et un contrôle des semences.",
                eyebrow: "Z-Image Turbo",
                sectionKicker: "Z-Image Turbo",
                ctaTag: "Z Image Turbo · Miral",
                badges: ["Texte en image", "Extension d'invite", "Rapports d'aspect flexibles", "Taille personnalisée", "Contrôle des semences"],
                previewLabel: "Z-Image Turbo",
                previewMeta: ["1:1", "512 – 2048", "Contrôle des semences"],
                previewTitle: "D'une courte invite à un visuel soigné et haute résolution",
                previewDesc: "Laissez l’extension d’invite enrichir une brève idée, choisissez le bon rapport hauteur/largeur et réutilisez une graine pour conserver un style cohérent entre les images.",
                keyFeaturesTitle: "Créez des visuels soignés avec le générateur de texte en image Z Image Turbo",
                keyFeaturesIntro: "Explorez les principales fonctionnalités du générateur d'images Z Image Turbo AI pour une extension rapide, des formats d'image flexibles, des tailles personnalisées et une cohérence basée sur les graines.",
                exploreTitle: "Explorez davantage de modèles d'images IA",
                mainFeaturesTitle: "Principales fonctionnalités de Z Image Turbo",
                generatedImageLabel: "Image générée",
                versionLabel: "Contrôle",
                featureLabel: "Ce que ça change",
                useCaseLabel: "Idéal pour",
                variantsTitle: "Commandes de création Z Image Turbo",
                variantsIntro: "Combinez une extension rapide, des dimensions flexibles et un contrôle de départ en fonction du niveau de détail et de cohérence visuelle dont votre projet a besoin.",
                variants: [
                    { name: "Z-Image Turbo", desc: "Génération rapide de texte en image avec une sortie détaillée haute résolution.", bestFor: "Visuels de produits, portraits, art conceptuel et images marketing." },
                    { name: "Extension d'invite", desc: "Enrichit automatiquement les invites courtes avec des détails visuels supplémentaires.", bestFor: "Transformer des idées rapides en instructions de génération plus complètes." },
                    { name: "Contrôle des semences", desc: "Réutilise la même graine de départ pendant que vous affinez d'autres paramètres.", bestFor: "Garder un style coordonné à travers les variations d’image ou les campagnes." }
                ],
                controlsTitle: "Choisissez les bons paramètres d'invite, de taille et de graine",
                controlsIntro: "Activez l'extension d'invite lorsqu'une idée nécessite plus de détails, choisissez les dimensions de sortie prévues et réutilisez une graine lorsque la cohérence visuelle est importante.",
                galleryTitle: "Plus d’exemples d’images Turbo Z Image",
                discussionTitle: "Questions courantes sur Z Image Turbo",
                communityTitle: "Méthodes populaires de création avec Z Image Turbo",
                tutorialPrompt: "Un scooter électrique compact exposé dans un studio d'architecture lumineux, sol en béton pâle, lucarne douce, photographie de produits raffinée, composition équilibrée, matériaux réalistes.",
                qualityBenefits: [
                    "Développez des idées courtes en invites plus riches sans réécrire manuellement chaque détail visuel.",
                    "Choisissez des dimensions paysage, portrait, carré ou personnalisées précises pour le canal final.",
                    "Réutilisez une graine pour que l'éclairage, la palette et la composition restent plus cohérents au fil des itérations."
                ],
                features: [
                    { name: "Extension d'invite", short: "Éventuellement, développez une courte invite avec des détails plus riches.", desc: "Activez l'extension d'invite et Z Image Turbo enrichit automatiquement une brève invite avec des détails supplémentaires avant la génération. Cela permet aux invites courtes ou simples de produire des images plus complètes et plus vives sans réécriture manuelle.", demo: { type: 'table', rows: [
                        { prompt: "Une serre en verre remplie de plantes tropicales à la surface de Mars.", image: require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
                        { prompt: "Une petite boulangerie artisanale construite dans un wagon de train d'époque.", image: require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
                    ] } },
                    { name: "Rapports d'aspect flexibles", short: "Choisissez un format paysage, portrait, carré ou personnalisé.", desc: "Choisissez parmi des formats d'image prêts à l'emploi tels que 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 et 1536×1536, ou entrez une taille personnalisée de 512×512 à 2048×2048. Cela rend le générateur de texte en image Z Image Turbo adapté aussi bien aux bannières, aux affiches, aux publications sociales et aux vignettes carrées.", prompt: "Une vue aérienne ultra-large d'un marché nocturne de Tokyo sous la pluie, des lanternes en papier lumineuses, des stands de nourriture bondés, des rues réfléchissantes, une atmosphère cinématographique, 1536×864.", image: require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
                    { name: "Tailles d'image personnalisées", short: "Définissez les dimensions exactes des pixels pour une sortie précise.", desc: "Lorsqu'un préréglage ne convient pas, passez à une taille personnalisée et entrez n'importe quelle largeur et hauteur entre 512 et 2048. Cela vous permet de faire correspondre une mise en page, un emplacement de bannière ou un aspect d'impression spécifique sans recadrage manuel.", prompt: "Une affiche d'exposition botanique verticale, typographie orange surdimensionnée, feuilles tropicales rares, texture de papier blanc cassé chaleureuse, grille éditoriale précise, 1152×1728.", image: require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
                    { name: "Contrôle des semences pour la cohérence", short: "Réutilisez une graine pour conserver un style stable sur les images.", desc: "Définissez une valeur de départ fixe (0 à 2147483647) et le générateur d'images Z Image Turbo AI s'appuiera sur le même point de départ d'une exécution à l'autre, ce qui facilitera le maintien d'une apparence cohérente pendant que vous affinez l'invite. Laissez la graine à 0 pour obtenir un résultat frais et aléatoire à chaque fois.", prompt: "Une campagne de soins de la peau coordonnée comprenant trois flacons en verre dépoli sur une pierre vert pâle, une lumière douce et diffuse, des accents d'eucalyptus — réutilisez la même graine pour préserver l'éclairage, la palette et la composition de toute la série de produits.", image: require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
                    { name: "Détails raffinés et réalisme", short: "Rendre un éclairage, des matériaux et une profondeur crédibles.", desc: "Z Image Turbo produit des textures fines, un éclairage réaliste et une profondeur naturelle, ce qui en fait un choix idéal pour la photographie de produits, les portraits, l'art conceptuel et les visuels éditoriaux où la crédibilité compte.", prompt: "Gros plan documentaire d'un luthier sculptant un pont en érable dans un atelier calme, copeaux de bois fins, outils à main usés, texture naturelle de la peau, lumière douce de la fenêtre nord, faible profondeur de champ.", image: require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
                ],
                showcaseKicker: "Exemples rapides",
                showcaseTitle: "Exemples d'invites Z Image Turbo pour de meilleures images IA",
                showcaseIntro: "Utilisez ces exemples d’invites Z Image Turbo comme point de départ. Décrivez clairement le sujet, la composition, l'éclairage et le style, activez éventuellement l'extension de l'invite, puis envoyez-la directement au générateur.",
                useCasesKicker: "Conçu pour un vrai travail",
                useCasesTitle: "Cas d'utilisation populaires de Z Image Turbo",
                useCases: [
                    { name: "Z Image Turbo pour la photographie de produits", desc: "Créez des photos de produits épurées avec des arrière-plans contrôlés et une graine fixe pour un look cohérent." },
                    { name: "Z Image Turbo pour le marketing", desc: "Générez des concepts de campagne, des publicités sociales et des bannières dans plusieurs formats." },
                    { name: "Z Image Turbo pour les affiches et les mises en page", desc: "Produisez des arrière-plans d'affiches et des visuels prêts à être mis en page dans des dimensions en pixels personnalisées." },
                    { name: "Z Image Turbo pour les portraits", desc: "Générez des portraits détaillés avec une texture de peau naturelle et un éclairage crédible." },
                    { name: "Z Image Turbo pour l’art conceptuel", desc: "Explorez les personnages, les environnements et les directions visuelles avec des invites superposées." },
                    { name: "Z Image Turbo pour le contenu social", desc: "Créez des images carrées, portraits et paysages dimensionnées pour différentes plateformes sociales." }
                ],
                howToKicker: "Trois étapes simples",
                howToTitle: "Comment utiliser le générateur d'images Z Image Turbo AI en ligne",
                howToIntro: "Utilisez le générateur d'images Z Image Turbo AI en ligne sur Miral avec une invite claire, une extension d'invite facultative et le rapport hauteur/largeur dont votre projet a besoin.",
                howToSteps: [
                    { title: "Entrez votre invite principale", desc: "Décrivez le sujet, la scène, la composition, l'éclairage, le style et les détails visuels souhaités." },
                    { title: "Configurer les contrôles de génération", desc: "Activez éventuellement l'extension d'invite, choisissez un rapport hauteur/largeur prêt à l'emploi ou entrez une taille personnalisée et définissez une valeur de départ si vous souhaitez une cohérence." },
                    { title: "Générer et réviser", desc: "Démarrez la génération, examinez le résultat et téléchargez l'image ou ajustez votre invite pour une autre passe." }
                ],
                howToCta: "Essayez le générateur d'images Z Image Turbo AI",
                faqTitle: "Foire aux questions sur Z Image Turbo",
                faqs: [
                    { q: "Qu'est-ce que le générateur d'images Z Image Turbo AI ?", a: "Z Image Turbo est un modèle texte-image pour la génération d'images haute résolution. Le générateur d'images Z Image Turbo AI transforme les invites écrites en images détaillées et est disponible sur Miral pour l'art, le design, le marketing et la création visuelle de produits directement dans votre navigateur." },
                    { q: "Quel outil puis-je utiliser pour créer une série cohérente d’images de produits ?", a: "Z Image Turbo combine une extension rapide, des tailles d'image flexibles et un contrôle des semences pour aider à créer une série cohérente de photographies de produits ou de visuels marketing." },
                    { q: "Puis-je utiliser gratuitement le générateur d’images Z Image Turbo AI ?", a: "Oui. Inscrivez-vous pour recevoir des crédits gratuits et commencez immédiatement à créer des images de haute qualité avec le générateur d'images Z Image Turbo AI. La génération d'images utilise les crédits correspondants." },
                    { q: "Comment utiliser le générateur d'images Z Image Turbo AI en ligne ?", a: "Entrez une invite de texte détaillée, activez éventuellement l'extension d'invite, choisissez un rapport hauteur/largeur prêt à l'emploi ou entrez une taille personnalisée, définissez une graine si vous souhaitez un aspect cohérent, puis cliquez sur Générer. Z Image Turbo fonctionne bien pour les supports marketing, les photographies de produits, les portraits et les mises en page d'affiches." },
                    { q: "Qu'est-ce que l'extension d'invite dans Z Image Turbo ?", a: "L'extension d'invite est un commutateur optionnel qui permet à Z Image Turbo d'enrichir automatiquement une invite courte ou simple avec des détails supplémentaires avant la génération. Cela aide les invites non expertes à produire des images plus complètes et plus vives sans réécriture manuelle." },
                    { q: "Comment corriger les résultats incohérents dans Z Image Turbo ?", a: "Réutilisez la même graine tout en affinant d’autres paramètres pour aider à maintenir un style cohérent entre les images. Laissez la graine à 0 uniquement lorsque vous souhaitez un résultat frais et aléatoire à chaque fois." },
                    { q: "Quelles tailles et quels formats d'image Z Image Turbo prend-il en charge ?", a: "Sur Miral, Z Image Turbo propose des ratios prêts à l'emploi tels que 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 et 1536×1536, ainsi qu'une taille personnalisée de 512×512 jusqu'à 2048×2048. Cela couvre les sorties paysage, portrait et carré pour les bannières, les affiches, les publications sociales et les vignettes." },
                    { q: "Quels sont les meilleurs exemples d'invites Z Image Turbo ?", a: "Les invites Z Image Turbo efficaces décrivent clairement le sujet, le décor, la composition, l'éclairage et le style. Pour des idées courtes, activez l’extension d’invite afin que le modèle puisse enrichir automatiquement l’invite. Utilisez les exemples d'invites Z Image Turbo sur cette page comme point de départ et personnalisez-les pour votre projet." }
                ],
                ctaTitle: "Essayez Z Image Turbo gratuitement sur Miral !",
                ctaDesc: "Entrez votre idée ci-dessus et utilisez le générateur d'images Z Image Turbo AI avec une extension rapide, des tailles flexibles et un contrôle de départ pour créer des visuels soignés."
            },
            midjourney: {
                title: "Générateur d'images AI Midjourney gratuit en ligne | Miral",
                description: "Créez de l'art IA en ligne avec Midjourney sur Miral AI. Choisissez des styles réalistes ou animés, guidez les résultats avec des images de référence et transformez les invites textuelles en visuels éclatants.",
                heroHeadline: "Générateur d'images IA à mi-parcours",
                heroIntro: "Utilisez gratuitement le générateur d'images Midjourney AI sur Miral AI. Inscrivez-vous pour recevoir des crédits gratuits et créer instantanément des images de haute qualité avec des styles Réaliste ou Anime et des conseils d'image de référence en option.",
                eyebrow: "À mi-parcours",
                sectionKicker: "À mi-parcours",
                ctaTag: "À mi-parcours · Miral",
                badges: ["Texte en image", "Styles réalistes et animés", "Guide d’image de référence", "Direction Artistique"],
                previewLabel: "À mi-parcours",
                previewMeta: ["Réaliste", "Anime", "Jusqu'à 5 références"],
                previewTitle: "D'une invite vivante à une image cinématographique dirigée par l'art",
                previewDesc: "Choisissez un style, décrivez l'ambiance et l'éclairage, et laissez Midjourney façonner l'aspect artistique de votre concept, affiche ou personnage.",
                keyFeaturesTitle: "Créez des visuels dirigés par l'art avec le générateur de texte en image Midjourney",
                keyFeaturesIntro: "Explorez les principales fonctionnalités du générateur d'images Midjourney AI pour le changement de style, le guidage des images de référence et une direction artistique riche.",
                features: [
                    { name: "Styles réalistes et animés", short: "Changez de style visuel en un seul clic.", desc: "Le générateur d'images Midjourney AI sur Miral expose deux styles prêts à l'emploi : Réaliste et Anime. Choisissez Réaliste pour les détails photographiques, la lumière naturelle et les textures réalistes, ou Anime pour des lignes stylisées, des couleurs vives et une sensation dessinée à la main. Le style est choisi sur le panneau, afin que votre invite puisse se concentrer sur la scène elle-même.", demo: { type: 'table', rows: [
                        { prompt: "Un voyageur solitaire debout au bord d'une crête de montagne brumeuse au lever du soleil, lumière volumétrique, plan large cinématographique, tissu fin et détails rocheux.", image: require('@/assets/images/midjourney/1783505533006329.webp') },
                        { prompt: "Une jeune épéiste déterminée sur un toit au crépuscule, des cheveux flottants, des lanternes lumineuses, un travail de ligne d'anime expressif, un ombrage de cellophane vibrant.", image: require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp') }
                    ] } },
                    { name: "Guide d’image de référence", short: "Téléchargez jusqu'à cinq images pour orienter le look.", desc: "Guidez le générateur d'images Midjourney AI avec jusqu'à cinq images de référence (PNG, JPG, JPEG ou WebP). Utilisez-les pour reprendre une palette de couleurs, l'apparence d'un personnage, la forme d'un produit ou une esthétique globale afin que le résultat reste plus proche d'une direction de référence plutôt que du texte seul.", prompt: "Une photo de produit haut de gamme d'un vase en céramique noir mat sur un socle en marbre, une lumière douce de studio, un arrière-plan épuré, correspondant à l'ambiance et à la palette des références téléchargées.", image: require('@/assets/images/midjourney/1783506116812275.webp') },
                    { name: "Éclairage et ambiance cinématographique", short: "Rendre une lumière, une atmosphère et une profondeur spectaculaires.", desc: "Midjourney est connu pour son éclairage et son atmosphère dirigés par l'art. Décrivez l'heure dorée, la lueur du néon, le brouillard, la lumière du bord ou la lueur des bougies, et le modèle se penche sur un look cinématographique qui convient aux affiches, aux illustrations clés et aux visuels conceptuels.", demo: { type: 'table', rows: [
                        { prompt: "Une allée de néons trempée de pluie la nuit, des flaques d'eau réfléchissantes, un doux bokeh provenant de panneaux lointains, une atmosphère cinématographique maussade, une silhouette unique avec un parapluie.", image: require('@/assets/images/midjourney/1783506281563151.webp') },
                        { prompt: "Portrait à l'heure d'or d'un musicien sur un toit, contre-jour chaleureux, lumière parasite, faible profondeur de champ, grain de film.", image: require('@/assets/images/midjourney/1783506420066100.webp') }
                    ] } },
                    { name: "Personnages et concepts artistiques", short: "Construisez des personnages et des mondes expressifs.", desc: "Le générateur de texte en image Midjourney convient parfaitement à la conception de personnages, aux scènes fantastiques et à l'art conceptuel. Décrivez la pose, la tenue, l'expression et le décor d'un personnage, choisissez un style et répétez jusqu'à ce que le look atterrisse.", prompt: "Un alchimiste errant vêtu d'une cape de voyage superposée, portant une lanterne en laiton et des fioles lumineuses, un ancien chemin forestier, une lumière tachetée et des détails de costume complexes.", image: require('@/assets/images/midjourney/1783506547640511.webp') },
                    { name: "Affiches et art éditorial", short: "Produisez des mises en page saisissantes et des visuels clés.", desc: "Des illustrations clés de la campagne aux illustrations éditoriales, Midjourney façonne des compositions audacieuses et une esthétique raffinée. Associez un sujet focal clair à une ambiance décrite et laissez le modèle fournir des visuels artistiques à des fins marketing et éditoriales.", prompt: "Un visuel clé de campagne audacieux représentant un colibri planant au-dessus d'une fleur tropicale lumineuse, des tons de bijoux saturés, un espace négatif épuré, un éclairage de studio à contraste élevé.", image: require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp') }
                ],
                showcaseKicker: "Exemples rapides",
                showcaseTitle: "Exemples d'invites à mi-parcours pour de meilleures images d'IA",
                showcaseIntro: "Utilisez ces exemples d’invites de mi-parcours comme point de départ. Décrivez le sujet, l'ambiance, l'éclairage et le style de la scène, puis choisissez Réaliste ou Anime sur le panneau et envoyez-le au générateur.",
                useCasesKicker: "Conçu pour un vrai travail",
                useCasesTitle: "Cas d'utilisation populaires à mi-parcours",
                useCases: [
                    { name: "À mi-parcours pour l’art conceptuel", desc: "Créez des personnages, des mondes fantastiques et des directions visuelles avec un éclairage et une ambiance dirigés par l'art." },
                    { name: "À mi-parcours pour les illustrations clés et les affiches", desc: "Créez des visuels clés de campagne, des affiches et des illustrations éditoriales audacieuses avec un aspect soigné." },
                    { name: "À mi-parcours pour les visuels de produits et de marques", desc: "Façonnez des concepts de produits haut de gamme et des images de marque, guidés par des images de référence pour plus de cohérence." },
                    { name: "À mi-parcours pour les portraits", desc: "Générez des portraits cinématographiques avec de la lumière naturelle, du grain de film ou des ombrages d'anime stylisés." },
                    { name: "À mi-parcours pour l’anime et l’illustration", desc: "Passez au style Anime pour un travail au trait expressif, des couleurs vives et des personnages dessinés à la main." },
                    { name: "À mi-parcours pour le contenu social", desc: "Produisez des visuels saisissants et partageables pour les flux, les miniatures et les publications sociales créatives." }
                ],
                howToKicker: "Trois étapes simples",
                howToTitle: "Comment utiliser le générateur d'images Midjourney AI en ligne",
                howToIntro: "Utilisez le générateur d'images Midjourney AI en ligne sur Miral avec une invite vive, un style choisi et des images de référence facultatives.",
                howToSteps: [
                    { title: "Décrivez votre scène", desc: "Écrivez une invite vivante couvrant le sujet, le décor, l’ambiance, l’éclairage et le look artistique souhaité." },
                    { title: "Choisissez le style et les références", desc: "Choisissez Réaliste ou Anime sur le panneau et téléchargez éventuellement jusqu'à cinq images de référence pour guider le look." },
                    { title: "Générer et affiner", desc: "Démarrez la génération, examinez le résultat et téléchargez l'image ou ajustez votre invite et vos références pour une autre passe." }
                ],
                howToCta: "Essayez le générateur d'images Midjourney AI",
                faqTitle: "Foire aux questions sur Midjourney",
                faqs: [
                    { q: "Qu'est-ce que le générateur d'images Midjourney AI ?", a: "Midjourney est un modèle de conversion texte-image largement utilisé, connu pour ses visuels cinématographiques dirigés par l'art. Sur Miral, le générateur d'images Midjourney AI transforme les invites écrites en images saisissantes pour les concepts artistiques, les visuels clés, les affiches et le travail éditorial directement dans votre navigateur." },
                    { q: "Quel outil puis-je utiliser pour créer un concept art cinématographique avec des images de référence ?", a: "Midjourney combine une direction artistique riche, un éclairage dramatique, des styles réalistes et animés et des conseils d'images de référence pour l'art conceptuel cinématographique, les visuels clés et les images de marque." },
                    { q: "Puis-je utiliser gratuitement le générateur d’images Midjourney AI ?", a: "Oui. Inscrivez-vous pour recevoir des crédits gratuits et commencez immédiatement à créer des images de haute qualité avec le générateur d'images Midjourney AI. La génération d'images utilise les crédits correspondants." },
                    { q: "Comment utiliser le générateur d'images Midjourney AI en ligne ?", a: "Entrez une invite de texte vif décrivant le sujet, l'ambiance, l'éclairage et le style, choisissez Réaliste ou Anime sur le panneau, téléchargez éventuellement jusqu'à cinq images de référence et cliquez sur Générer. Midjourney fonctionne bien pour l'art conceptuel, les visuels clés, les affiches, les portraits et les illustrations éditoriales." },
                    { q: "Quelle est la différence entre les styles Réaliste et Anime ?", a: "Réaliste penche vers les détails photographiques, la lumière naturelle et les textures réalistes, tandis que l'Anime privilégie les lignes stylisées, les couleurs vives et un look dessiné à la main. Vous choisissez le style sur le panneau afin que votre invite puisse se concentrer sur la scène elle-même." },
                    { q: "Comment réparer les images Midjourney qui ne correspondent pas à ma référence ?", a: "Téléchargez jusqu'à cinq images de référence claires (PNG, JPG, JPEG ou WebP) et décrivez la palette de couleurs, l'apparence des personnages, la forme du produit ou l'esthétique globale que le résultat doit suivre." },
                    { q: "Quels sont les meilleurs exemples d'invites de mi-parcours ?", a: "Les invites efficaces de Midjourney décrivent en détail le sujet, le décor, l'ambiance, l'éclairage et l'aspect artistique, puis associent cette invite au bon style sur le panneau. Utilisez les exemples d'invites Midjourney sur cette page comme point de départ et ajustez-les pour votre projet." },
                    { q: "Midjourney vs Stable Diffusion 3.5 : lequel dois-je utiliser ?", a: "Choisissez en fonction du flux de travail plutôt que d'un gagnant universel. Midjourney convient parfaitement aux concepts artistiques, à l'éclairage cinématographique et aux visuels guidés par référence avec des styles réalistes et animés prêts à l'emploi sur Miral. Stable Diffusion 3.5 peut convenir aux créateurs qui ont besoin d'invites négatives explicites et de proportions flexibles avec des tailles personnalisées." }
                ],
                ctaTitle: "Essayez Midjourney gratuitement sur Miral !",
                ctaDesc: "Entrez votre idée ci-dessus et utilisez le générateur d'images Midjourney AI avec des styles Réaliste ou Anime et des conseils d'image de référence pour créer des visuels dirigés par l'art."
            }
        }
  }
}
